import './TicketDetails.scss'
import { GoabAccordion, GoabBadge, GoabButton, GoabButtonGroup, GoabCallout, GoabCheckbox, GoabCircularProgress, GoabFormItem, GoabIcon, GoabIconButton, GoabModal, GoabRadioGroup, GoabRadioItem, GoabSpacer, GoabTable, type GoabFormItemProps } from '@abgov/react-components';
import { Fragment, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ApiService from '../../../sevices/ApiService';
import { pdfService } from '../../../sevices/PdfService';

import type { AutoCompleteCtrl, AutoCompleteCtrl_Attributes, AutoCompleteCtrl_InputValue, AutoCompleteCtrl_Options, PopulateDeps, CostCenterDef, CostRateTypeFromDomain, FireContractInfo, FormCtrl, GenListType, MealsClaimsExpenses, NoteItem, TravelClaimsExpenses, WorkClaimsExpenses } from '../../../common/types';
import type { BasicInfo_ui, CostSummary_ui, FireEquipmentInfo_raw, LodgingProvisionInfo, MealProvisionInfo, Rate_raw, TicketInfo, TicketInfo_ui, TravelSegmentInfo, WorkSegmentInfo } from '../../../common/models/TicketInfo';
import { Autocomplete, createFilterOptions, InputAdornment, MenuItem, Select, TextField, Tooltip } from '@mui/material';
import { wdpUtil } from '../../../common/utils/util';
import { appLog } from '../../../common/utils/app-log';
import type { GoabCalloutType, GoabCheckboxOnChangeDetail, GoabFormItemRequirement, GoabTemporaryNotificationType } from '@abgov/ui-components-common';
import { TemporaryNotification } from '@abgov/ui-components-common';
import { CustomFmF } from '../../../common/components/datePicker/datePicker';
import { AppContext } from '../../../common/contexts/apiContext';
import { useAuth } from 'react-oidc-context';
import { appStrings, basicFields,  dateFormat, domianTableLookupIdWorkPerformed, domianTableLookupIdAssignedToWildfire, domianTableLookupIdFuelProvidedByGoa, domianTableLookupIdCostRateType, domianTableLookupIdCostingActivity, LodgingCostRateType, mandatoyFields, MealCostRateType, RatesFromFires, TravelCostRateType,  TicketStatusLookupKey, TicketStatuses, workRateType, RateType_CrewExpBreakfast, RateType_CrewExpLunch, RateType_Accommodation, RateType_CrewExpDinner, RateType_FuelSurcharge, RateType_Standard, appPdfTemplateId, domianTableRelationshipKeyWorkPerformed } from '../../../common/constants';
import dayjs from 'dayjs';
import TicketService from '../../../sevices/TicketService';
import ApiControllerService from '../../../sevices/ApiControllerService';
import { Notes } from './components/notes/Notes';
import { TravelInfo } from './components/travelInfo/TravelInfo';
import { MealInfo } from './components/mealInfo/MealInfo';
//import { WorkInfo } from './components/workInfo/WorkInfo';
import { arePrerequisitesReady } from '../../../common/utils/lookupReadiness';
import { WorkInfo } from './components/workInfo/WorkInfo';
import { canEditCostSummaryField, canManageCostSummaryRows, canShowButton , getCurrentTicketPermissions, getTicketRole, getViewableStatusLookupKeys } from './role-processor/permission-config';






export function TicketDetails(props: { onChange: any, onEditModeChange?: (editMode: boolean) => void }) {

  const { ticketId, digitalId } = useParams();
  const navigate = useNavigate();

  
  
  const auth = useAuth();
  const [appError, setAppError] = useState("");
  const redirectId = useRef({ id: '', ticketNumber: '' });
  const [refresh, setRefresh] = useState(true);
  // Tracks the identifier (ticketId/digitalId) of the last ticket that was successfully loaded.
  // Used to distinguish a genuinely fresh navigation to a ticket (should reset to view mode and
  // show the full-page loading state) from a background reload of the SAME ticket triggered
  // after a save (should preserve accordion open/closed state and whichever section is in edit mode).
  const lastLoadedIdentifierRef = useRef<string | null>(null);
  // Aborts the in-flight ticket load (getTicketById/getTicketByDigitalId + queryTicketDep) when a
  // new loadTicket() call starts (e.g. rapid navigation between tickets), so a slower, stale
  // response can't overwrite the form with the wrong ticket's data.
  const loadTicketAbortControllerRef = useRef<AbortController | null>(null);
  // Ref to the form element wrapping all accordions. Used at save time to read the ACTUAL
  // open/closed state of each accordion directly from the DOM (the goa-accordion web component
  // manages its own open/closed state internally via its shadow DOM <details> element, so React
  // state can't be trusted to reflect user toggles). The captured snapshot is then restored after
  // the save-triggered reload completes, so accordions come back exactly as the user left them.
  const formContainerRef = useRef<HTMLFormElement>(null);
  const accordionOpenSnapshotRef = useRef<{ basic: boolean; costSummary: boolean; meal: boolean; travel: boolean; work: boolean; notes: boolean } | null>(null);
  //const [pageReadOnlyMode, setPageReadOnlyMode] = useState(true);
  //const [ticketStatus, setTicketStatus] = useState("");
  //const [ticketStatusId, setTicketStatusId] = useState(0);
  
  

  const [showDeleteCostSummaryModal, setShowDeleteCostSummaryModal] = useState(false);
  const [showDeleteTicketModal, setShowDeleteTicketModal] = useState(false);
  const [showDeleteTicketWarningModal, setShowDeleteTicketWarningModal] = useState(false);
  const [showChangeEquipWarningModal, setShowChangeEquipWarningModal] = useState<{who:string,value:any}|null>(null);
  const [showDuplicateTicketWarningModal, setShowDuplicateTicketWarningModal] = useState(false);
  const [returnTicketNote, setReturnTicketNote] = useState('');
  const [returnShareWithOperatorVendor, setReturnShareWithOperatorVendor] = useState(true);
  
  // section controls and statuses managent
  const [pendingBackendSave, setPendingBackendSave] = useState(false);
  // Guards against re-entrant backend calls (e.g. a double-click on Save, or
  // onCreateTicket() calling onSaveBasicInfo() then onSaveCostSummary() back-to-back,
  // each of which calls doSave() directly). isBusyRef.current is read/written
  // synchronously, unlike useState, so it also catches calls made within the same event
  // handler, before React has re-rendered. forceBusyRender just forces a re-render so
  // JSX `disabled` props bound to isBusyRef.current stay in sync.
  const isBusyRef = useRef(false);
  const [, forceBusyRender] = useState(0);
  function setIsBusy(value: boolean) {
    isBusyRef.current = value;
    forceBusyRender(t => t + 1);
  }

  
  //const [sectionDirtyMap, setSectionDirtyMap] = useState({ basic: false, meal: false, travel: false,costSummary:false,notes:false });
  

  // page flow and status management
  const [pageStatus, setPageStatus] = useState({ updateFlow: false,editModeBySection: { basic: true, meal: true, travel: true, work: true,costSummary:true,notes:true }}); 

  // Only one section can be in edit mode at a time. Tracks which section is currently active so
  // starting to edit a new section forces any other section to cancel its own edit.
  type EditableSection = 'basic' | 'costSummary' | 'meal' | 'travel' | 'work' | 'notes';
  const [activeEditSection, setActiveEditSection] = useState<EditableSection | null>(null);

  // Role/status-derived permission matrix for the currently loaded ticket; recomputed whenever
  // the ticket's status changes (see effect below). Drives section visibility and action gating.
  const [ticketPermissions, setTicketPermissions] = useState<ReturnType<typeof getCurrentTicketPermissions> | null>(null);
  
  
  // Full-page blocking spinner (GoabCircularProgress) - used for the initial page/prerequisite/ticket
  // load AND for every backend call in flight (save/approve/delete/etc.) - set it right before the
  // call and clear it in the .finally().
  const [progressMsg, setProgressMsg] = useState("");
  // True while a post-action reload (handleToast's 'refresh' trigger -> reloadPage() -> loadTicket())
  // is in flight. While true, handlers' .finally() blocks skip clearing isBusy/progressMsg so the
  // blocking spinner and re-entrancy guard stay up for the WHOLE action, not just its own API call -
  // loadTicket() clears this once the reload actually finishes.
  const reloadPendingRef = useRef(false);

  //const [allAccordionOpen, setAllAccordionOpen] = useState({basic:true,equipment:true,timeTrack:true,meal:false,true:false});
  const [allAccordionOpen, setAllAccordionOpen] = useState({ basic: true, costSummary: true, meal:true,travel:true,work:true,notes: true });
  const [notesDrawerOpen, setNotesDrawerOpen] = useState(false);
  const [notesDrawerMode, setNotesDrawerMode] = useState<'notes' | 'return'>('notes');

  // contract Number - autoCOmplete control
  //const [contractNumberValue, setContractNumberValue] = useState<FireContractInfo | null>(null);
  const [contractNumberInputValue, setContractNumberInputValue] = useState('');
  const [forestAreaIdInputValue, setForestAreaIdInputValue] = useState('');
  const [unitNumberInputValue, setUnitNumberInputValue] = useState('');
  const [equipmentInputValue, setEquipmentInputValue] = useState('');
  const [serialNumberInputValue, setSerialNumberInputValue] = useState('');
  const [addOnsInputValue, setaddOnsInputValue] = useState('');

  const [contractInfoList, setContractInfoList] = useState<FireContractInfo[]>([]);
  const [isTicketNotesLoading, setIsTicketNotesLoading] = useState(false);
  const [isTicketNotesError, setIsTicketNotesError] = useState(false);
  //const [costCenterList, setCostCenterList] = useState<GenListType[]>([]);

  //
  // form control
  //
  //const InitGenListType : GenListType={label:"",value:""};
  const costSummaryEmptyObj: CostSummary_ui = {
     id:"",
    fireNumber: "",
    costActivityCode: "",
    rateType: "",
    noOfUnits: "",
    rateUnit: "",
    ratePerUnit: "",
    amount: "",
    internalOrder: "",
    costCenter: "",
    fund: "",
    account: "",
    invoiceNo: '',
    invoiceId: "",
    // UI only
    selected: false,
  };
  const ticketEmptyObj: TicketInfo_ui = {
    id: "",
    ticketNumber: "",
    digitalId: "",
    date: "",
    statusId: "",
    status: "",
    contractNumber: "",
    contractorName: "",
    forestAreaId: "",
    standbyBase: "",
    fieldSupervisor: "",
    
    unitNumber: "",
    serialNumber: "",
    equipment: "",
    addOns: "",

    costSummary: [],
    
    isDraft: "",
    isFlagged: false,
    isReturnable: false,
    resourceComments: "",
    timeTrackingComments: "",
    mealsAndLodgingComments: "",
    travelTimeComments: "",

    notes: [],

    // UI Olny
  }
  const autoCompleteInputCtrlEmptyObj: AutoCompleteCtrl_InputValue  = { fireNumber: "", internalOrder: "",costCenter:"" };
  const autoCompleteOptionsCtrlEmptyObj: AutoCompleteCtrl_Options   = { fireNumber: [], internalOrder: [] ,costCenter:[]};
  const autoCompleteAttrsCtrlEmptyObj: AutoCompleteCtrl_Attributes  = { fireNumber: {}, internalOrder: {matchFireNo:false} ,costCenter:{}};
  
  //const [autoCompleteInputCtrl, setAutoCompleteInputCtrl] = useState<AutoCompleteCtrl_InputValue[]>([autoCompleteInputCtrlEmptyObj]);
  //const [autoCompleteOptionsCtrl, setAutoCompleteOptionsCtrl] = useState<AutoCompleteCtrl_Options[]>([autoCompleteOptionsCtrlEmptyObj]);
  

  const [autoCompleteCtrl, setAutoCompleteCtrl] = useState<AutoCompleteCtrl>({input: [],options: [],attrs:[]});
  
  


  //NOTE:  all the fields in initVals must be empry, because we are ussing it for Errors and touched objects
  // there is a separte function  to do the init

  const [formCtrl, setformCtrl] = useState<FormCtrl>({ values: wdpUtil.deepCopy(ticketEmptyObj), errors: wdpUtil.deepCopy(ticketEmptyObj), touched: wdpUtil.deepCopy(ticketEmptyObj) });
  

  const orginalData = useRef<TicketInfo_ui>(wdpUtil.deepCopy(ticketEmptyObj));

  // lookup from fires - Equipment Info
  const [resourceSnapshotRawJsonFromFires, setResourceSnapshotRawJsonFromFires] = useState<FireEquipmentInfo_raw[]>([]);  

  //const filterOptionsContractInfo = createFilterOptions({ matchFrom: 'any', stringify: (option: FireContractInfo) => { return option?.contractNumber } });
  //const filterOptionsGenListType = createFilterOptions({ matchFrom: 'start', stringify: (option: GenListType) => { return option?.label } });
  const filterOptionsGenListType = createFilterOptions({ matchFrom: 'any', stringify: (option: GenListType) => { return option?.label } });
  //const filterOptionsGenListType = createFilterOptions({matchFrom: 'start',stringify: (option: GenListType) => option?.label?.toLowerCase() ?? ""});

  // Sub Components Interaction 
  // Meal/lodge  and Travel
  // const [mealEligibility,   setMealEligibility]   = useState(true);
  // const [mealsCanClaim,     setMealsCanClaim]     = useState({id:"",breakfast: false,lunch: false,dinner: false,lodging: false});
  // const [travelEligibility, setTravelEligibility] = useState(true);
  // const [travelValues,      setTravelValues]      = useState<TravelClaimsExpenses[]>([{ id:"",from: "", to: "", startUtc: "", finishUtc: "", noOfUnits: "" }]);
  
  // context Data
  const myAppCtx = useContext(AppContext);
  const pageMounted = useRef(false);
  // list of rate types that has rate per unit in the domian table
  // fore the  other rate tpyes ..dry, stadnard, .. we will get the rate per unit from FIRES
  /****************************************************************************************
   * 
  *****************************************************************************************/
  useEffect(() => {
  }, []);
  /****************************************************************************************
  

  *****************************************************************************************/
  // useEffect(() => {
    
  //   const selected = (formCtrl.values.forestAreaId as GenListType)?.label?.trim() || "";
  //   if (!selected) return;

  //   setProgressMsg("Loading cost centers...");

  //   ApiService.queryCostCenter(auth.user?.access_token!, selected, null)
  //     .then(res => {
  //       if (!res || !Array.isArray(res) || res.length === 0) return;

  //       const sorted   = wdpUtil.sortOptList("costCenter", res);
  //       const goodList = sorted.map(x => ({label: `${x.costCenterName?.trimStart()} - ${x.costCenterId?.trimStart()}`,value: x.costCenterId?.trimStart()}));



  //       // update autocomplete
  //       const _autoInput  = autoCompleteCtrl.input.map(x => ({ ...x, costCenter: "" }));
  //       const _autoLists  = autoCompleteCtrl.options.map(x => ({ ...x, costCenter: goodList }));

  //       updateFormCtrl(_formValues, _formErrors, _formTouched);
  //       setAutoCompleteCtrl({ input: _autoInput, options: _autoLists });
  //     })
  //     .catch(err => {
  //       if (err.name !== "CanceledError") {
  //         console.log(err);
  //         handleServerError(err, "Failed to load cost center list");
  //       }
  //     })
  //     .finally(() => {
  //       setProgressMsg("");
  //     });
  // }, [
  //   // IMPORTANT: use the primitive value, not the whole object
  //   (formCtrl.values.forestAreaId as GenListType)?.label
  // ]);


  /****************************************************************************************
  
  *****************************************************************************************/
  useEffect(() => {
    if (wdpUtil.isNullorUndefined(myAppCtx)) return; // it shouldnt

    const cacheReady = arePrerequisitesReady(myAppCtx!.lookups);
    if (!cacheReady) {
      setProgressMsg("Loading Prerequisites");
      return;
    }

    setProgressMsg("");
    loadTicket();

    //}, [ticketId, refresh]);
  }, [ticketId, digitalId, refresh, myAppCtx?.lookups]);

  /********************************************************************************************
   * Recompute ticket permissions once the ticket (and its status) has been loaded. Falls back to
   * statusId 0 (-> "notSubmitted") for a brand-new, not-yet-saved ticket.
  *********************************************************************************************/
  useEffect(() => {
    const statusId = wdpUtil.safeParse(formCtrl.values.statusId, { type: "int" }) || 0;
    setTicketPermissions(getCurrentTicketPermissions(auth, statusId));
  }, [formCtrl.values.statusId]);

  /********************************************************************************************
  // this is a deferred-save
  // Trigger backend save after formCtrl state has been updated by a section save.
  // Why: updateFormCtrl is async, and doSave() reads formCtrl.values. Calling doSave()
  // immediately after updateFormCtrl may send stale data.
  //
  *********************************************************************************************/
  useEffect(() => {
    if (pendingBackendSave) {
      setPendingBackendSave(false);
      doSave();
    }
  }, [pendingBackendSave]);
  
  /********************************************************************************************
  *********************************************************************************************/
//   useEffect(() => {
//   setformCtrl(prev => {
//     const newErrors = { ...prev.errors };
//     const newTouched = { ...prev.touched };

//     for (const key in prev.values) {
//       const value = prev.values[key];
//       const error = validateField(key, value);

//       newErrors[key] = error;
//       newTouched[key] = true; // or keep previous touched logic
//     }

//     return {
//       ...prev,
//       errors: newErrors,
//       touched: newTouched
//     };
//   });
// }, [formCtrl.values]);

  const travelEntries = useMemo(() => {
    return extractTravelCostEntries(formCtrl.values.costSummary);
  }, [formCtrl.values.costSummary]);

   const mealsCanClaim = useMemo(() => {
     return extractMealCostEntries(formCtrl.values.costSummary);
  }, [formCtrl.values.costSummary]);

  const workPerformedEntries = useMemo(() => {
    return extractWorkCostEntries(formCtrl.values.costSummary);
  }, [formCtrl.values.costSummary]);
  /********************************************************************************************
   * Load notes for persisted tickets. Parent owns data fetching for Notes section.
  ********************************************************************************************/
  function loadTicketNotes(targetTicketId: string) {
    setIsTicketNotesLoading(true);
    setIsTicketNotesError(false);

    ApiService.getTicketNotes(auth.user?.access_token as string, targetTicketId)
      .then((res: NoteItem[] | null) => {
        updateFormCtrl({ notes: Array.isArray(res) ? res : [] }, null, null);
      })
      .catch((error) => {
        appLog.error(error);
        updateFormCtrl({ notes: [] }, null, null);
        setIsTicketNotesError(true);
      })
      .finally(() => {
        setIsTicketNotesLoading(false);
      });
  }

  /********************************************************************************************
   * 
  ********************************************************************************************/
  function loadResourceSnapshotRawJsonFromFires(value: string, dt: string) {

    // if AutoComplete is used then we need value.value because the input will be GenListType
    //const newVal = value.value;

    const newVal = value;
    //const qSearch = unitNumberInputValue;
    if (!wdpUtil.isNullorUndefined(newVal) && !wdpUtil.isNullorUndefined(dt)) {

      ApiService.loadResourceSnapshotRawJson(auth.user?.access_token as string, newVal, dt!).then((res: any) => {
        if (res != null && !wdpUtil.isNullorUndefined(res)) {
          // load equipment detials from Fires endpoint.  has everything we need .. take the unit now
          const goodList = res.map((e: FireEquipmentInfo_raw) => { return { ...e, equipmentId: e.equipmentId?.toString() } });  // make sure to convert ant num to string
          setResourceSnapshotRawJsonFromFires(goodList);
        }
      }).catch((error) => {
        appLog.debug(error);
        handleServerError(error, 'Failed to load equipment data');
      }).finally(() => setProgressMsg(""));
    } else {
      setResourceSnapshotRawJsonFromFires([]);
    }
  }
  /********************************************************************************************
  *********************************************************************************************/
  function loadFires(newVal: string, recIndex: number) {
    const qStr = newVal.trim();
    // 1. Always update inputValue immediately (user typing)
    updateAutoCompleteCtrl(recIndex, {inputValue: { fireNumber: qStr },options: { fireNumber: [] }});

    // 2. Do not search until 2+ chars
    if (qStr.length < 2) return;

    // 3. Get a per-field abort controller
    const controller = ApiControllerService.createController(recIndex, "fireNumber");

    // 4. Call backend
    ApiService.queryFires(auth.user?.access_token!, qStr, controller).then(res => {
      const list = res?.data;

      // Empty result → clear options
      if (!list || list.length === 0) {
        updateAutoCompleteCtrl(recIndex, {
          options: { fireNumber: [] }
        });
        return;
      }

      // Map results
      const goodList: GenListType[] = list.map((elem: any) => ({
        label: `${elem.fireNumber} - ${elem.year}`,
        value: elem.fireNumber
      }));

      // Update ONLY options
      updateAutoCompleteCtrl(recIndex, {
        options: { fireNumber: goodList }
      });
    })
    .catch(error => {
      if (error.name === "CanceledError") return;
      appLog.debug(error);
      handleServerError(error, "Failed to load fire numbers");
    })
    .finally(() => {
      setProgressMsg("");
    });
  }

  /********************************************************************************************
  *********************************************************************************************/
  function loadContracts(qSearch: string, _formValues: TicketInfo_ui) {
    if (qSearch != null && qSearch.length > 0 && qSearch.trimStart() && qSearch.trimEnd() && qSearch.length >= 2) {
      ApiService.queryContracts(auth.user?.access_token as string, qSearch, _formValues.date!).then((res: any) => {
        if (res != null) {
          const goodList = res;
          //const goodList: GenListType[] = res.map((elem: any) => { return { label: elem.contractNumber, value: elem.contractNumber } });
          //console.log(goodList);
          setContractInfoList([...goodList]);
        }
      }).catch((error) => {
        appLog.debug(error);
        handleServerError(error, 'Failed to load contracts');
      }).finally(() => setProgressMsg(""));
    } else {
      setContractInfoList([]);

    }
  }
  /********************************************************************************************
  *********************************************************************************************/
  function loadCostCenter(newVal: string, recIndex: number) {
    const qStr = newVal.trim();
  
    // 1. Always update inputValue immediately (user typing)
    updateAutoCompleteCtrl(recIndex, {inputValue: { costCenter: qStr },options: {costCenter: [] }});

    // 2. Do not search until 2+ chars
    if (qStr.length < 2) return;

    // 3. Abort previous request for THIS field only
    const controller = ApiControllerService.createController(recIndex, "costCenter");
    
    // 4. Call backend
    ApiService.queryCostCenter(auth.user?.access_token!, qStr, controller)
      .then(res => {
        if (!res || !Array.isArray(res) || res.length === 0) {
          updateAutoCompleteCtrl(recIndex, {options: { costCenter: [] }});
          return;
        }

        const sorted = wdpUtil.sortOptList("costCenter", res);
        const goodList = sorted.map((x:CostCenterDef) => ({label: `${x.costCenterDescription?.trimStart()} - ${x.costCenter?.trimStart()}`,value: x.costCenter?.trimStart()}));

        // 5. Update ONLY options (API result)
        updateAutoCompleteCtrl(recIndex, {options: { costCenter: goodList }});
      })
      .catch(error => {
        if (error.name !== "CanceledError") {
          appLog.debug(error);
          handleServerError(error, "Failed to cost Center list");
        }
      })
      .finally(() => {
        setProgressMsg("");
      });
  }
  /********************************************************************************************
  *********************************************************************************************/
  function forestAreaSideEffect(_formValues:TicketInfo_ui,_formErrors:TicketInfo_ui,_formTouched:TicketInfo_ui,forestArea:string){
    const goodList: GenListType[] = TicketService.getCostCenter4ForestArea(myAppCtx?.lookups,forestArea); // exprecting just one item 
    
    // update costSummary rows
    for (const cs of _formValues.costSummary) {if (cs) cs.costCenter = goodList.length === 1 ? goodList[0] : null;}
    for (const cs of _formErrors.costSummary) {if (cs) cs.costCenter = "";}
    for (const cs of _formTouched.costSummary) {if (cs) cs.costCenter = "T";}

    // update autocomplete
    const _autoInput  = autoCompleteCtrl.input.map(x => ({ ...x, costCenter: "" }));
    const _autoLists  = autoCompleteCtrl.options.map(x => ({ ...x, costCenter: goodList }));
    const _autoAtrs   = autoCompleteCtrl.attrs.map(x => ({ ...x, costCenter: goodList }));
    setAutoCompleteCtrl({input:_autoInput,options:_autoLists,attrs: _autoAtrs});
    
    //updateFormCtrl(_formValues, _formErrors, _formTouched);
    //setAutoCompleteCtrl({ input: _autoInput, options: _autoLists });
    // const qStr = forestArea.trim();
    // ApiService.queryCostCenter(auth.user?.access_token!, qStr, null)
    //   .then(res => {
    //     if (res && Array.isArray(res) && res.length > 0) {
    //       const sorted = wdpUtil.sortOptList("costCenter", res);
    //       const goodList = sorted.map(x => ({label: `${x.costCenterName?.trimStart()} - ${x.costCenterId?.trimStart()}`,value: x.costCenterId?.trimStart()}));
    //       for(let cs of _formValues.costSummary){
    //         if(cs!=null){
    //           cs.costCenter = (goodList!=null && goodList.length===1)? goodList[0]:null;
    //         }
    //       }
    //       for(let cs of _formErrors.costSummary){if(cs!=null){cs.costCenter = '';}}
    //       for(let cs of _formTouched.costSummary){if(cs!=null){cs.costCenter = "T";}}
    //     }
    //   })
    //   .catch(error => {
    //     if (error.name !== "CanceledError") {
    //       console.log(error);
    //       handleServerError(error, "Failed to cost Center list");
    //     }
    //   })
    //   .finally(() => {
    //     setProgressMsg("");
    //   });

  }
  /********************************************************************************************
   * we should check if we are  calling this function while User-Typing or Programatically
   * this function will update inputValue, options and maybe the formCtrl(value, errors,touched)
  *********************************************************************************************/
  function loadInternalOrderCodes(newVal: string, recIndex: number) {
    const qStr = newVal.trim();
  
    // 1. Always update inputValue immediately (user typing)
    updateAutoCompleteCtrl(recIndex, {inputValue: { internalOrder: qStr },options: { internalOrder: [] }});

    // 2. Do not search until 2+ chars
    if (qStr.length < 2) return;

    // 3. Abort previous request for THIS field only
    const controller = ApiControllerService.createController(recIndex, "internalOrder");
    
    // 4. Call backend
    ApiService.queryInternalCodes(auth.user?.access_token!, qStr, controller)
      .then(res => {
        if (!res || !Array.isArray(res) || res.length === 0) {
          updateAutoCompleteCtrl(recIndex, {
            options: { internalOrder: [] }
          });
          return;
        }

        const sorted = wdpUtil.sortOptList("internalOrder", res);
        const goodList = sorted.map(x => ({
          label: `${x.internalOrderDescription?.trimStart()} - ${x.internalOrder}`,
          value: x.internalOrder
        }));

        // 5. Update ONLY options (API result)
        updateAutoCompleteCtrl(recIndex, {
          options: { internalOrder: goodList }
        });
      })
      .catch(error => {
        if (error.name !== "CanceledError") {
          appLog.debug(error);
          handleServerError(error, "Failed to load internal order codes");
        }
      })
      .finally(() => {
        setProgressMsg("");
      });
  }
  /********************************************************************************************
  *********************************************************************************************/
  async function loadInternalCodesAsync(qStr: string) {
    try {
      return await ApiService.queryInternalCodesAsync(auth.user?.access_token!,qStr);
    } catch (err) {
      appLog.error(err);
      return null;
    }
  }

  
  // function runProgrammaticUpdate(fn: () => void) {
  //   setAutoCompleteProgrammatic(true);
  //   fn(); // perform the programmatic update
  //   // Reset AFTER React finishes rendering the update
  //   setTimeout(() => {
  //     setAutoCompleteProgrammatic(false);
  //   }, 0);
  // }


  /********************************************************************************************
   * Load ticket details after prerequisites are available in app context.
  ********************************************************************************************/
  function loadTicket() {
    // Determine which route parameter is being used
    const identifier = digitalId || ticketId;

    // A "same-ticket reload" is a background refresh (e.g. triggered after a section save)
    // of the SAME ticket that's already loaded/displayed — as opposed to a genuinely fresh
    // navigation to a (possibly different) ticket. For a same-ticket reload we want to keep
    // the page mounted and preserve accordion open/closed state and whichever section is
    // currently in edit mode, instead of resetting everything back to view mode.
    const isSameTicketReload = identifier != 'new' && lastLoadedIdentifierRef.current === identifier;

    // Clear any previous progress message and show the blocking spinner. For a same-ticket
    // background reload the form stays mounted underneath it (see the render gate above), so
    // this safely blocks interaction without losing accordion/edit state.
    setProgressMsg("Loading ticket's details...");

    // Reset notes state on every load (fresh navigation or same-ticket reload); notes are
    // (re)fetched via loadTicketNotes() once the ticket id is known.
    updateFormCtrl({ notes: [] }, null, null);
    setIsTicketNotesLoading(false);
    setIsTicketNotesError(false);

    if (identifier != 'new') {
      // Cancel any still in-flight load for a previous ticket so a slower, stale response
      // can't land after this one and overwrite the form with the wrong ticket's data.
      loadTicketAbortControllerRef.current?.abort();
      const controller = new AbortController();
      loadTicketAbortControllerRef.current = controller;

      // Call appropriate API method based on which parameter exists
      const apiCall = digitalId 
        ? ApiService.getTicketByDigitalId(auth.user?.access_token as string, digitalId as string, controller)
        : ApiService.getTicketById(auth.user?.access_token as string, ticketId as string, false, controller);
      
      apiCall.then(res => {
        if (res != null) {
          loadTicketNotes(res.id as string);
          const ticketDep = { id: res.id, contratNo: res.contractNo, formattedDate: res.date };
          // IMPORTANT: return this promise so the outer .finally() below waits for populateForm()
          // (which sets formCtrl.values.id) to actually complete before clearing progressMsg.
          // Without the return, .finally() fires as soon as `apiCall` resolves, exposing a window
          // where the page is shown but formCtrl.values.id (and therefore isNewTicket()) is stale.
          return ApiService.queryTicketDep(auth.user?.access_token as string, ticketDep, controller).then((depRes: any) => {

            const contractInfo = depRes.contactInfo ?? [];
            // FIRES documents an empty array when a contract has no equipment; guard against a
            // null/undefined response too so the rest of populate still runs instead of silently
            // leaving the form blank.
            const rawJsonRes = depRes.rawJson ?? [];
            const goodList = rawJsonRes.map((e: FireEquipmentInfo_raw) => { return { ...e, equipmentId: e.equipmentId?.toString() } });

            setContractInfoList([...contractInfo]);
            setResourceSnapshotRawJsonFromFires([...goodList]);

            // Ready to populate
            const populateDeps: PopulateDeps = { contracts: [...contractInfo], rawJsonFromFires: [...goodList] }
            setPageStatus((prev) => ({
              ...prev,
              updateFlow: true,
              // On a same-ticket background reload, preserve whichever section (if any) is
              // currently in edit mode instead of forcing everything back to view mode.
              editModeBySection: isSameTicketReload
                ? prev.editModeBySection
                : { basic: false, meal: false, travel: false, work: false, costSummary: false, notes: false }
            }));
            if (props.onEditModeChange) {
              props.onEditModeChange(false);
            }
            setAppError("");
            reloadPendingRef.current = false;
            setIsBusy(false);
            setProgressMsg("");
            populateForm(populateDeps, {...res});
            lastLoadedIdentifierRef.current = identifier as string;

            // Restore the accordion open/closed layout captured right before this save
            // (if this reload was triggered by a save). Otherwise leave the current state as-is.
            if (accordionOpenSnapshotRef.current) {
              setAllAccordionOpen(accordionOpenSnapshotRef.current);
              accordionOpenSnapshotRef.current = null;
            }
          });
        } else {
          appLog.debug(`Failed to Load ticket details. ticketID = ${ticketId}`);
          setAppError('Failed to load ticket details');
          reloadPendingRef.current = false;
          setIsBusy(false);
          setProgressMsg("");
        }
      }).catch((error) => {
        // A CanceledError just means a newer loadTicket() call superseded this one; nothing to report.
        if (error.name === "CanceledError") return;
        appLog.debug(error.message);
        // A post-action reload 403 means this role lost view access under the ticket's new status
        // (e.g. Reviewer after Verify/Return) - the action itself succeeded, so go home instead of
        // leaving a stale, now-inaccessible page up with just a generic error toast.
        if (reloadPendingRef.current && error?.status === 403) {
          TemporaryNotification.show('Ticket updated - it is no longer accessible with your current role.', { type: 'basic', duration: 'short' });
          navigate("/");
          return;
        }
        handleServerError(error, 'Failed to load ticket details');
      }).finally(() => {
        if (loadTicketAbortControllerRef.current === controller) {
          reloadPendingRef.current = false;
          setIsBusy(false);
          setProgressMsg("");
        }
      });
    } else {
      // A fresh navigation to the "new ticket" form supersedes any in-flight load for a
      // previously viewed ticket.
      loadTicketAbortControllerRef.current?.abort();
      loadTicketAbortControllerRef.current = null;
      lastLoadedIdentifierRef.current = null;
      
      setPageStatus((prev) => ({
        ...prev,
        updateFlow: false,
        editModeBySection: { basic: true, meal: true, travel: true, work: true, costSummary: true, notes: true }
      }));
      // In create-ticket mode, only Basic information should start expanded; all other
      // accordion sections should start collapsed.
      setAllAccordionOpen({ basic: true, costSummary: false, meal: false, travel: false, work: false, notes: false });
      if (props.onEditModeChange) {
        props.onEditModeChange(true);
      }
      const populateDeps: PopulateDeps = { contracts: [], rawJsonFromFires: [] }
      populateForm(populateDeps, null);
      reloadPendingRef.current = false;
      setIsBusy(false);
      setProgressMsg("");
    }
  }
  /********************************************************************************************
   * {contracts:[],rawJsonFromFires:[]}
  ********************************************************************************************/
  function populateForm(_populateDeps: PopulateDeps, myTicket: TicketInfo | null) {
    appLog.debug("populateForm started");
    // new Ticket
    if (myTicket === null) {
      const _formValues:TicketInfo_ui  = wdpUtil.deepCopy(ticketEmptyObj);
      const _formErrors:TicketInfo_ui  = wdpUtil.deepCopy(ticketEmptyObj);
      const _formTouched:TicketInfo_ui = wdpUtil.deepCopy(ticketEmptyObj);
      
      // init goes here 
      initTicket(_formValues);
      const initialStatusItem = getStatusLookupItemByKey(getNewTicketStatusKey());
      _formValues.statusId = initialStatusItem?.value ?? "";
      _formValues.status   = initialStatusItem?.label ?? "";

      // Keep an original snapshot for dirty checks and cancel behavior.
      orginalData.current = wdpUtil.deepCopy(_formValues);
      
      // Ready to  update
      updateFormCtrl(_formValues, _formErrors, _formTouched);
      pageMounted.current=true;
    }
    else {
      
      // make acopy of the FormControl
      const _formValues:TicketInfo_ui  = wdpUtil.deepCopy(formCtrl.values);
      const _formErrors:TicketInfo_ui  = wdpUtil.deepCopy(formCtrl.errors);
      const _formTouched:TicketInfo_ui = wdpUtil.deepCopy(formCtrl.touched);
      try {
        _formValues.id              = myTicket.id as string;
        _formValues.ticketNumber    = myTicket.ticketNumber;
        _formValues.digitalId       = myTicket.digitalId;
        _formValues.date            = myTicket.date;
        _formValues.statusId        = myTicket.statusId;
        _formValues.status          = myTicket.status;
        _formValues.contractorName  = myTicket.contractorName;
        _formValues.standbyBase     = myTicket.standbyBase ?? "";
        _formValues.fieldSupervisor = myTicket.fieldSupervisor ?? "";
        _formValues.isFlagged       = myTicket.isFlagged ?? false;
        _formValues.isReturnable    = myTicket.isReturnable ?? false;
        
        
        _formValues.forestAreaId  =  myAppCtx?.lookups.forestAreaList.find((e:GenListType) => e.value === myTicket.forestAreaId.toString())??"";
        _formValues.contractNumber= {label: myTicket.contractNo,        value:myTicket.contractNo};
        _formValues.unitNumber    = {label: myTicket.resourceCode,      value:myTicket.resourceCode};
        _formValues.serialNumber  = {label: myTicket.resourceIdentifier,value:myTicket.resourceIdentifier};
        const addOnsStr           = TicketService.extractFromAttrobute(myTicket.resourceAttributes,'addOns');
        //_formValues.addOns        = {label:(addOnsStr==="")?appStrings.noAddOns:addOnsStr,value:addOnsStr}; 
        _formValues.addOns        = {label:addOnsStr,value:addOnsStr}; 
        _formValues.equipment     = {label: myTicket.resourceDisplayName, value: myTicket.resourceId.toString() };
       
        
        
        /////////////////////////////////////////////////////////
        // Cost Summary table
        _formValues.costSummary = [];
        _formErrors.costSummary = [];
        _formTouched.costSummary = [];

        const _autoCompletInputCtrl: AutoCompleteCtrl_InputValue[] = [];
        const _autoCompletListCtrl: AutoCompleteCtrl_Options[] = [];
        const _autoCompletAttsCtrl: AutoCompleteCtrl_Attributes[] = [];
        // helper to build the AutoCompleteCtrl_Attributes for each cost summary record based on the fire number and internal order
        const buildAttrsCtrl = (rec: CostSummary_ui): AutoCompleteCtrl_Attributes => ({
          ...autoCompleteAttrsCtrlEmptyObj,
          internalOrder: {
            matchFireNo: TicketService.isInternalOrderMatchingFireNo(rec.fireNumber as GenListType | string | null,rec.internalOrder as GenListType | string | null)
          }
        });

         const equInfo= TicketService.packageEquInfo(_formValues); // we will need this inof to find some ids in FIRES
        if(myTicket.workSegments != null){
          for (let recIndex=0;recIndex< myTicket.workSegments.length;recIndex++) {
            const rec: CostSummary_ui|null = Segment2CostSummary(equInfo,myTicket.workSegments[recIndex]);
            if(rec!=null){
              _formValues.costSummary?.push(rec);
              _formErrors.costSummary?.push(wdpUtil.deepCopy(costSummaryEmptyObj));
              _formTouched.costSummary?.push(wdpUtil.deepCopy(costSummaryEmptyObj));
              
              // form _autoComplet controller
              const recInputCtrl  = {...autoCompleteInputCtrlEmptyObj};   _autoCompletInputCtrl.push(recInputCtrl);
              const recOptCtrl    = {...autoCompleteOptionsCtrlEmptyObj}; _autoCompletListCtrl.push(recOptCtrl);
              const recAttCtrl = buildAttrsCtrl(rec);_autoCompletAttsCtrl.push(recAttCtrl);
            }
          }
        }
        if(myTicket.travelSegments != null){
          for (let recIndex=0;recIndex< myTicket.travelSegments.length;recIndex++) {
            const rec: CostSummary_ui|null = Segment2CostSummary(equInfo,myTicket.travelSegments[recIndex]);
            if(rec!=null){
              // extra travel info
              rec.travelFrom = myTicket.travelSegments[recIndex].from;
              rec.travelTo        = myTicket.travelSegments[recIndex].to; 
              //rec.travelStartUtc  = wdpUtil.formatDate(myTicket.travelSegments[recIndex].startUtc, '', true);
              //rec.travelFinishUtc = wdpUtil.formatDate(myTicket.travelSegments[recIndex].finishUtc, '', true);
              rec.travelStartUtc  = myTicket.travelSegments[recIndex].startUtc;
              rec.travelFinishUtc = myTicket.travelSegments[recIndex].finishUtc;
              
              
              _formValues.costSummary?.push(rec);
              _formErrors.costSummary?.push(wdpUtil.deepCopy(costSummaryEmptyObj));
              _formTouched.costSummary?.push(wdpUtil.deepCopy(costSummaryEmptyObj));
              
              // form _autoComplet controller
              const recInputCtrl  = {...autoCompleteInputCtrlEmptyObj};   _autoCompletInputCtrl.push(recInputCtrl);
              const recOptCtrl    = {...autoCompleteOptionsCtrlEmptyObj}; _autoCompletListCtrl.push(recOptCtrl);
              const recAttCtrl = buildAttrsCtrl(rec);_autoCompletAttsCtrl.push(recAttCtrl);
            }
          }
        }
        //myTicket.meals
        if(myTicket.meals!=null){
          for (let recIndex=0;recIndex< myTicket.meals.length;recIndex++) {
            const rec: CostSummary_ui|null = Segment2CostSummary(equInfo,myTicket.meals[recIndex]);
            if(rec!=null){
              _formValues.costSummary?.push(rec);
              _formErrors.costSummary?.push(wdpUtil.deepCopy(costSummaryEmptyObj));
              _formTouched.costSummary?.push(wdpUtil.deepCopy(costSummaryEmptyObj));
            
              // form _autoComplet controller
              const recInputCtrl  = {...autoCompleteInputCtrlEmptyObj};   _autoCompletInputCtrl.push(recInputCtrl);
              const recOptCtrl    = {...autoCompleteOptionsCtrlEmptyObj}; _autoCompletListCtrl.push(recOptCtrl);
              const recAttCtrl = buildAttrsCtrl(rec);_autoCompletAttsCtrl.push(recAttCtrl);
            }
          }
        }
        //myTicket.lodging
        if(myTicket.lodging!=null){
          for (let recIndex=0;recIndex< myTicket.lodging.length;recIndex++) {
            const rec: CostSummary_ui|null = Segment2CostSummary(equInfo,myTicket.lodging[recIndex]);
            if(rec!=null){
              _formValues.costSummary?.push(rec);
              _formErrors.costSummary?.push(wdpUtil.deepCopy(costSummaryEmptyObj));
              _formTouched.costSummary?.push(wdpUtil.deepCopy(costSummaryEmptyObj));
              
              // form _autoComplet controller
              const recInputCtrl  = {...autoCompleteInputCtrlEmptyObj};   _autoCompletInputCtrl.push(recInputCtrl);
              const recOptCtrl    = {...autoCompleteOptionsCtrlEmptyObj}; _autoCompletListCtrl.push(recOptCtrl);
              const recAttCtrl = buildAttrsCtrl(rec);_autoCompletAttsCtrl.push(recAttCtrl);
            }
          }
        }
        /////////// done with the Segments
        // Don't auto-add cost summary row when loading ticket
        // Rows will be added when user changes equipment/contract fields or clicks "Add new+"

        // _formValues was deep-copied from formCtrl.values captured by this closure, which can
        // be a STALE snapshot from before loadTicketNotes() (fired earlier in loadTicket(), in
        // parallel with the queryTicketDep() call that leads here) resolves and updates
        // formCtrl.values.notes. Since updateFormCtrl() merges via {...prev.values, ...vals},
        // leaving `notes` in _formValues would clobber the freshly-loaded notes with this stale
        // (often still-empty) value whenever the notes fetch wins the race - which is common
        // since it's a single GET vs. queryTicketDep's two calls. populateForm doesn't own the
        // notes field, so drop it here and let loadTicketNotes() be the sole source of truth.
        delete _formValues.notes;

        // Keep an original snapshot for dirty checks and cancel behavior.
        orginalData.current = wdpUtil.deepCopy(_formValues);

        /////////////////////////////////////////////////////////
        // Ready to  update
        updateFormCtrl(_formValues, _formErrors, _formTouched);
        setAutoCompleteCtrl({input:_autoCompletInputCtrl,options:_autoCompletListCtrl,attrs:_autoCompletAttsCtrl})
        pageMounted.current=true;
        props.onChange(_formValues);
      }
      catch (e) {
        throw { status: 500, message: e };
      }
    }
  }
  /********************************************************************************************
   * 
  ********************************************************************************************/
  function onMyChange(who: string | undefined, value: any/*string[] | string | null|Dayjs*/) {
    //console.log(`onMychange: who:${who} value:${value}`);
    if (wdpUtil.isNullorUndefined(who))
      return;
    if (who?.startsWith("costSummary-") && !canEditCostSummaryField(ticketPermissions, who.split("-")[1])) {
      appLog.warn("Cost summary field edit blocked by ticket permissions:", who);
      return;
    }

    const _formValues:TicketInfo_ui  = wdpUtil.deepCopy(formCtrl.values);
    const _formErrors:TicketInfo_ui  = wdpUtil.deepCopy(formCtrl.errors);
    const _formTouched:TicketInfo_ui = wdpUtil.deepCopy(formCtrl.touched);
    const keyTypedVal   = who as keyof typeof formCtrl.values;
    const keyTypedErr   = who as keyof typeof formCtrl.errors;
    const keyTypedTouch = who as keyof typeof formCtrl.touched;


    switch (who) {
      /** basic Info Fields **/
      case "ticketNumber": {
        // Allow only: E/e + digits (max 8 chars)
        if(value ==="" ||  /^[Ee]\d{0,7}$/.test(value)){
        _formValues.ticketNumber = value;
        }
        
      }
      break;
      case "date": {
        let newVal = null;
        if ((value !== null) && !isNaN(value.toDate().getTime())) {
          newVal = (value ? value.format(dateFormat) : null);
        }
        (_formValues.date as string) = newVal as string;
        // side effect
        // if(wdpUtil.isNullorUndefined(_formValues.date)){
        //     //1 - reset contraxt number
        //     _formValues.contractNumber = null;
        //     contractSideEffect(_formValues,_formErrors,_formTouched,value);
        // }
      }
        break;
      case "contractNumber": {
        
        if (!wdpUtil.isNullorUndefined(contractInfoList) && contractInfoList.length > 0 && !wdpUtil.isNullorUndefined(value)) {
          _formValues.contractNumber = value;
        } else {
          _formValues.contractNumber = null;
        }
        contractSideEffect(_formValues,_formErrors,_formTouched,value);
      }
      break;
      case "contractorName": {
        // we dont need this as this field is readony
        //_formValues[keyTypedVal] = value;
      }
        break;
      case "forestAreaId": {
        _formValues.forestAreaId = value;
        // sideeffect
         forestAreaSideEffect(_formValues,_formErrors,_formTouched,value!=null?value.label:''); // exprecting just one item 
      }
      break;
      case "standbyBase": {
        _formValues.standbyBase = value;
      }
        break;
      case "fieldSupervisor": {
        _formValues.fieldSupervisor = value;
      }
        break;
      case "unitNumber": 
      case "serialNumber": 
      case "equipment":{
        if(_formValues.costSummary!=null && _formValues.costSummary.length && !wdpUtil.isNullOrEmpty(_formValues.costSummary[0].rateType) ){
          setShowChangeEquipWarningModal({who:who,value:value});
        }else{
          _formValues[keyTypedVal] = value;
          equSideEffect(who, value, _formValues,_formErrors,_formTouched);
        }
      }
      break;
      case "addOns":{
        _formValues[keyTypedVal] = value;
        equSideEffect(who, value, _formValues,_formErrors,_formTouched);
      }
      break;
      
      default: {
        ////////////////////////////////////////
        /** Cost Summary Section fields **/
        // NOTE: just for AutoComplete, the vlaue is object of {lable and vlaue}

        if (who!.includes("costSummary")) {
          const parts = who!.split('-');
          const whowho: string = parts[1];
          const recIndex = wdpUtil.safeParse(parts[2]);
          const csRecVals     = _formValues.costSummary![recIndex];
          const csRec_err     = _formErrors.costSummary![recIndex];
          const csRec_touched = _formTouched.costSummary![recIndex];
          //const _autoCompleteCtrlRec = autoCompleteCtrl[index];
          switch (whowho) {
            case "fireNumber": {
              csRecVals.fireNumber = value;
              defaultCostActivityField(recIndex,_formValues,_formErrors,_formTouched);
              defaultInternalOrderFieldSync(recIndex,_formValues,_formErrors,_formTouched);
           
              // let err = validateField(whowho,csRecVals.fireNumber,{recIndex:recIndex,rec:csRecVals});
              // _formErrors.costSummary[recIndex].fireNumber = err;
              // _formTouched.costSummary[recIndex].fireNumber = "T";
              // updateFormCtrl(_formValues, _formErrors, _formTouched);
              // return ;
            }
            break;
            case "rateType": {
              // prevent duplicate 
              // if(costEntryExist()){
              // //coming soon  
              // }
              csRecVals.rateType        = value;
              
              // reset all the related fields
              csRecVals.costActivityCode= null;
              csRecVals.rateUnit        = null;
              csRecVals.noOfUnits       = "0.00";
              csRecVals.ratePerUnit     = "";
              csRecVals.amount          = "";

              defaultNoOfUnitsField(recIndex,_formValues,_formErrors,_formTouched);

              // default the related fields
              defaultCostActivityField(recIndex,_formValues,_formErrors,_formTouched);
              defaultUnitField(recIndex,_formValues,_formErrors,_formTouched);
              defaultRatePerUnitField(recIndex,_formValues,_formErrors,_formTouched);
              // recalc the amount
              reCalcCost(recIndex,_formValues,_formErrors,_formTouched );
            }
            break;
            case "costActivityCode": {
              csRecVals.costActivityCode = value;
            }
            break;
            case "noOfUnits": {
              //const numericValue  = value?.replace(/[^0-9.]/g, '') ?? '';
              const numericValue  = wdpUtil.restrictDecimalInput(value, 2, 4);
              csRecVals.noOfUnits = numericValue;//wdpUtil.formatValFLoat(numericValue);
              // sideEffect2 update the amount and set the ratePerUnit 
              reCalcCost(recIndex,_formValues,_formErrors,_formTouched);
            }
              break;
            case "rateUnit": {
              csRecVals.rateUnit = value;
              // sideEffect2 update the amount and set the ratePerUnit 
              const rpu =  TicketService.getRate4RateTyle(myAppCtx?.lookups,resourceSnapshotRawJsonFromFires,(csRecVals!.rateType as GenListType),value, TicketService.packageEquInfo(_formValues));
              csRecVals.ratePerUnit = wdpUtil.formatValFloat(rpu);
              logRateLookup(csRecVals, _formValues, "rate unit selection", rpu, value);

              reCalcCost(recIndex,_formValues,_formErrors,_formTouched);
              

            }
            break;
            case "ratePerUnit": {
              //const numericValue  = value?.replace(/[^0-9.]/g, '') ?? '';
              const numericValue  = wdpUtil.restrictDecimalInput(value, 2, 4);
              csRecVals.ratePerUnit = numericValue;//wdpUtil.formatValFLoat(numericValue);
              // sideEffect2 update the amount and set the ratePerUnit 
              reCalcCost( recIndex,_formValues,_formErrors,_formTouched);
            }
            break;
            case "internalOrder": {
              csRecVals.internalOrder = value;
            }
            break;
            case "costCenter": {
              csRecVals.costCenter = value;
              appLog.debug(`costCenter changed to ${JSON.stringify(value)}`);
            }
            break;
            default: {
              if (csRecVals!=null) {
                (csRecVals[whowho as keyof typeof csRecVals] as any) = value;
              }
            }
          }//swich
          // validate .. because in some senarios we set default values for some fields
          // comment out ..onSave we will do validation 
          // validateCostSummaryTable(_formValues,_formErrors,_formTouched);
        }
      }
        break;
    }//first witch

    //------------------------
    // ready to update
    updateFormCtrl(_formValues, _formErrors, _formTouched);
    //update  Auto Complete
    // ...
  }
/********************************************************************************************
   * 
  ********************************************************************************************/
  function contractSideEffect( _formValues: TicketInfo_ui,_formErrors:TicketInfo_ui,_formTouched:TicketInfo_ui, value: GenListType ) {
    
    //1- resdet dependencies
    _formValues.contractorName= "";
    _formValues.standbyBase   = "";
    _formValues.fieldSupervisor = "";
    _formValues.forestAreaId  = null;
    _formValues.unitNumber    = null;
    _formValues.serialNumber  = null;
    _formValues.equipment     = null;
    _formValues.addOns        = null;

    
    // 2 set the Contractor Name

    if(value!=null){
      const found = contractInfoList.find((e:FireContractInfo) => e.contractNumber === value?.value);
      
      _formValues.contractorName= found!=null? found.name1:"";
      // Clear errors for fields that are being reset, but don't mark as touched
      // The user hasn't interacted with these fields yet
      _formErrors.forestAreaId  = "";
      _formErrors.contractorName= "";
      _formErrors.unitNumber    = "";
      _formErrors.serialNumber  = "";
      _formErrors.equipment     = "";
      
      //3- load from FIRE
      loadResourceSnapshotRawJsonFromFires(value.value, _formValues.date);
    }
    //4- changing the contract number means reset everything including the cost summary table
    resetCostSummary(_formValues ,_formErrors,_formTouched);
  }
  /********************************************************************************************
   * 
  ********************************************************************************************/
  function equSideEffect(who: string, _value:GenListType|null|string , _formValues: TicketInfo_ui,_formErrors:TicketInfo_ui,_formTouched:TicketInfo_ui) {
    
    const findAndUpdate =() =>{
      const rawRec = findRecordinFiresLookups(resourceSnapshotRawJsonFromFires, who, _value!=null? (_value as GenListType).value:'');
      
      
      _formValues.unitNumber  = rawRec? {label:rawRec.unitNumber,   value:rawRec.unitNumber}:null;
      _formValues.serialNumber= rawRec? {label:rawRec.serialNumber, value:rawRec.serialNumber}:null;
      _formValues.equipment   = rawRec? {label:rawRec.description,  value:rawRec.equipmentId.toString()}:null;
      
      let addOns_GoodOptsList =  TicketService.extractAddOnsFromFires(resourceSnapshotRawJsonFromFires,TicketService.packageEquInfo(_formValues));
      // default AddOns if the list has just one item
      _formValues.addOns      = (addOns_GoodOptsList!=null && addOns_GoodOptsList.length==1)? addOns_GoodOptsList[0]:null;
      
      
      costSummarySideEffect(_formValues ,_formErrors,_formTouched);  
      
      // Clear errors for auto-populated fields, but don't mark as touched
      _formErrors.unitNumber  = "";
      _formErrors.serialNumber= "";
      _formErrors.equipment   = "";
      _formErrors.addOns      = "";
    } 
    
    if(['unitNumber','serialNumber','equipment'].includes(who)){
      findAndUpdate();
    }
    else if(who=='addOns'){
      costSummarySideEffect(_formValues ,_formErrors,_formTouched);
    }
  }
  function logRateLookup(
    row: CostSummary_ui,
    values: TicketInfo_ui,
    source: string,
    foundRatePerUnit: string | number | null | undefined,
    foundRateUnit: GenListType | string | null | undefined = row.rateUnit
  ) {
    const describeSelection = (selection: GenListType | string | null | undefined) => {
      if (selection == null || selection === "") {
        return null;
      }
      return typeof selection === "string"
        ? selection
        : { label: selection.label, value: selection.value };
    };
    const rateType = row.rateType as GenListType | null;
    const isFiresRate = rateType != null && wdpUtil.inListCI(rateType.label, RatesFromFires);
    const unitNotFound = foundRateUnit == null || foundRateUnit === "";
    const noAddOnRateFallback = isFiresRate && values.addOns == null && (foundRatePerUnit === "0.00" || foundRatePerUnit === 0);
    const rateNotFound = foundRatePerUnit == null || foundRatePerUnit === "" || noAddOnRateFallback;
    const rateNotFoundReason = !rateNotFound
      ? undefined
      : source.includes("fallback")
        ? "No configured domain rate was found for the selected rate type."
        : isFiresRate && values.addOns == null
          ? "No add-on is selected, so this flow returns 0.00 without matching a FIRES rate."
          : "No rate value was found for the selected rate type, unit, and add-on.";

    appLog.info("[Rate lookup]", {
      source,
      selectedContract: describeSelection(values.contractNumber),
      selectedUnit: describeSelection(values.unitNumber),
      selectedEquipment: describeSelection(values.equipment),
      selectedAddOns: describeSelection(values.addOns),
      selectedWorkPerformedEntry: describeSelection(row.workPerformedType),
      selectedRateType: describeSelection(row.rateType),
      foundRateUnit: describeSelection(foundRateUnit),
      foundRatePerUnit: foundRatePerUnit ?? null,
      ...(unitNotFound && {
        unitNotFoundReason: "No unit was resolved; the available options may be empty or require a selection.",
      }),
      ...(rateNotFound && { rateNotFoundReason }),
    });
  }
  /********************************************************************************************
   * 
  ********************************************************************************************/
  function costSummarySideEffect(_formValues: TicketInfo_ui,_formErrors: TicketInfo_ui,_formTouched: TicketInfo_ui){
   
    for(let i=0;i<_formValues.costSummary!.length;i++){
      // this change will effect the entries that have rate type  from FIRES
      const csRec = _formValues?.costSummary![i!];
      const myRateType = csRec.rateType as GenListType;
      if(myRateType!=null){ //row has a rate type
        // is it from FIRES 
        if (wdpUtil.inListCI(myRateType.label, RatesFromFires)) {
          
          // get the new Rate per unit ..considering the selected new AddOns  and then re calc the cost
          // cs.ratePerUnit = TicketService.getRate4RateTyle(myAppCtx?.lookups,resourceSnapshotRawJsonFromFires,(cs!.rateType as GenListType),(cs!.rateUnit as GenListType), packageEquInfo(_formValues));
          
          const units:GenListType[] = TicketService.getUnits4RateTyle(myAppCtx?.lookups,resourceSnapshotRawJsonFromFires,myRateType, TicketService.packageEquInfo(_formValues));
          if((units!=null && units.length>0)){
            if(_formValues.addOns!=null){
              csRec.rateUnit = units[0];
              
              // then we can get the rate per unit
              const rpu =  TicketService.getRate4RateTyle(myAppCtx?.lookups,resourceSnapshotRawJsonFromFires,myRateType,(csRec.rateUnit as GenListType), TicketService.packageEquInfo(_formValues));
              csRec.ratePerUnit = wdpUtil.formatValFloat(rpu);
              logRateLookup(csRec, _formValues, "equipment/add-on change", rpu, csRec.rateUnit);
            }else{
              csRec.rateUnit=null;
              csRec.ratePerUnit="0.00";
              logRateLookup(csRec, _formValues, "equipment/add-on change (no add-on selected)", null, null);
            }
          }
          
          // Don't mark as touched - this is a side effect from equipment changes
          validateCostSummaryTable(_formValues,_formErrors,_formTouched,undefined,false);
          reCalcCost(i,_formValues,_formErrors,_formTouched );
        }
      }
    }
  }
  /********************************************************************************************
   * Applies the rate-type defaulting chain (cost activity, unit, rate per unit, amount,
   * validation) to a cost summary row. NOTE: this is NOT wired to the user-facing "rateType"
   * dropdown in onMyChange (that case inlines the same steps itself); rateTypeSideEffect is
   * only invoked when a row is created/re-added programmatically with a rate type already set -
   * e.g. syncing Travel/Meal/Lodging entries from their sections, or re-adding a rate type row
   * after it was removed by onDelCostSummary.
  ********************************************************************************************/
  function rateTypeSideEffect(index: number,newRateType: any,formValues: TicketInfo_ui,formErrors: TicketInfo_ui,formTouched: TicketInfo_ui) {
    const row         = formValues.costSummary[index];
    const rowErr      = formErrors.costSummary[index];
    const rowTouched  = formTouched.costSummary[index];
    
    // if(newRateType==="etc"){
    // special condtion (ifany)
    // }
    // 2. Default dependent fields
    defaultCostActivityField(index, formValues, formErrors, formTouched);
    defaultUnitField(index, formValues, formErrors, formTouched);
    defaultRatePerUnitField(index, formValues, formErrors, formTouched);

    // 3. Recalculate amount
    reCalcCost(index, formValues, formErrors, formTouched);

    // 4. Validate the entire table
    validateCostSummaryTable(formValues, formErrors, formTouched);
  }
  /********************************************************************************************
   * NOTE: caaller will do the update
  ********************************************************************************************/
  function defaultCostActivityField(recIndex:number, _formValues: TicketInfo_ui,_formErrors:TicketInfo_ui,_formTouched:TicketInfo_ui) {
    
    
    const myRateType    = _formValues.costSummary[recIndex].rateType as GenListType;
    const myfireNumber  = _formValues.costSummary[recIndex].fireNumber as GenListType;
    // no rateType no default for ActvitiyCode
    if(wdpUtil.isNullOrEmpty(myRateType)) return;

    // Fuel surcharge should follow the activity from the single Standard row when present.
    if(myRateType!=null && wdpUtil.strEqual(myRateType.label, RateType_FuelSurcharge)){
      const standardEntries = _formValues.costSummary.filter((rec: CostSummary_ui) => wdpUtil.strEqual(((rec.rateType as GenListType | null)?.label) ?? "", RateType_Standard));
      if (standardEntries.length === 1 && !wdpUtil.isNullOrEmpty(standardEntries[0].costActivityCode)) {
        _formValues.costSummary[recIndex].costActivityCode = standardEntries[0].costActivityCode;
        return;
      }
    }
      
    let goodOpts = TicketService.getCostActivity4RateTypeId(myAppCtx?.lookups, myRateType.value);
    if(wdpUtil.isNullOrEmpty(myfireNumber)){
      goodOpts=goodOpts.filter((e:GenListType) => e.label.toUpperCase().startsWith("FP",0));
    }else{
      goodOpts=goodOpts.filter((e:GenListType) => e.label.toUpperCase().startsWith("FS",0));
    }
    if(goodOpts && goodOpts.length){
      if(goodOpts.length==1){
        _formValues.costSummary[recIndex].costActivityCode = goodOpts[0];
      }else{
        // remove the invalid selection  (ifany)
        const activityCode = wdpUtil.getFormFieldVal(_formValues.costSummary[recIndex].costActivityCode,true);
        if(activityCode){
            const isCurAcodeFS = activityCode.toUpperCase().startsWith("FS",0);
            if( isCurAcodeFS && wdpUtil.isNullOrEmpty(_formValues.costSummary[recIndex].fireNumber) ){
              _formValues.costSummary[recIndex].costActivityCode=null;
            }
            if( !isCurAcodeFS && !wdpUtil.isNullOrEmpty(_formValues.costSummary[recIndex].fireNumber) ){
              _formValues.costSummary[recIndex].costActivityCode=null;
            }  
        }else{
          // more than one option in the list, dont default anything
        }
      }
    }
    // vaidate the field
    // comment out ..we wil do validation onSave
    // let err = validateField("costActivityCode",csRecVals.costActivityCode,{recIndex:recIndex,rec:csRecVals});
    // _formErrors.costSummary[recIndex].costActivityCode = err;
    // _formTouched.costSummary[recIndex].costActivityCode = "T";
  }
  /********************************************************************************************
  ********************************************************************************************/
  function defaultUnitField(recIndex:number, _formValues: TicketInfo_ui,_formErrors:TicketInfo_ui,_formTouched:TicketInfo_ui) {
    const csRecVals   = _formValues.costSummary[recIndex];
    const myRateType  = csRecVals.rateType as GenListType;
    let goodOpts:GenListType[]=[];

    // Rows generated from the "Work performed" section always carry a duration in hours
    // (see recalcNoOfUnits in WorkInfo.tsx), so the unit must always default to "hour" -
    // regardless of rate type. Skipping this and falling through to getUnits4RateTyle below
    // would return the full (unfiltered, ambiguous) costRateUnitList whenever the equipment
    // has no addOns selected, so the unit would silently stay blank instead of defaulting.
    if (!wdpUtil.isNullOrEmpty(csRecVals.workPerformedType ?? null)) {
      const hourOpt = myAppCtx?.lookups?.costRateUnitList?.find((e: GenListType) => wdpUtil.strEqual(e.label, "hour"));
      if (hourOpt) {
        csRecVals.rateUnit = hourOpt;
        return;
      }
    }

    if(myRateType!=null && wdpUtil.strEqual(myRateType.label, RateType_FuelSurcharge)){
      goodOpts = getUnits4RateTyle_FuelSurcharge(recIndex,_formValues);
    }else{
      goodOpts = TicketService.getUnits4RateTyle(myAppCtx?.lookups,resourceSnapshotRawJsonFromFires,csRecVals.rateType as GenListType, TicketService.packageEquInfo(_formValues));
    }

    if((goodOpts!=null && goodOpts.length>0)){
      //if(formCtrl.values.addOns!=null){
        if(goodOpts && goodOpts.length===1){
          csRecVals.rateUnit = goodOpts[0];
        }
      //}
    }
  }
  /********************************************************************************************
  ********************************************************************************************/
  function getUnits4RateTyle_FuelSurcharge(recIndex:number, _formValues: TicketInfo_ui){
    const csRecVals = _formValues.costSummary[recIndex];
    let goodOpts:GenListType[] = TicketService.getUnits4RateTyle(myAppCtx?.lookups,resourceSnapshotRawJsonFromFires,csRecVals.rateType as GenListType, TicketService.packageEquInfo(_formValues));

    const standardEntries = _formValues.costSummary.filter((rec: CostSummary_ui) => wdpUtil.strEqual(((rec.rateType as GenListType | null)?.label) ?? "", RateType_Standard));
    if (standardEntries.length === 1) {
      const allUnitOpts = TicketService.extractGoodUnitsForRateType(myAppCtx?.lookups?.genericRelationsList ?? [], null).map((opt) => ({ label: opt.lookupLabel.toLowerCase(), value: opt.lookupLabel.toLowerCase() }));
      const hourOpt = allUnitOpts.find((opt: GenListType) => wdpUtil.strEqual(opt.label, "hour"));
      goodOpts = hourOpt ? [hourOpt] : [];
    }

    return goodOpts;
  }
  /********************************************************************************************
  ********************************************************************************************/
  function defaultNoOfUnitsField(recIndex:number, _formValues: TicketInfo_ui,_formErrors:TicketInfo_ui,_formTouched:TicketInfo_ui) {
    const csRecVals = _formValues.costSummary[recIndex];
    const myRateType = csRecVals.rateType as GenListType;

    if (myRateType != null && wdpUtil.includesIgnoreCase([...MealCostRateType,...LodgingCostRateType], myRateType.label)) {
      csRecVals.noOfUnits = "1.00";
      return;
    }

    if(myRateType!=null && wdpUtil.strEqual(myRateType.label, RateType_FuelSurcharge)){
      const standardEntries = _formValues.costSummary.filter((rec: CostSummary_ui) => wdpUtil.strEqual(((rec.rateType as GenListType | null)?.label) ?? "", RateType_Standard));
      if (standardEntries.length === 1) {
        const standardNoOfUnits = standardEntries[0].noOfUnits;
        csRecVals.noOfUnits = wdpUtil.isNullOrEmpty(standardNoOfUnits) ? "0.00" : wdpUtil.formatValFloat(standardNoOfUnits);
      }
      return;
    }
  }
  /********************************************************************************************
  ********************************************************************************************/
  function defaultRatePerUnitField(recIndex:number, _formValues: TicketInfo_ui,_formErrors:TicketInfo_ui,_formTouched:TicketInfo_ui) {
    const csRecVals = _formValues.costSummary[recIndex];

    const myRateType = csRecVals.rateType as GenListType;
    if(myRateType!=null && wdpUtil.strEqual(myRateType.label, RateType_FuelSurcharge)){
      const rpuList:GenListType[] = TicketService.getRate4FuelSurcharge(myAppCtx?.lookups,resourceSnapshotRawJsonFromFires, TicketService.packageEquInfo(_formValues));
      csRecVals.ratePerUnit = (wdpUtil.isNullorUndefined(rpuList) || rpuList.length===0) ? "0.00" : wdpUtil.formatValFloat(rpuList[0].value);
      logRateLookup(csRecVals, _formValues, "fuel surcharge rate lookup", rpuList[0]?.value ?? null);
      return;
    }

    //if(formCtrl.values.addOns!=null){
    const rpu =  TicketService.getRate4RateTyle(myAppCtx?.lookups,resourceSnapshotRawJsonFromFires,csRecVals.rateType as GenListType,(csRecVals!.rateUnit as GenListType), TicketService.packageEquInfo(_formValues));
    //}

    // getRate4RateTyle returns "0.00" whenever the equipment's addOns is null (no add-ons
    // available, or 2+ ambiguous options the user hasn't picked between) - Work Performed rows
    // never go through an addOns selection at all, so this hit on virtually every such row.
    // Fall back to the domain-configured TimeTrakingCost default (same source used for non-FIRES
    // rate types) rather than leaving the rate hard-coded at 0.
    if (!wdpUtil.isNullOrEmpty(csRecVals.workPerformedType ?? null) && (wdpUtil.isNullOrEmpty(rpu) || Number(rpu) === 0)) {
      const domainRate = myAppCtx?.lookups?.costRateTypeList?.find((e: CostRateTypeFromDomain) => e.LookupId?.toString() === myRateType?.value)?.TimeTrakingCost ?? null;
      csRecVals.ratePerUnit = wdpUtil.isNullOrEmpty(domainRate) ? "0.00" : wdpUtil.formatValFloat(domainRate);
      logRateLookup(csRecVals, _formValues, "work performed domain-rate fallback", domainRate);
      return;
    }

    csRecVals.ratePerUnit = wdpUtil.formatValFloat(rpu);
    logRateLookup(csRecVals, _formValues, "rate type lookup", rpu);
  }
  /********************************************************************************************
   * : Fire number: SWF001 - 2025 therefore Internal Order = FFSWF00125
  ********************************************************************************************/
  async function defaultInternalOrderFieldSync(recIndex:number, _formValues: TicketInfo_ui,_formErrors:TicketInfo_ui,_formTouched:TicketInfo_ui) {
    
    const patch = {
      inputValue: { internalOrder: "" },
      options: { internalOrder: [] as GenListType[] },
      attrs: { internalOrder: { matchFireNo: false } }
    };

    if(!wdpUtil.isNullorUndefined(_formValues.costSummary[recIndex])){
      const fNoLabel =  wdpUtil.getFormFieldVal(_formValues.costSummary[recIndex].fireNumber,true);
      if(!wdpUtil.isNullorUndefined(fNoLabel) && !wdpUtil.isNullOrEmpty(fNoLabel)){
        const parts = fNoLabel.split('-');
        if(parts && parts.length===2){
          const identifier = parts[0].trim();
          const year = parts[1].trim();
          //const qStr= `FF${code}${year.substring(2)}`;
          //const qStr= `${identifier}${year.substring(2)}`;
          const qStr= `FF${identifier}${year.substring(2)}`;
          //loadInternalOrderCodes(qStr, recIndex,{values:_formValues,errors:_formErrors,touched:_formTouched});
          
          _formValues.costSummary[recIndex].internalOrder   = null;
          //_formErrors.costSummary[recIndex].internalOrder   = "";
          //_formTouched.costSummary[recIndex].internalOrder  = "T";
          // query the backend
          const res = await loadInternalCodesAsync( qStr);
          if (res!=null && Array.isArray(res) && res.length>0) {
            const sorted  = wdpUtil.sortOptList("internalOrder", res);
            const goodList= sorted.map(x => ({label: `${x.internalOrderDescription?.trimStart()} - ${x.internalOrder}`,value: x.internalOrder}));
            if(goodList && goodList.length>0){
              patch.inputValue  = { internalOrder: goodList[0].label };
              patch.options     = { internalOrder: goodList};
              patch.attrs       = { internalOrder: {matchFireNo:true} };
                
              
              // note: we might need to set the firenumber here because at this moment  onMyChange event is calling updateFormCtrl with the old value of fireNumber  
              // update form values...
              // _formValues.costSummary[recIndex].fireNumber = fireNo;
              // _formValues.costSummary[recIndex].fireNumber = "";
              // _formValues.costSummary[recIndex].fireNumber = "T";
              _formValues.costSummary[recIndex].internalOrder   = goodList[0];
            }
          }
        }
      }
    }
    updateAutoCompleteCtrl(recIndex, patch);
    // vaidate the field
    // comment out ..we wil do validation onSave
    // let err = validateField("internalOrder",_formValues.costSummary[recIndex].internalOrder,{recIndex:recIndex,rec:_formValues.costSummary[recIndex]});
    // _formErrors.costSummary[recIndex].internalOrder = err;
    // _formTouched.costSummary[recIndex].internalOrder = "T";
  }
  /********************************************************************************************
  ********************************************************************************************/
  function onConfirmChangeEqu(obj:{who:string,value:any}|null){
    
    // hide the popup first
    setShowChangeEquipWarningModal(null);

    // update the fields
    const _formValues:TicketInfo_ui  = wdpUtil.deepCopy(formCtrl.values);
    const _formErrors:TicketInfo_ui  = wdpUtil.deepCopy(formCtrl.errors);
    const _formTouched:TicketInfo_ui = wdpUtil.deepCopy(formCtrl.touched);
    
    
    if(obj!=null){
      const keyTypedVal   = obj.who as keyof typeof formCtrl.values;
      const keyTypedErr   = obj.who as keyof typeof formCtrl.errors;
      const keyTypedTouch = obj.who as keyof typeof formCtrl.touched;
      
      (_formValues[keyTypedVal] as any) = obj.value as GenListType;
      equSideEffect(obj.who, obj.value, _formValues,_formErrors,_formTouched);
    }
    
    // reset cost summary
    resetCostSummary(_formValues ,_formErrors,_formTouched);
    
    // ready to update FormControl
    updateFormCtrl(_formValues , _formErrors, _formTouched);

  }
  /********************************************************************************************
  ********************************************************************************************/
  // function onConfirmDuplicateTicket(){
  //   // update the fields
  //   const _formErrors:TicketInfo_ui  = wdpUtil.deepCopy(formCtrl.errors);
  //   (_formErrors.ticketNumber   as string) = "";
    
  //   // ready to update FormControl
  //   updateFormCtrl(null , _formErrors, null);
  //   const parts = showDuplicateTicketWarningModal.split('-');
  //   const exemptTicket = (parts && parts.length===2)?parts[1]:"";
    
  //   setShowDuplicateTicketWarningModal( `confirmed-${exemptTicket}`);
  // }
  /********************************************************************************************
   // this will recalc the rate per unit it might effect one or more
  ********************************************************************************************/
  // function costSideEffect( _formValues: TicketInfo_ui,_formErrors:TicketInfo_ui,_formTouched:TicketInfo_ui, value: GenListType,recIndex:number){
  // }
  /********************************************************************************************
   * call this function when user change AddOns, rate type, rate unit, no of Uint
  ********************************************************************************************/
  function reCalcCost(recIndex:number,_formValues:TicketInfo_ui ,_formErrors:TicketInfo_ui,_formTouched:TicketInfo_ui ) {
    
    if(_formValues.costSummary===null){
      return 0;
    }
      // we need no of units  
      const noUnits = _formValues.costSummary![recIndex].noOfUnits;
      // find the Rate per Unit and set it  and then cac the amount and set it 
      const cs = _formValues.costSummary![recIndex];
      // do we 

      let rpu = _formValues.costSummary![recIndex].ratePerUnit;
      if(wdpUtil.isNullorUndefined(rpu) || rpu === ''){
        rpu = TicketService.getRate4RateTyle(myAppCtx?.lookups,resourceSnapshotRawJsonFromFires,(cs!.rateType as GenListType),(cs!.rateUnit as GenListType), TicketService.packageEquInfo(_formValues));
        logRateLookup(cs, _formValues, "cost recalculation fallback", rpu);
      }

      if(rpu!=null){
        _formValues.costSummary![recIndex].ratePerUnit  = rpu;
        _formErrors.costSummary![recIndex].ratePerUnit  = ''; 
        _formTouched.costSummary![recIndex].ratePerUnit = '';

        _formValues.costSummary![recIndex].amount  = wdpUtil.calcCost(wdpUtil.safeParse(rpu,{type:"float"}),wdpUtil.safeParse(noUnits,{type:"float"})).toString();
        _formErrors.costSummary![recIndex].amount  = ''; 
        _formTouched.costSummary![recIndex].amount = '';

      }else{
        _formValues.costSummary![recIndex].ratePerUnit = '';
        _formValues.costSummary![recIndex].amount = ''
      }
  }
  

  /********************************************************************************************
   *  Validation will take place onBlue event
  ********************************************************************************************/
  function onMyBlur(who: string, value: any) {
    
    //console.log(`onMyBlur who: ${who} value: ${value}`);
    
    let updateVal = false;
    // make a copy
    const _formValues:TicketInfo_ui  = wdpUtil.deepCopy(formCtrl.values);
    const _formErrors:TicketInfo_ui  = wdpUtil.deepCopy(formCtrl.errors);
    const _formTouched:TicketInfo_ui = wdpUtil.deepCopy(formCtrl.touched);
    const keyTypedVal = who as keyof typeof formCtrl.values;
    const keyTypedErr = who as keyof typeof formCtrl.errors;
    const keyTypedTouch = who as keyof typeof formCtrl.touched;


    let fldErr = '';


    //1- VALIDATION
    if (who.includes("costSummary")) {

      // flag it as touched  
      const nestProps = who.split('-');
      const whowho = nestProps[1];
      const rowIndex = wdpUtil.safeParse(nestProps[2]);

      const csRec=_formValues.costSummary[rowIndex];
      
      
      // special case after the validation
      if(whowho === "costActivityCode"){
        const fireNo =_formValues.costSummary[rowIndex].fireNumber;
      
      }

      // transformation and data format goes here
      if(whowho === "noOfUnits"){
        _formValues.costSummary[rowIndex].noOfUnits = wdpUtil.formatValFloat(_formValues.costSummary[rowIndex].noOfUnits);
        updateVal=true;
      }
      if( whowho === "ratePerUnit"){
        _formValues.costSummary[rowIndex].ratePerUnit = wdpUtil.formatValFloat(_formValues.costSummary[rowIndex].ratePerUnit);
        updateVal=true;
      }
      // End of Data format
      
      // now do the validation
      // Only mark THIS specific field as touched, not all fields in the row
      const fieldValue = _formValues.costSummary[rowIndex][whowho as keyof CostSummary_ui];
      const fieldError = validateField(whowho, fieldValue as string | GenListType | null, {recIndex: rowIndex, rec: csRec});
      ((_formErrors.costSummary[rowIndex] as CostSummary_ui)[whowho as keyof CostSummary_ui] as string) = fieldError;
      ((_formTouched.costSummary[rowIndex] as CostSummary_ui)[whowho as keyof CostSummary_ui] as string) = "T";
    }
    else {
      // flag it as touched and do the validation
      fldErr=validateField(who,value);
      // special case after the validation
      if(who === "ticketNumber" && (fldErr=='')){
        
         if (value.startsWith("e")) {
          value = "E" + value.slice(1);
          _formValues.ticketNumber=value;
          updateVal=true;
        }
        //if(showDuplicateTicketWarningModal==='' || !showDuplicateTicketWarningModal.includes(`confirmed-${value}`)){
        if(pageStatus.updateFlow===false || (pageStatus.editModeBySection.basic && !wdpUtil.strEqual(value,orginalData.current.ticketNumber)) ){
          ApiService.isTicketExist(auth.user?.access_token as string, value).then(res => {
            if(res.exists==true){
              _formErrors.ticketNumber  = ""; //appStrings.ticketExists;
              _formTouched.ticketNumber = "T";
              // ready to update FormControl
              updateFormCtrl(updateVal ? _formValues : null, _formErrors, _formTouched);
              setShowDuplicateTicketWarningModal(true);
            }
          });
        }
      }
      // if(who === "date" && (fldErr!='')){
      // }
      (_formErrors[keyTypedErr] as string) = fldErr;
      (_formTouched[keyTypedTouch] as string) = "T";
    }

    // ready to update FormControl
    updateFormCtrl(updateVal ? _formValues : null, _formErrors, _formTouched);
  }
  /********************************************************************************************
   * 
  ********************************************************************************************/
  function renderField(who: string, fieldLabel: string, helpTxt: string = "", placeholder: string = "", req: boolean = true) {

    let fldJsx: any;

    const fldVal = getFldCtrInfo('value', who);
    const fldErr = getFldCtrInfo('error', who) as string;
    const fldTouch = getFldCtrInfo('touched', who) as string;

    const width = '100%';
    //const editMode = pageStatus.editPage;

    // formItem Attributes
    const atts: GoabFormItemProps = {
      helpText: helpTxt,
      error: (fldTouch == "T" ? fldErr : ""),
      label: fieldLabel,
      requirement: req ? '' as GoabFormItemRequirement : 'optional' as GoabFormItemRequirement
    }
    const extraAtts: any = {};
    extraAtts.placeHolder = placeholder;
    //atts.requirement= req?'":'optional';
    /////////////////////////////////

    switch (who) {
      // ------------ Basic info Section
      case "ticketNumber":{
        //extrAtts.disabled = pageStatus.updateFlow;
        extraAtts.maxLength = 8;
        extraAtts.pattern = "[Ee][0-9]{7}";
        fldJsx = pageStatus.editModeBySection.basic ? renderTxtField(who, fldVal as string, fldErr as string, fldTouch as string, atts, extraAtts) : renderReadOnlyField(fieldLabel, who, fldVal as string, width);
      }
      break;
      case "date": {
        const dateExtraAtts = { disabled: isEditingSignedOffTicket() };
        fldJsx = pageStatus.editModeBySection.basic ? renderDateField(who, formCtrl.values.date, fldErr, fldTouch, atts, dateExtraAtts) : renderReadOnlyField(fieldLabel, who, formCtrl.values.date as string, width);
      }
      break;
      case "contractNumber": {
        const goodOpts = contractInfoList.map((e:FireContractInfo) =>({label:e.contractNumber,value:e.contractNumber})) || [];  
        fldJsx = pageStatus.editModeBySection.basic ?
          <GoabFormItem {...atts}>
            <Autocomplete className='formField' includeInputInList filterSelectedOptions autoComplete sx={{ width }} id={who} data-testid={`tnc_${who}`} noOptionsText="--type to select--"
              disabled={((wdpUtil.isNullorUndefined(formCtrl.values.date) || formCtrl.values.date?.length==0) || formCtrl.errors.date!='') || ( pageStatus.updateFlow==true) || isEditingSignedOffTicket()}
              renderInput={(params) => <TextField {...params} placeholder="--type to select-- " />}
              getOptionLabel={(option) => typeof option === 'string' ? option : (option.label ?? "")}
              options={goodOpts}
              filterOptions={filterOptionsGenListType}
              value={formCtrl.values.contractNumber as GenListType}
              onChange={(_event: any, item: GenListType | null) => { onMyChange(who, item); }}
              //inputValue    ={formCtrl.values.contractNumberInputValue}
              //onInputChange={(_event, newInputValue) => { onAutoCompleteInputChanged({ who: who, newVal: newInputValue, extra: extrAtts }) }}
              inputValue={contractNumberInputValue}
              onInputChange={(_event, newInputValue) => { onAutoCompleteInputChanged({ who: who, newVal: newInputValue, extra: extraAtts }) }}
              onBlur={(e: any) => onMyBlur(e?.nativeEvent?.target?.id, e?.nativeEvent?.target?.value)}
            />
          </GoabFormItem> : renderReadOnlyField(fieldLabel, who, (fldVal as GenListType)?.label ?? '-', width);
      }
        break;
      case "contractorName": {
        extraAtts.disabled = true;
        
        fldJsx = pageStatus.editModeBySection.basic ? renderTxtField(who, fldVal as string,  fldErr as string, fldTouch as string, atts, extraAtts) : renderReadOnlyField(fieldLabel, who, fldVal as string, width);
      }
      break;
      case "forestAreaId": {
        const goodOpts = myAppCtx?.lookups.forestAreaList || [];
        fldJsx = pageStatus.editModeBySection.basic ?  
        <GoabFormItem {...atts}>
          <Autocomplete className='formField' includeInputInList filterSelectedOptions  autoComplete  sx={{ width }} id={who} data-testid={`tnc_${who}`} noOptionsText="--type to select--" 
            disabled      ={!isCriticalValid()}
            renderInput   ={(params) => <TextField {...params} placeholder="--type to select-- " />}
            getOptionLabel={(option) => typeof option === 'string' ? option : (option.label ?? "")}
            options       ={goodOpts}
            filterOptions ={filterOptionsGenListType}
            value         ={formCtrl.values.forestAreaId as GenListType}
            onChange      ={(_event: any, item: GenListType | null) => { onMyChange(who, item); }}
            inputValue    ={forestAreaIdInputValue}
            onInputChange={(_event, newInputValue) => { onAutoCompleteInputChanged({ who: who, newVal: newInputValue, extra: extraAtts }) }}
            onBlur        ={(e: any) => onMyBlur(e?.nativeEvent?.target?.id, e?.nativeEvent?.target?.value)}
        />
        </GoabFormItem> : renderReadOnlyField(fieldLabel, who, (formCtrl.values.forestAreaId as GenListType)?.label ?? "-", width);   

      }
      break;
      case "standbyBase":{
        extraAtts.disabled = !isCriticalValid();
        fldJsx = pageStatus.editModeBySection.basic ? renderTxtField(who, fldVal as string, fldErr as string, fldTouch as string, atts, extraAtts) : renderReadOnlyField(fieldLabel, who, fldVal as string, width);
      }
      break;
      case "fieldSupervisor":{
        extraAtts.disabled = !isCriticalValid();
        extraAtts.maxLength = 130; // allow more chars (validation will take care of the rest)
        fldJsx = pageStatus.editModeBySection.basic ? renderTxtField(who, fldVal as string, fldErr as string, fldTouch as string, atts, extraAtts) : renderReadOnlyField(fieldLabel, who, fldVal as string, width);
      }
      break;
      case "unitNumber": {
        const goodOpts = resourceSnapshotRawJsonFromFires.map((e: any) => { return { label: e.unitNumber, value: e.unitNumber.toString() } });

        fldJsx = pageStatus.editModeBySection.basic ?
          <GoabFormItem {...atts}>
            <Autocomplete className='formField' filterSelectedOptions sx={{ width }} id={who} data-testid={`tnc_${who}`} noOptionsText="--type to select--"
              disabled={!isCriticalValid() || isEditingSignedOffTicket()}
              renderInput={(params) => <TextField {...params} placeholder="--type to select-- " />}
              getOptionLabel={(option) => typeof option === 'string' ? option : (option.label ?? "")}
              options={goodOpts}
              filterOptions={filterOptionsGenListType}
              value={formCtrl.values.unitNumber as GenListType}
              onChange={(_event: any, item: GenListType | null) => { onMyChange(who, item); }}
              inputValue={unitNumberInputValue}
              onInputChange={(_event, newInputValue) => { onAutoCompleteInputChanged({ who: who, newVal: newInputValue, extra: extraAtts }) }}
              onBlur={(e: any) => onMyBlur(e?.nativeEvent?.target?.id, e?.nativeEvent?.target?.value)}
            />
          </GoabFormItem> : renderReadOnlyField(fieldLabel, who, (fldVal as GenListType)?.label ?? "-", width);
      }
        break;
      case "serialNumber": {
        const goodOpts = resourceSnapshotRawJsonFromFires.map((e: any) => { return { label: e.serialNumber, value: e.serialNumber.toString() } });
        fldJsx = pageStatus.editModeBySection.basic ?
          <GoabFormItem {...atts}>
            <Autocomplete className='formField' filterSelectedOptions sx={{ width }} id={who} data-testid={`tnc_${who}`} noOptionsText="--type to select--"
              disabled={!isCriticalValid() || isEditingSignedOffTicket()}
              renderInput={(params) => <TextField {...params} placeholder="--type to select-- " />}
              getOptionLabel={(option) => typeof option === 'string' ? option : (option.label ?? "")}
              options={goodOpts}
              filterOptions={filterOptionsGenListType}
              value={formCtrl.values.serialNumber as GenListType}
              onChange={(_event: any, item: GenListType | null) => { onMyChange(who, item); }}
              inputValue={serialNumberInputValue}
              onInputChange={(_event, newInputValue) => { onAutoCompleteInputChanged({ who: who, newVal: newInputValue, extra: extraAtts }) }}
              onBlur={(e: any) => onMyBlur(e?.nativeEvent?.target?.id, e?.nativeEvent?.target?.value)}
            />
          </GoabFormItem> : renderReadOnlyField(fieldLabel, who, (fldVal as GenListType)?.label ?? "-", width);
      }
        break;
      case "equipment": {
        const equ_goodOptsList = resourceSnapshotRawJsonFromFires.map((e: any) => { return { label: e.description, value: e.equipmentId.toString() } });
        const goodOpts = wdpUtil.getUniqueByProperty(equ_goodOptsList, "value"); // I odnt know wht the list is has duplicates .. we need to ask FIRES team
        fldJsx = pageStatus.editModeBySection.basic ?
          <GoabFormItem {...atts}>
            <Autocomplete className='formField' filterSelectedOptions sx={{ width }} id={who} data-testid={`tnc_${who}`} noOptionsText="--type to select--"
              disabled={!isCriticalValid() || isEditingSignedOffTicket()}
              renderInput={(params) => <TextField {...params} placeholder="--type to select-- " />}
              getOptionLabel={(option) => typeof option === 'string' ? option : (option.label ?? "")}
              options={goodOpts}
              filterOptions={filterOptionsGenListType}
              value={formCtrl.values.equipment as GenListType}
              onChange={(_event: any, item: GenListType | null) => { onMyChange(who, item); }}
              inputValue={equipmentInputValue}
              onInputChange={(_event, newInputValue) => { onAutoCompleteInputChanged({ who: who, newVal: newInputValue, extra: extraAtts }) }}
              onBlur={(e: any) => onMyBlur(e?.nativeEvent?.target?.id, e?.nativeEvent?.target?.value)}
            />
          </GoabFormItem> : renderReadOnlyField(fieldLabel, who, (formCtrl.values.equipment as GenListType)?.label ?? "-", width);

      }
        break;
      case "addOns": {
        const goodOpts = TicketService.extractAddOnsFromFires(resourceSnapshotRawJsonFromFires,TicketService.packageEquInfo(formCtrl.values));
        //console.log(JSON.stringify(goodOpts));
        //console.log(JSON.stringify(formCtrl.values.addOns));
        fldJsx = pageStatus.editModeBySection.basic ?
          <GoabFormItem {...atts}>
            <Autocomplete className='formField' filterSelectedOptions sx={{ width }} id={who} data-testid={`tnc_${who}`} noOptionsText="--type to select--" 
              disabled={!isCriticalValid() || wdpUtil.isNullorUndefined(formCtrl.values.unitNumber) || wdpUtil.isNullorUndefined(formCtrl.values.equipment) || wdpUtil.isNullorUndefined(formCtrl.values.serialNumber) || isEditingSignedOffTicket()}
              renderInput={(params) => <TextField {...params} placeholder="--type to select-- " />}
              getOptionLabel={(option) => typeof option === 'string' ? option : (option.label ?? "")}
              options={goodOpts}
              filterOptions={filterOptionsGenListType}
              value={formCtrl.values.addOns as GenListType}
              onChange={(_event: any, item: GenListType | null) => { onMyChange(who, item); }}
              inputValue={addOnsInputValue}
              onInputChange={(_event, newInputValue) => { onAutoCompleteInputChanged({ who: who, newVal: newInputValue, extra: extraAtts }) }}
              onBlur={(e: any) => onMyBlur(e?.nativeEvent?.target?.id, e?.nativeEvent?.target?.value)}
            />
          </GoabFormItem> : renderReadOnlyField(fieldLabel, who, (formCtrl.values.addOns as GenListType)?.label ?? "-", width);
      }
        break;

      case "costSummary": {
        fldJsx = formCtrl.values.costSummary?.map((_cs, i) => {
          return <tr key={`costSummary-${i}`}>
            {renderDynamicFld(who, i, "selected")}
            {renderDynamicFld(who, i, "fireNumber")}
            {renderDynamicFld(who, i, "rateType")}
            {renderDynamicFld(who, i, "costActivityCode")}
            {renderDynamicFld(who, i, "noOfUnits")}
            {renderDynamicFld(who, i, "rateUnit")}
            {renderDynamicFld(who, i, "ratePerUnit")}
            {renderDynamicFld(who, i, "amount")}
            {renderDynamicFld(who, i, "internalOrder")}
            {renderDynamicFld(who, i, "costCenter")}
            {renderDynamicFld(who, i, "fund")}
            {renderDynamicFld(who, i, "account")}
            {renderDynamicFld(who, i, "invoiceNo")}
          </tr>
        })//map
      }
        break;



      /////////////////////////////////////
    }//switch
    return fldJsx;
  }
  /********************************************************************************************
  
  *********************************************************************************************/
  function renderDynamicFld(who: string, recIndex: number, fldName: string) {

    const fldVal = getFldCtrInfo('value', who, recIndex, fldName) as GenListType | string;
    const fldErr = getFldCtrInfo('error', who, recIndex, fldName) as string;
    const fldTouch = getFldCtrInfo('touched', who, recIndex, fldName) as string;
    const width = '100%';

    //console.log(`who: ${fldName} val:${fldVal} err: ${fldErr} touched: ${fldTouch}`);
    

    const atts: GoabFormItemProps = {
      error: (fldTouch == "T" ? fldErr : ""),
    }
    const fullId = `${who}-${fldName}-${recIndex}`;


    if (who === "costSummary") {
      //do we have Contract and equpiment info
      const extractCostActivityCode   = (text?: string | null) => (text ?? "").split("-")[0]?.trim() ?? ""; // for cost activity code, the code is the first part of the label
      const extractInternalOrderCode  = (text?: string | null) => (text ?? "").split("-")[1]?.trim() ?? ""; // for internal order, the code is the second part of the label
      const extractCostCenterCode     = (text?: string | null) => (text ?? "").split("-")[1]?.trim() ?? ""; // for cost center, the code is the second part of the label
      
      const currentCsRow              = formCtrl.values.costSummary![recIndex];
      const selectedRateType          = currentCsRow.rateType as GenListType | null;
      const lockedRateTypes           = [...TravelCostRateType, ...MealCostRateType, ...LodgingCostRateType];
      const isLockedRateType          = TicketService.isManagedCostSummaryRateType(selectedRateType, currentCsRow.workPerformedType);
      // Lines already tied to an invoice are immutable in the UI, regardless of section edit mode.
      const isInvoicedRow             = !wdpUtil.isNullorUndefined(currentCsRow.invoiceId) && currentCsRow.invoiceId !== '';
      const canEditRow                = pageStatus.editModeBySection.costSummary === true && !isInvoicedRow
        && canEditCostSummaryField(ticketPermissions, fldName);

      const extrAtts = { type:'text',placeHolder:'',noOptionsText: "--type to select--", recIndex: recIndex, InputProps: {}, disabled: !isBasicInfoValid() };
      if (fldName === "selected") {
        if (pageStatus.editModeBySection.costSummary !== true) {
          return <td className='rowChkBox col-select'></td>;
        }
        const selectedAtts = {
          ...extrAtts,
          disabled: extrAtts.disabled 
          || !canManageCostSummaryRows(ticketPermissions)
          || isInvoicedRow
          || TicketService.isManagedCostSummaryRateType(currentCsRow.rateType as GenListType | string | null, currentCsRow.workPerformedType)
        };
        return <td className='rowChkBox col-select'>{renderCheckBox(fullId, fldVal, fldErr, fldTouch, atts,selectedAtts)} </td>
      }
      /////////////////////////////
      if (fldName === "fireNumber") {
        //let goodOpts = autoCompleteOptionsCtrl[recIndex]?.fireNumber ?? [];
        let goodOpts = autoCompleteCtrl.options[recIndex].fireNumber ?? [];
        return <td className="col-fireNumber">
          {canEditRow ?
            <GoabFormItem {...atts}>
              <Autocomplete className='formField' filterSelectedOptions autoComplete sx={{ width }} id={fullId} data-testid={`tnc_${fullId}`} noOptionsText="--type to select--" disabled={extrAtts.disabled}
                renderInput={(params) => <Tooltip placement='top' arrow title={(fldVal as GenListType)?.label}><TextField {...params} placeholder="--type to select-- " /></Tooltip>}
                getOptionLabel={(option) => typeof option === 'string' ? option : (option.label ?? "")}
                options={goodOpts ? goodOpts : []}
                filterOptions={filterOptionsGenListType}
                value={formCtrl.values.costSummary![recIndex].fireNumber as GenListType}
                onChange={(_event: any, item: GenListType | null) => { onMyChange(fullId, item); }}
                //inputValue={autoCompleteCtrl.input![recIndex]?.fireNumber ?? ''}
                onInputChange={(_event, newInputValue,reason) => { 
                  if (reason === "reset") {
                    //return; // Ignore programmatic resets
                  }
                  onAutoCompleteInputChanged({ who: fullId, newVal: newInputValue, extra: extrAtts }) 
                }}
                onBlur={(e: any) => onMyBlur(e?.nativeEvent?.target?.id, e?.nativeEvent?.target?.value)}
              /></GoabFormItem> : <span>{fldVal?(fldVal as GenListType).label:null}</span>
          }
        </td>
      }
      ///////////////////////////// 
      if (fldName === "rateType") {
        // render the rate type
        //const goodOpts: GenListType[] = autoCompleteOptionsCtrl[recIndex].rateType!;
        //const goodOpts: GenListType[] = myAppCtx?.costRateTypeList ??[];
        const allRateTypeOpts: GenListType[] = wdpUtil.sortOptList(fldName,myAppCtx!.lookups.costRateTypeList?.map((x:any) => ({label:x.Description,value:x.LookupId?.toString()})));

        // Direct table entry should not allow adding travel/meal/lodging types from this dropdown.
        let goodOpts: GenListType[] = allRateTypeOpts.filter((opt: GenListType) => !wdpUtil.inListCI(opt.label, lockedRateTypes));

        // Keep current locked value visible for existing rows loaded from travel/meal/lodging sections.
        if (isLockedRateType && selectedRateType) {
          goodOpts = [selectedRateType, ...goodOpts.filter((opt: GenListType) => opt.value !== selectedRateType.value)];
        }

        // Travel/meal/lodging rows are managed from their sections and should not be editable here.
        // Keep this scoped to rateType only.

        return <td className="col-rateType">
          {canEditRow ?
            <GoabFormItem {...atts}>
              <Autocomplete freeSolo={false} filterSelectedOptions className='formField' sx={{ width }} id={fullId} data-testid={`tnc_${fullId}`} disabled={extrAtts.disabled || isLockedRateType}
                noOptionsText={extrAtts.noOptionsText ?? "--type to select--"}
                renderInput={(params) => (<Tooltip placement='top' arrow title={(formCtrl.values.costSummary![recIndex].rateType as GenListType | null)?.label}><TextField {...params} placeholder='select rate type' label="" /></Tooltip>)}
                getOptionLabel={(option) => option?.label ?? ""}
                autoHighlight
                disableClearable={false}
                options={goodOpts}
                value={formCtrl.values.costSummary![recIndex].rateType as GenListType}
                onChange={(_event: any, item: GenListType | null) => { onMyChange(fullId, item); }}
                onBlur={(e: any) => onMyBlur(e?.nativeEvent?.target?.id, e?.nativeEvent?.target?.value)}
              />
            </GoabFormItem> : <span>{fldVal ? (fldVal as GenListType).label : ''}</span>
          }
        </td>
      }

      if (fldName === "costActivityCode") {
        //const goodOpts: GenListType[] = autoCompleteOptionsCtrl[recIndex].costActivityCode!;
        //const goodOpts: GenListType[] = myAppCtx?.costActivityList ?? [];
        let goodOpts: GenListType[] = [];
        const cs = formCtrl.values.costSummary;
        if (!wdpUtil.isNullorUndefined(cs) && cs!.length > 0 && (recIndex >= 0) && !wdpUtil.isNullorUndefined(cs![recIndex].rateType)) {
          const rateType = (cs![recIndex].rateType as GenListType);
          goodOpts = TicketService.getCostActivity4RateTypeId(myAppCtx?.lookups, rateType.value);
          // filter 2 .. we need just the FS items if there is a fire number
          if(wdpUtil.isNullOrEmpty(cs![recIndex].fireNumber)){
            goodOpts=goodOpts.filter((e:GenListType) => e.label.toUpperCase().startsWith("FP",0));
          }else{
            goodOpts=goodOpts.filter((e:GenListType) => e.label.toUpperCase().startsWith("FS",0));
          }

        }
        return <td className="col-activityCode">
          {canEditRow ?
            <GoabFormItem {...atts}>
              <Autocomplete freeSolo={false} filterSelectedOptions className='formField' sx={{ width }} id={fullId} data-testid={`tnc_${fullId}`} disabled={extrAtts.disabled}
                noOptionsText={extrAtts.noOptionsText ?? "--type to select--"}
                renderInput={(params) => (<Tooltip placement='top' arrow title={(formCtrl.values.costSummary![recIndex].costActivityCode as GenListType | null)?.label}><TextField {...params} placeholder='select activity code' label="" /></Tooltip>)}
                getOptionLabel={(option) => extractCostActivityCode(option.label)}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  return <li {...optionProps} key={`${option?.value ?? option?.label ?? ""}-${option?.label ?? ""}`}>{option?.label ?? option?.value ?? ""}</li>;
                }}
                filterOptions={filterOptionsGenListType}
                autoHighlight
                disableClearable={false}
                options={goodOpts}
                value={formCtrl.values.costSummary![recIndex].costActivityCode as GenListType}
                onChange={(_event: any, item: GenListType | null) => { onMyChange(fullId, item); }}
                onBlur={(e: any) => onMyBlur(e?.nativeEvent?.target?.id, e?.nativeEvent?.target?.value)}
              />
            </GoabFormItem> : <span>{fldVal ? extractCostActivityCode((fldVal as GenListType).label) : ''}</span>
          }
        </td>
      }

      if (fldName === "noOfUnits") {
        extrAtts.type = 'text';
        const goodVal =  fldVal as string;
        return <td className="col-units">{canEditRow ? renderTxtField(fullId, goodVal, fldErr, fldTouch, atts, extrAtts) : <span>{(goodVal)}</span>}</td>
      }
      if (fldName === "rateUnit") {
        extrAtts.placeHolder= 'select unit';

        const selectedRateType = formCtrl.values.costSummary![recIndex].rateType as GenListType | null;
        const selectedRateTypeLabel = wdpUtil.getFormFieldVal(selectedRateType, true);
        const isFuelSurcharge = wdpUtil.strEqual(selectedRateTypeLabel, RateType_FuelSurcharge);
        const goodOpts:GenListType[] = isFuelSurcharge? getUnits4RateTyle_FuelSurcharge(recIndex, formCtrl.values): TicketService.getUnits4RateTyle(myAppCtx?.lookups,resourceSnapshotRawJsonFromFires,formCtrl.values.costSummary![recIndex].rateType as GenListType, TicketService.packageEquInfo(formCtrl.values));
        //const goodOpts: GenListType[] = TicketService.getUnits4RateTyle(myAppCtx?.lookups, resourceSnapshotRawJsonFromFires, formCtrl.values.costSummary![recIndex].rateType as GenListType, packageEquInfo(formCtrl.values));    
        return <td className="col-unit">
          {canEditRow ?
            <GoabFormItem {...atts}>
              <Autocomplete freeSolo={false} filterSelectedOptions className='formField' sx={{ width }} id={fullId} data-testid={`tnc_${fullId}`} disabled={extrAtts.disabled}
                noOptionsText={extrAtts.noOptionsText ?? "--type to select--"}
                renderInput={(params) => (<Tooltip placement='top' arrow title={(formCtrl.values.costSummary![recIndex].rateUnit as GenListType | null)?.label}><TextField {...params} placeholder={extrAtts.placeHolder} label="" /></Tooltip>)}
                getOptionLabel={(option) => option?.label ?? ""}
                autoHighlight
                disableClearable={false}
                options={goodOpts}
                value={formCtrl.values.costSummary![recIndex].rateUnit as GenListType}
                onChange={(_event: any, item: GenListType | null) => { onMyChange(fullId, item); }}
                onBlur={(e: any) => onMyBlur(e?.nativeEvent?.target?.id, e?.nativeEvent?.target?.value)}
              />
            </GoabFormItem> : <span>{fldVal ? (fldVal as GenListType).label : ''}</span>
          }
        </td>
      }
      if (fldName === "ratePerUnit") {
        extrAtts.placeHolder = 'rate per unit';
        extrAtts.type        = 'currency';
        const goodVal =  fldVal as string;
        return <td className="col-ratePerUnit">{canEditRow ? renderTxtField(fullId, goodVal, fldErr, fldTouch, atts, extrAtts) : <span>{`$${goodVal}`}</span>}</td>
        //return <td>{editMode ? renderCurrencyField(fullId, goodVal, fldErr, fldTouch, atts, extrAtts) : <span>{goodVal}</span>}</td>
      }
      if (fldName === "amount") {
        extrAtts.disabled = true;
        extrAtts.type     = 'currency';
        const goodVal     =  wdpUtil.formatValFloat(fldVal);
        return <td className="col-cost">{canEditRow ? renderTxtField(fullId, goodVal, fldErr, fldTouch, atts, extrAtts) : <span>{`$${goodVal}`}</span>}</td>
      }

      if (fldName === "internalOrder") {
        const goodOpts: GenListType[] = autoCompleteCtrl.options[recIndex]?.internalOrder ?? [];
        // Keep internal order locked when fire number has a matching internal order.
        // This must also hold in Edit mode after loading an existing ticket.
        
        const hasFireNumber           = !wdpUtil.isNullOrEmpty(wdpUtil.getFormFieldVal(formCtrl.values.costSummary![recIndex].fireNumber, true));
        const hasSingleMatchedOption  = goodOpts.length === 1 && hasFireNumber;
        const hasMatchFromAttrs       = autoCompleteCtrl.attrs?.[recIndex]?.internalOrder?.matchFireNo === true && hasFireNumber;
        extrAtts.disabled             = extrAtts.disabled || hasSingleMatchedOption || hasMatchFromAttrs;
        
        return <td className="col-internalOrder">
          {canEditRow ?
            <GoabFormItem {...atts}>
              <Autocomplete className='formField' filterSelectedOptions autoComplete sx={{ width }} id={fullId} data-testid={`tnc_${fullId}`} noOptionsText="--type to select--" disabled={extrAtts.disabled}
                renderInput={(params) => <Tooltip placement='top' arrow title={(fldVal as GenListType)?.label} ><TextField {...params} placeholder="--type to select-- " /></Tooltip>}
                getOptionLabel={(option) => extractInternalOrderCode(option.label)}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  return <li {...optionProps} key={`${option?.value ?? option?.label ?? ""}-${option?.label ?? ""}`}>{option?.label ?? option?.value ?? ""}</li>;
                }}
                options={goodOpts ? goodOpts : []}
                filterOptions={filterOptionsGenListType}
                value={formCtrl.values.costSummary![recIndex].internalOrder as GenListType}
                onChange={(_event: any, item: GenListType | null) => { onMyChange(fullId, item); }}
                //inputValue={autoCompleteCtrl.input![recIndex].internalOrder}   do not control inputValue unless you need custom text behavior
                onInputChange={(_event, newInputValue,reason) => { 
                  if (reason === "reset" && pageMounted.current){ 
                    // after we complete loading the page, we should Ignore programmatic resets
                    return; 
                  }
                  // Only update state for 'input', 'clear', or 'blur'
                  onAutoCompleteInputChanged({ who: fullId, newVal: newInputValue, extra: extrAtts }) 
                  }
                }
                onBlur={(e: any) => onMyBlur(e?.nativeEvent?.target?.id, e?.nativeEvent?.target?.value)}
              /></GoabFormItem> : <span>{fldVal ? extractInternalOrderCode((fldVal as GenListType).label) : ''}</span>
          }
        </td>
      }
      if (fldName === "costCenter") {
        //const goodOpts: GenListType[] = autoCompleteOptionsCtrl[recIndex].costCenter!;
        let selectedForestArea =  (formCtrl.values.forestAreaId as GenListType)?.value ||'';
        //const goodOpts: GenListType[] = TicketService.getCostCenters(myAppCtx?.lookups); // expecting just one item 
        const goodOpts: GenListType[] = autoCompleteCtrl.options[recIndex]?.costCenter ?? [];
        extrAtts.placeHolder= 'select cost center';
        return <td className="col-costCenter">
          {canEditRow ?
            <GoabFormItem {...atts}>
              <Autocomplete className='formField' filterSelectedOptions autoComplete sx={{ width }} id={fullId} data-testid={`tnc_${fullId}`} noOptionsText="--type to select--" disabled={extrAtts.disabled}
                renderInput={(params) => <Tooltip placement='top' arrow title={(fldVal as GenListType)?.label} ><TextField {...params} placeholder="--type to select-- " /></Tooltip>}
                getOptionLabel={(option) => extractCostCenterCode(option.label)}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  return <li {...optionProps} key={`${option?.value ?? option?.label ?? ""}-${option?.label ?? ""}`}>{option?.label ?? option?.value ?? ""}</li>;
                }}
                options={goodOpts ? goodOpts : []}
                filterOptions={filterOptionsGenListType}
                value={formCtrl.values.costSummary![recIndex].costCenter as GenListType}
                onChange={(_event: any, item: GenListType | null) => { onMyChange(fullId, item); }}
                //inputValue={autoCompleteCtrl.input![recIndex].internalOrder}
                onInputChange={(_event, newInputValue,reason) => { 
                  if (reason === "reset"){ 
                    //return; // Ignore programmatic resets
                  }
                  // Only update state for 'input', 'clear', or 'blur'
                  onAutoCompleteInputChanged({ who: fullId, newVal: newInputValue, extra: extrAtts }) 
                  }
                }
                onBlur={(e: any) => onMyBlur(e?.nativeEvent?.target?.id, e?.nativeEvent?.target?.value)}
              /></GoabFormItem> : <span>{fldVal ? extractCostCenterCode((fldVal as GenListType).label) : ''}</span>
          }
        </td>
      }
      if (fldName === "fund") {
       extrAtts.placeHolder= 'fund';
      //  extrAtts.disabled ||= extrAtts.disabled || isLockedRateType ;
        return <td className="col-fund">{canEditRow ? renderTxtField(fullId, fldVal as string, fldErr, fldTouch, atts,extrAtts) : <span className='readyOnly-cell'>{fldVal as string}</span>}</td>
      }
      if (fldName === "account") {
         extrAtts.placeHolder= 'account';
        //  extrAtts.disabled ||= extrAtts.disabled || isLockedRateType ;
        return <td className="col-account">{canEditRow ? renderTxtField(fullId, fldVal as string, fldErr, fldTouch, atts,extrAtts) : <span className='readyOnly-cell'>{fldVal as string}</span>}</td>
      }
      if (fldName === "invoiceNo") {
        extrAtts.placeHolder= 'invoice number';
        extrAtts.disabled ||= extrAtts.disabled || isLockedRateType;
        return <td className="col-invoiceNo">{canEditRow ? renderTxtField(fullId, fldVal as string, fldErr, fldTouch, atts,extrAtts) : <span className='readyOnly-cell'>{fldVal as string}</span>}</td>
      }

    }
  }
  /********************************************************************************************
   * 
  ********************************************************************************************/
  // function rednerTimePicker(who: string, fieldVal: any, _fldErr: string, _fldTouched: string, atts: any, _extraAtta: any) {
  //   return (
  //     <GoabFormItem {...atts}>
  //       <TimePicker className='formField' name={who}
  //         value={fieldVal}
  //         onChange={(e) => { onMyChange(who, e.target.value) }}
  //       //onBlur={(e) => { onMyBlur(who, e.target.value) }}
  //       //error={(fldErr !== "" && fldTouched !== "T")}
  //       />
  //     </GoabFormItem>
  //   );
  // }
  /********************************************************************************************
   * 
  ********************************************************************************************/
  function renderTxtField(who: string, fieldVal: string, fldErr: string, fldTouched: string, atts: any, extraAtts: any) {

    const fldType = extraAtts?.type ?? 'text';
    const maxLen  = extraAtts?.maxLength ?? 64;
    const pattern = extraAtts?.pattern ?? "";
    const safeFieldVal = fieldVal ?? "";
    if(extraAtts?.type === 'currency'){
    return (
      <GoabFormItem {...atts}>
        <TextField className='formField' id={who} name={who} variant="outlined" fullWidth={true} size='small' placeholder={extraAtts?.placeholder} disabled={extraAtts?.disabled}
          value={safeFieldVal}
          type='text'
          slotProps={{ 
            input: { 
                startAdornment: ( <InputAdornment position="start">$</InputAdornment> ), 
                inputProps: { maxLength: 6 } 
            } 
          }}
          onChange={(e) => { onMyChange(who, e.target.value) }}
          onBlur={(e) => { onMyBlur(who, e.target.value) }}
          error={(fldErr !== "" && fldTouched == "T")}
        
        />
      </GoabFormItem>
    );  
    }
    return (
      <GoabFormItem {...atts}>
        <TextField className='formField' id={who} name={who} variant="outlined" fullWidth={true} size='small' placeholder={extraAtts?.placeholder} disabled={extraAtts?.disabled}
          value={safeFieldVal}
          type={fldType}
          onChange={(e) => { onMyChange(who, e.target.value) }}
          onBlur={(e) => { onMyBlur(who, e.target.value) }}
          error={(fldErr !== "" && fldTouched == "T")}
          slotProps={{ 
            input: { 
                inputProps: { 
                  maxLength: maxLen,
                  pattern:pattern // this is just to participate in HTML form validation, not live input masking... onmychange is the real masking
                }
            }
          }}
        />
      </GoabFormItem>
    );
  }
  /********************************************************************************************
   * 
  ********************************************************************************************/
  // function renderTxtAreaField(who: string, fieldVal: any, fldErr: string, fldTouched: string, atts: any, extraAtta:any) {
  //   const keyTypedErr = who as keyof typeof formCtrl.errors;
  //   const keyTypedTouch = who as keyof typeof formCtrl.touched;
  //   return (
  //     <GoabFormItem {...atts}>
  //       <GoabTextArea name={who} width={'100%'}
  //         placeholder={extraAtta.placeholder}
  //         disabled={extraAtta.disabled}
  //         error={(formCtrl.errors[keyTypedErr] !== "" && formCtrl.touched[keyTypedTouch] !== "T") && !extraAtta.disabled && !pageStatus.submissionPage}
  //         value={fieldVal}
  //         onChange={(details: GoabTextAreaOnChangeDetail) => { onMyChange(details.name, details.value) }}
  //       >
  //       </GoabTextArea>
  //     </GoabFormItem>
  //   );
  // }

  /********************************************************************************************
   * 
  ********************************************************************************************/
  function renderReadOnlyField(fieldLabel: string, _who: string, fieldVal: string, width: string) {
    const h = fieldLabel ? "auto" : "12px";
    return (
      <GoabFormItem label={fieldLabel}>
        <div style={{ width: `${width}`, paddingTop: `${h}` }} >{fieldVal ? fieldVal : "-"}</div>
      </GoabFormItem>
    );
  }
  /********************************************************************************************
  *********************************************************************************************/
  function renderDateField(who: string, fldVal: any, flddErr: any, fldTouch: any, atts: any, _extraAtta?: any) {
    let aDt = (fldVal ? dayjs(fldVal as string).endOf('day') : null);
    if (who === "estimatedStartDate") {
      aDt = (fldVal ? dayjs(fldVal as string) : null);
    }
    return (
      <GoabFormItem  {...atts} >
        <div className='formField date-field' onBlur={() => { onMyBlur(who, fldVal) }}>
          <CustomFmF id={who} name={who}
            value={(fldVal ? dayjs(fldVal).tz() : null)}
            onChange={(e: any) => onMyChange(e?.target?.name, e?.target?.value)}
            error={(flddErr !== "" && fldTouch !== "T")}
            disabled={_extraAtta?.disabled}
          />
        </div>
      </GoabFormItem>
    );
  }
  /********************************************************************************************
  *********************************************************************************************/
  function renderRadioButton(who: string, _fldVal: any, _flddErr: any, _fldTouch: any, atts: any, _extraAtta?: any) {
    return (
      <GoabFormItem {...atts}>
        <GoabRadioGroup name={who}>
          <GoabRadioItem value="1" label="Yes" description={<span></span>} />
          <GoabRadioItem value="2" label="No" />
        </GoabRadioGroup>
      </GoabFormItem>
    );
  }
  /********************************************************************************************
  *********************************************************************************************/
  function renderCheckBox(who: string, fldVal: any, _flddErr: any, _fldTouch: any, atts: any, _extraAtta?: any) {
    return (
      <GoabFormItem {...atts}>
        <GoabCheckbox name={who} text={atts.label}  disabled={_extraAtta.disabled} 
        value={fldVal} 
        checked={fldVal} 
        onChange={(details: GoabCheckboxOnChangeDetail) => { onMyChange(details.name, details.checked) }} />
      </GoabFormItem>
    );
  }
  /********************************************************************************************
  *********************************************************************************************/
  function renderDropdown(who: string, fldVal: string, fldErr: string, fldTouched: string, atts: any, extrAtts: any, opts: GenListType[]) {

    if (wdpUtil.isNullorUndefined(fldVal)) {
      //console.log("unefined - who:"+ who);
      //return <></>;
      fldVal = '';
    }
    return (
      <GoabFormItem {...atts}>
        <Select label={extrAtts.placeHolder} size='small' fullWidth={true}
          data-testid={`tic_${who}`}
          value={fldVal}
          onChange={(e) => { onMyChange(who, e.target) }}
          onBlur={(e) => { onMyBlur(who, e.target.value) }}
          error={fldErr !== "" && fldTouched !== "T"}
        >
          {(opts || []).map((item: GenListType, i) => <MenuItem key={item.value + item.label + i} value={item.value}>{item.label}</MenuItem>)}
        </Select>
      </GoabFormItem>
    );
  }
  /********************************************************************************************
  //// onInputChange event is designed to capture user-driven input (typing)
  *********************************************************************************************/
  function onAutoCompleteInputChanged(param: any) {
    const who = param.who;
    //console.log("AutoComplete Update. who: " + who, "val: " + param.newVal);
    
    const _formValues: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.values);
    if (wdpUtil.isNullorUndefined(param.newVal)) {
      //the state is determined during the first render. It's considered controlled if the value is not `undefined`
      param.newVal = '';
    }

    if (who!.includes("costSummary")) {
      const parts = who!.split('-');
      const whowho: string = parts[1];
      const recIndex = wdpUtil.safeParse(parts[2]);
      // for costSummary table, we maintain the auto comlete inputvalue inside the costSummary table hook
      if (whowho === "fireNumber") {
        //updateAutoCompleteCtrl("inputValue", recIndex, whowho, param.newVal);
        loadFires(param.newVal, recIndex); // this will update the Options
      }
      // if(whowho=== "rateType") {
      //   updateAutoCompleteCtrl("inputValue",recIndex,whowho,param.newVal);
      //   updateAutoCompleteCtrl("Options",recIndex,whowho,myAppCtx?.costRateTypeList as GenListType[]);
      // }
      // if(whowho=== "rateUnit") { // no need , as I converted this one to none freeSolo.. meaning there in no inputvalue
      //   updateAutoCompleteCtrl("inputValue",recIndex,whowho,param.newVal);
      //   updateAutoCompleteCtrl("Options",recIndex,whowho,myAppCtx?.costRateUnitList as GenListType[]);
      // }
      // if(whowho==="costActivityCode"){
      //   updateAutoCompleteCtrl("inputValue",recIndex,whowho,param.newVal);
      //   updateAutoCompleteCtrl("Options",recIndex,whowho,myAppCtx?.costActivityList as GenListType[]);
      // }
      if (whowho === "internalOrder") {
        //updateAutoCompleteCtrl("inputValue", recIndex, whowho, param.newVal);
        //updateAutoCompleteCtrl(recIndex, {inputValue: { internalOrder: param.newVal }});
        loadInternalOrderCodes(param.newVal, recIndex);// this will update the Options and inputvalue
      }
      if(whowho==="costCenter"){
        //updateAutoCompleteCtrl("inputValue",recIndex,whowho,param.newVal);
        //updateAutoCompleteCtrl("Options",recIndex,whowho,myAppCtx?.costCenterList as GenListType[]);
        loadCostCenter(param.newVal, recIndex);// this will update the Options and inputvalue
      }

    } else {
      if (param.who === "contractNumber") {
        setContractNumberInputValue(param.newVal);
        let dt = formCtrl.values.date;
        if (wdpUtil.isNullorUndefined(dt)) {
          const today = new Date();
          dt = today.toISOString().split('T')[0];
        }
        loadContracts(param.newVal, _formValues);
      }
      if (param.who === "forestAreaId") { setForestAreaIdInputValue(param.newVal); }
      if (param.who === "unitNumber") { setUnitNumberInputValue(param.newVal); }
      if (param.who === "equipment") { setEquipmentInputValue(param.newVal); }
      if (param.who === "serialNumber") { setSerialNumberInputValue(param.newVal); }
      if (param.who === "addOns") { 
        setaddOnsInputValue(param.newVal); 
      }


    }


  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Helper Functions
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////
  function resetCostSummary(_formValues:TicketInfo_ui,_formErrors:TicketInfo_ui,_formTouched:TicketInfo_ui){
      _formValues.costSummary = [];
      _formErrors.costSummary = [];
      _formTouched.costSummary= [];

        // maybe we need to move this tis to the call , bacuse the cal has an update 
      setAutoCompleteCtrl({input:[],options:[],attrs:[]});
  }
  function addExpense(obj: Partial<WorkSegmentInfo> | Partial<MealProvisionInfo> | Partial<TravelSegmentInfo> | Partial<LodgingProvisionInfo>, cs: Partial<CostSummary_ui>) {
    obj.id            = cs.id===''?undefined:cs.id,
    obj.fireNo        = wdpUtil.getFormFieldVal(cs.fireNumber,true);
    obj.costCenter    = wdpUtil.getFormFieldVal(cs.costCenter,true);      // we need to send it as description - code
    obj.internalOrder = wdpUtil.getFormFieldVal(cs.internalOrder,true);   // we need to send it as description - code
    obj.rateTypeId    = wdpUtil.safeParse(wdpUtil.getFormFieldVal(cs.rateType));
    obj.rateUnit      = wdpUtil.getFormFieldVal(cs.rateUnit);

    obj.account       = cs.account;
    obj.fund          = cs.fund;
    obj.invoiceId     = null;
    obj.invoiceNo     = null;
    obj.ratePerUnit   = wdpUtil.safeParse(cs.ratePerUnit,{type:"float"});

    obj.noOfUnits     = wdpUtil.safeParse(cs.noOfUnits,{type:"float"});
    obj.amount        = wdpUtil.safeParse(cs.amount,{type:"float"});
  }
  /********************************************************************************************
   * who must be sam as name in the costSummary Object
  *******************************************************************************************/
  function getFldCtrInfo(ctrInfo: string, who: string, rowIndex?: number, colName?: string) {

    if (who === "costSummary") {
      if (!wdpUtil.isNullorUndefined(formCtrl.values.costSummary) && Array.isArray(formCtrl.values.costSummary) && !wdpUtil.isNullorUndefined(rowIndex) && !wdpUtil.isNullorUndefined(colName)) {
        if (ctrInfo === 'value') {
          const row = formCtrl.values.costSummary?.[rowIndex!];
          return row?.[colName as keyof typeof row];
        }
        if (ctrInfo === 'error') {
          const row = formCtrl.errors.costSummary?.[rowIndex!];
          return row?.[colName as keyof typeof row];
        }
        if (ctrInfo === 'touched') {
          const row = formCtrl.touched.costSummary?.[rowIndex!];
          return row?.[colName as keyof typeof row];
        }
      } else {
        //console.log("getFldCtrInfo: error code (101)");
      }
    }
    if (ctrInfo === 'value') return formCtrl.values[who as keyof typeof formCtrl.values];
    if (ctrInfo === 'error') return formCtrl.errors[who as keyof typeof formCtrl.errors];
    if (ctrInfo === 'touched') return formCtrl.touched[who as keyof typeof formCtrl.touched];
    return '';
  }
  /********************************************************************************************
  *******************************************************************************************/
  function updateFormCtrl(vals: any, errs: any, touchs: any) {
    setformCtrl((prev) => (
      {
        ...prev,
        //values: vals    ? { ...prev.values, ...vals } : prev.values,
        values: vals ? { ...prev.values, ...vals } : prev.values,
        errors: errs ? { ...prev.errors, ...errs } : prev.errors,
        touched: touchs ? { ...prev.touched, ...touchs } : prev.touched,
      }
    ));
  }
  /********************************************************************************************
  *******************************************************************************************/
  function updateAutoCompleteCtrl(recIndex: number,updates: {rec?: Partial<CostSummary_ui>;inputValue?: Partial<AutoCompleteCtrl_InputValue>;options?: Partial<AutoCompleteCtrl_Options>;}) {
  
    const { rec, inputValue, options } = updates;

    setAutoCompleteCtrl(prev => {
      const next: AutoCompleteCtrl = {
        input: [...prev.input],
        options: [...prev.options],
        attrs: [...prev.attrs],
      };

      // Ensure row exists
      next.input[recIndex]   = next.input[recIndex]   ?? { ...autoCompleteInputCtrlEmptyObj };
      next.options[recIndex] = next.options[recIndex] ?? { ...autoCompleteOptionsCtrlEmptyObj };
      next.attrs[recIndex]   = next.attrs[recIndex]   ?? { ...autoCompleteAttrsCtrlEmptyObj };

      
      // 1. Programmatic selection (loading existing ticket)
      if (rec) {
        const rowInput   = next.input[recIndex];
        const rowOptions = next.options[recIndex];

        if (rec.fireNumber) {
          const g = rec.fireNumber as GenListType;
          rowInput.fireNumber = g.label;
          rowOptions.fireNumber = [g];
        }

        if (rec.internalOrder) {
          const g = rec.internalOrder as GenListType;
          rowInput.internalOrder = g.label;
          rowOptions.internalOrder = [g];
        }

        if (rec.costCenter) {
          const g = rec.costCenter as GenListType;
          rowInput.costCenter = g.label;
          rowOptions.costCenter = [g];
        }
      }
      // 2. User typing → update ONLY input values .. NOTE: not in ue anymore as we have changed the AutoComplete InputValue to be uncontrolled
      if (inputValue) {
        next.input[recIndex] = {
          ...next.input[recIndex],
          ...inputValue
        };
      }
      // 3. API results → update ONLY options
      if (options) {
        next.options[recIndex] = {
          ...next.options[recIndex],
          ...options
        };
      }

      return next;
    });
  }
  /********************************************************************************************
  *********************************************************************************************/
  function resetFormTrackers() {

    const _formValues: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.values);
    let _formErrors: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.errors);
    let _formTouched: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.touched);

    _formErrors   = wdpUtil.deepReset(_formErrors, "");
    _formTouched  = wdpUtil.deepReset(_formTouched, "");
    
    
    updateFormCtrl(null, _formErrors, _formTouched);
  }
  /********************************************************************************************
  *********************************************************************************************/
  function Segment2CostSummary(equInfo:BasicInfo_ui|null,_from: WorkSegmentInfo|TravelSegmentInfo|MealProvisionInfo|LodgingProvisionInfo):CostSummary_ui|null {
    const from = _from;
    const appCtx = myAppCtx;
    if (!appCtx?.lookups) {
      return null;
    }
    const lookups = appCtx!.lookups;
    //const myRateUnit = myAppCtx?.costRateUnitList.find((e: GenListType) => e.value == from.rateUnit)?.label || "";
    const ret: CostSummary_ui = {
      id:             from.id,
      noOfUnits:      wdpUtil.formatValFloat(from.noOfUnits?.toString() || ""),
      ratePerUnit:    wdpUtil.formatValFloat(from.ratePerUnit?.toString() || ""),
      amount:         from.amount?.toString() || "",
      fund:           from.fund?.toString() || "",
      account:        from.account?.toString() || "",
      invoiceNo:      from.invoiceNo?.toString() || "",
      invoiceId:      from.invoiceId?.toString() || "",
      fireNumber:     null,
      rateType:       null,
      costActivityCode:null,
      rateUnit:       null,
      internalOrder:  null,
      costCenter:     null,
      selected:       false

    }

    // 1 - Fire NUmber
    ret.fireNumber = { label: '', value: '' };
    if (!wdpUtil.isNullorUndefined(from.fireNo) || from.fireNo != '') {
      ret.fireNumber = { label: from.fireNo as string, value: from.fireNo as string };
    }
    // 2 - Rate Type
    ret.rateType= {label: '' ,value:'' };
    if(!wdpUtil.isNullorUndefined(from.rateTypeId) ){
      const goodOpts: GenListType[] = lookups.costRateTypeList?.map((x:any) => ({label:x.Description,value:x.LookupId?.toString()})) || [];
      ret.rateType = goodOpts.find((e:GenListType) => e.value === from.rateTypeId?.toString())??null;  
    }



    // 3 - Cost Activity Code
    ret.costActivityCode = {label: '' ,value:'' };
    if(!wdpUtil.isNullorUndefined(from.costingActivityId) ){
      // Pass workPerformedRelationsList too - a WORK_PERFORMED-derived costingActivityId may only
      // co-occur with its rateTypeId there, not in the generic genericRelationsList relationship.
      const inArr = TicketService.extractFromRelations(lookups.genericRelationsList, 'costActivityCode', {
        rateTypeId: from.rateTypeId?.toString(),
        value: from.costingActivityId,
        workPerformedRelationsList: lookups.workPerformedRelationsList
      });
      if (inArr != null && inArr.length) {
        ret.costActivityCode = inArr[0];
      }
    }


    // 4 - Rate Unit 
    ret.rateUnit = {label: '' ,value:'' };
    if(!wdpUtil.isNullorUndefined(from.rateUnit) ){
      ret.rateUnit = lookups.costRateUnitList.find((e:GenListType) => e.value === from.rateUnit!) ?? null;
    }
    // 4 - Internal Order
    ret.internalOrder = { label: '', value: '' };
    if (!wdpUtil.isNullorUndefined(from.internalOrder)) {
      ret.internalOrder = { label: from.internalOrder as string, value: from.internalOrder as string };
    }
    // 5 - Cost Center
    ret.costCenter  = {label: '' ,value:'' };
    if(!wdpUtil.isNullorUndefined(from.costCenter)){
      //ret.costCenter = lookups?.costCenterList.find((e:GenListType) => e.value === from.costCenter!);
      ret.costCenter = { label: from.costCenter as string, value: from.costCenter as string }; 
    }
    // 6 - Work segment fields (workStartUtc, workFinishUtc, workPerformedType)
    if ('workPerformed' in from && 'stopUtc' in from) {
      const workSeg = from as WorkSegmentInfo;
      ret.workStartUtc  = workSeg.startUtc;
      ret.workFinishUtc = workSeg.stopUtc;
      const wpLabel = workSeg.workPerformed;
      const relations: any[] = lookups?.workPerformedRelationsList ?? [];
      const elements = relations
        .flatMap((rel: any) => rel.lookupRelationshipItems ?? [])
        .flatMap((item: any) => item.itemElements ?? [])
        .filter((e: any) => wdpUtil.strEqual(e.lookupTypeId, domianTableLookupIdWorkPerformed));
      const match = elements.find((e: any) => wdpUtil.strEqual(e.lookupLabel, wpLabel));
      ret.workPerformedType = match
        ? { label: match.lookupLabel ?? "", value: (match.lookupId ?? "").toString() }
        : { label: wpLabel ?? "", value: wpLabel ?? "" };
      ret.workFuelProvidedByGoa = workSeg.isFuelProvidedByGOA === true ? "yes" : workSeg.isFuelProvidedByGOA === false ? "no" : "";
      // The backend has no separate "assigned to wildfire" flag - it's derived from whether a
      // fire number was saved against the work segment (fireNo), same as the required-field
      // rule in WorkInfo.validateField, so derive it the same way here on load.
      ret.workAssignedToWildfire = !wdpUtil.isNullOrEmpty(wdpUtil.getFormFieldVal(ret.fireNumber as GenListType | string | null, true)) ? "yes" : "no";
    }
    return ret;

  }
  /********************************************************************************************
  *******************************************************************************************/
  function onEditBasicInfo(){
    if (pageStatus.editModeBySection.costSummary) {
      onCancelCostSummary();
    }
    setActiveEditSection('basic');
    setPageStatus(prev=>({...prev,  editModeBySection:{...prev.editModeBySection,basic:true}}));
  }
  /********************************************************************************************
  *******************************************************************************************/
  function onCancelBasicInfo(){
    const _orig = orginalData.current;
    // Restore ALL basic-info values from the snapshot taken at Edit time
    const originalBasicInfo: Partial<TicketInfo_ui> = {
      ticketNumber:    _orig.ticketNumber,
      date:            _orig.date,
      contractNumber:  _orig.contractNumber,
      contractorName:  _orig.contractorName,
      forestAreaId:    _orig.forestAreaId,
      standbyBase:     _orig.standbyBase,
      fieldSupervisor: _orig.fieldSupervisor,
      unitNumber:      _orig.unitNumber,
      serialNumber:    _orig.serialNumber,
      equipment:       _orig.equipment,
      addOns:          _orig.addOns,
    };
    // Reset errors and touched for basic-info fields only — leave costSummary errors untouched
    const _formErrors   = wdpUtil.deepCopy(formCtrl.errors);
    const _formTouched  = wdpUtil.deepCopy(formCtrl.touched);
    basicFields.forEach(f => { (_formErrors as any)[f] = ''; (_formTouched as any)[f] = ''; });
    updateFormCtrl(originalBasicInfo, _formErrors, _formTouched);
    setPageStatus(prev=>({...prev, editModeBySection:{...prev.editModeBySection,basic:false}}));
    setActiveEditSection(prev => prev === 'basic' ? null : prev);
  }
  /********************************************************************************************
  *******************************************************************************************/
  function onSaveBasicInfo(){ 
    // we only update the basic info part, cost summary is not affected
    const basicInfo = TicketService.packageEquInfo(formCtrl.values);
    updateFormCtrl(basicInfo, null, null);  

    // Advance basic baseline after a successful section save click.
    const nextOriginal = wdpUtil.deepCopy(orginalData.current);
    basicFields.forEach((f) => {
      (nextOriginal as any)[f] = (formCtrl.values as any)[f];
    });
    orginalData.current = nextOriginal;
    resetFormTrackers();
    setPageStatus(prev=>({...prev,editModeBySection:{...prev.editModeBySection,basic:false}}));
    setActiveEditSection(prev => prev === 'basic' ? null : prev);
    doSave();
  }
  /********************************************************************************************
  *******************************************************************************************/
  function isBasicSectionDirty(): boolean {
    const currentBasic = basicFields.reduce((acc, fieldName) => {
      (acc as any)[fieldName] = (formCtrl.values as any)[fieldName];
      return acc;
    }, {} as Partial<TicketInfo_ui>);
    const originalBasic = basicFields.reduce((acc, fieldName) => {
      (acc as any)[fieldName] = (orginalData.current as any)[fieldName];
      return acc;
    }, {} as Partial<TicketInfo_ui>);
    return JSON.stringify(currentBasic) !== JSON.stringify(originalBasic);
  }
  /********************************************************************************************
  * Cost Summary Section Edit/Cancel/Save
  *******************************************************************************************/
  function onEditCostSummary(){
    if (pageStatus.editModeBySection.basic) {
      onCancelBasicInfo();
    }
    setActiveEditSection('costSummary');
    setPageStatus(prev=>({...prev,  editModeBySection:{...prev.editModeBySection,costSummary:true}}));
  }
  /********************************************************************************************
  *******************************************************************************************/
  function onCancelCostSummary(){
    const _orig = orginalData.current;
    
    // Prepare values restore
    const originalCostSummary: Partial<TicketInfo_ui> = {
      costSummary: _orig.costSummary,
    };
    
    // Prepare errors/touched rebuild
    const _formErrors: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.errors);
    const _formTouched: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.touched);
    
    // Rebuild costSummary errors/touched to match restored array size
    if (_orig.costSummary && Array.isArray(_orig.costSummary)) {
      _formErrors.costSummary = _orig.costSummary.map(() => wdpUtil.deepCopy(costSummaryEmptyObj));
      _formTouched.costSummary = _orig.costSummary.map(() => wdpUtil.deepCopy(costSummaryEmptyObj));
    } else {
      _formErrors.costSummary = [];
      _formTouched.costSummary = [];
    }
    
    // Single call to update values, errors, and touched
    updateFormCtrl(originalCostSummary, _formErrors, _formTouched);
    
    setPageStatus(prev=>({...prev, editModeBySection:{...prev.editModeBySection,costSummary:false}}));
    setActiveEditSection(prev => prev === 'costSummary' ? null : prev);
  }
  /********************************************************************************************
  *******************************************************************************************/
  function canSaveCostSummary(){
    return isCostSummarySectionDirty();// && validateCostSummaryTable(wdpUtil.deepCopy(formCtrl.values), wdpUtil.deepCopy(formCtrl.errors), wdpUtil.deepCopy(formCtrl.touched), undefined, false);
  
  }
  /********************************************************************************************
  *******************************************************************************************/
  function getFuelSurchargeMissingStandardWarning(costSummary: CostSummary_ui[] | null | undefined, originalCostSummary: CostSummary_ui[] | null | undefined): string | null {
    if (!costSummary || costSummary.length === 0) {
      return null;
    }

    const countFuelSurcharge = (list: CostSummary_ui[] | null | undefined) =>
      (list ?? []).filter((rec: CostSummary_ui) =>
        wdpUtil.strEqual(wdpUtil.getFormFieldVal(rec.rateType, true), RateType_FuelSurcharge)
      ).length;

    const currentFuelSurchargeCount = countFuelSurcharge(costSummary);
    if (currentFuelSurchargeCount === 0) {
      return null;
    }

    // Only warn when this save is the first time a Fuel surcharge row is being added,
    // not when an already-existing Fuel surcharge row loses its Standard row later.
    const isNewFuelSurchargeAdded = currentFuelSurchargeCount > countFuelSurcharge(originalCostSummary);
    if (!isNewFuelSurchargeAdded) {
      return null;
    }

    const hasStandard = costSummary.some((rec: CostSummary_ui) =>
      wdpUtil.strEqual(wdpUtil.getFormFieldVal(rec.rateType, true), RateType_Standard)
    );

    if (!hasStandard) {
      return "Fuel surcharge applies to Standard hours. Please enter a note to explain fuel surcharge when no standard hours entered.";
    }

    return null;
  }
  /********************************************************************************************
  *******************************************************************************************/
  function onSaveCostSummary(){
    // validate Cost Summary section before saving
    const _formValues: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.values);
    const _formErrors: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.errors);
    const _formTouched: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.touched);
    if (!validateCostSummaryTable(_formValues,_formErrors,_formTouched,undefined,true)) {
      // Validation failed — update form controller with errors so they display in the UI
      updateFormCtrl(null, _formErrors, _formTouched);
      appLog.debug("Validation Failed. some entered information does not meet the required rules or formatting for a specific field or process.");
      return;
    }
    
    // Validation passed — snapshot is only committed once the backend confirms the save.
    const originalCostSummaryBeforeSave = orginalData.current.costSummary;
    const fuelSurchargeWarning = getFuelSurchargeMissingStandardWarning(_formValues.costSummary, originalCostSummaryBeforeSave);
    doSave(fuelSurchargeWarning ?? undefined, () => {
      // Save succeeded — advance the baseline and exit edit mode.
      const nextOriginal       = wdpUtil.deepCopy(orginalData.current);
      nextOriginal.costSummary = wdpUtil.deepCopy(formCtrl.values.costSummary);
      orginalData.current      = nextOriginal;

      resetFormTrackers();
      setPageStatus(prev=>({...prev, editModeBySection:{...prev.editModeBySection,costSummary:false}}));
      setActiveEditSection(prev => prev === 'costSummary' ? null : prev);
    });
    // On error, the section stays in edit mode with the user's entered values so they can be corrected.
  }
  /********************************************************************************************
  *******************************************************************************************/
  function isCostSummarySectionDirty(): boolean {
    return JSON.stringify(formCtrl.values.costSummary) !== JSON.stringify(orginalData.current.costSummary);
  }
  
  /********************************************************************************************
  *******************************************************************************************/
  
  // function canSave() {
  //   const BasicInfoValid =  isBasicInfoValid();
  //   if(!BasicInfoValid){
  //     //console.log("Basic info is not valid, cannot save");
  //     return false; 
  //   }

  //   // is there any change in the form, either in basic info or cost summary, if not, then we dont need to save
  //   const anySectionDirty = Object.values(sectionDirtyMap).some(v => v);
  //   const anyDirty =  (isSectionDirty() || anySectionDirty);
  //   if (!anyDirty) {
  //      return false;
  //   }
  //   return true;
  // }
  /********************************************************************************************
  *******************************************************************************************/
  function getCurrentStatusText(): string {
    const statusText = myAppCtx?.lookups.ticketStatusList.find((ts: GenListType) => ts.value == formCtrl.values.statusId?.toString())?.label;
    return statusText ? statusText.toUpperCase() : "";
  }

  function getCurrentStatusLookupKey(): TicketStatusLookupKey {
    const statusItem = TicketStatuses.find((ts) => ts.lookupId == formCtrl.values.statusId);
    return statusItem ? statusItem.lookupKey : "" as TicketStatusLookupKey;
  }

  /********************************************************************************************
  *******************************************************************************************/
  function isEditingSignedOffTicket(): boolean {
    return pageStatus.editModeBySection.basic && getCurrentStatusLookupKey() === "SIGNED-OFF";
  }

  function getDeleteWarningMsg():string[]{
    if(hasConstSummaryInvoice()){
      return [
        "Ticket cannot be deleted if any cost details have an invoice number populated.",
        "The ticket has to be detached from the invoice first."
      ];
    }
    if(getCurrentStatusLookupKey() === 'APPROVED'){
      return ["Ticket cannot be deleted if status is approved."];
    }
    if(getCurrentStatusLookupKey() === 'SIGNED-OFF'){
      return ["Ticket cannot be deleted if status is signed off."];
    }
    if(getCurrentStatusLookupKey() === 'PROCESSED'){
      return ["Ticket cannot be deleted if status is processed."];
    }
    return [];
  }
  
  
  /********************************************************************************************
   * 
   * @param name 
   * @param value 
   * extraParam:{rec:CostSummary_ui}
  *******************************************************************************************/
  function validateField(who: string, value: string|GenListType|null,extraParam?:any ): string {
    let err = "";
    
    const goodValue = wdpUtil.getFormFieldVal(value);
    // check if the field is mandatoy
    let mandatory = wdpUtil.includesIgnoreCase(mandatoyFields,who)

    // Internal order and cost center are allowed to stay empty while the ticket is still
    // IN-PROGRESS (or not yet saved) - they only become required once it moves past that status.
    
    const isTicketDraftOrNew = Boolean(formCtrl.values.isDraft) || isNewTicket();

    // special case
    if(who === 'internalOrder'){
      if(isTicketDraftOrNew){
        mandatory = false;
      } else {
        // make internalOrder mandatory if we have a fire number in this row
        const rec:CostSummary_ui = ( extraParam!=null && extraParam.rec!=null)?extraParam.rec:null;
        if(rec!=null ){
          const fireNo = wdpUtil.getFormFieldVal(rec.fireNumber,true);
          mandatory = fireNo!=null && fireNo.length>0;
          let match = autoCompleteCtrl.attrs?.[extraParam.recIndex]?.internalOrder?.matchFireNo;
          if(match){
            extraParam.fireNumber = fireNo;
          }
        }
      }
    }
    if(who === "costCenter" && isTicketDraftOrNew){
      mandatory = false;
    }
    if(who === "fireNumber"){
      //// make fire number  mandatory, if the selected activity code staets withis FS
      const rec:CostSummary_ui = ( extraParam!=null && extraParam.rec!=null)?extraParam.rec:null;
      if(rec!=null ){
        const acCode = wdpUtil.getFormFieldVal(rec.costActivityCode,true); 

        mandatory=(acCode.toUpperCase().startsWith("FS",0));
      } 
    }
    if(who === "fieldSupervisor"){
      // fieldSupervisor is optional, but we need to check the maxLength
      mandatory = true;
    }
    // Ready to call the generic validation 
    err = mandatory?TicketService.validateProp(who, goodValue,extraParam ):'';
    
    return err;
  }
  /****************************************************************************************
  *****************************************************************************************/
  function validateAll(): boolean {
    const _formValues: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.values);
    const _formErrors: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.errors);
    const _formTouched: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.touched);
    
    
    let allGood = true;
    // go through the fiels
    for (let ent of Object.entries(_formValues)) {
      const who = ent[0];
      const val = ent[1];
      let err   = '';
      
      if (who === 'costSummary') {
        const csIsGood = validateCostSummaryTable(_formValues,_formErrors,_formTouched); 
        if(!csIsGood){
          err="cost summary is not valide";// this is just for debuggingh as we dont show this meesage anywhere, instesad we show the validatin eror for each col 
        }
      }
      else{
        // value might be string or GenTypeList
        err =  validateField(who, val);
        (_formErrors[who as keyof typeof formCtrl.errors] as string) = err;
        (_formTouched[who as keyof typeof formCtrl.touched] as string) = "T";
        
      }
      // at least one field is not vlaide then rhe form is bot vaalid and we should return false.
      // be carfult not to overwrite allGood if the current filed in the loop is OK 
      if(err!==''){ 
        allGood=false;
      }

    }//loop
    
    //update state
    updateFormCtrl(null, _formErrors, _formTouched);
    
    return allGood;
  }
  /****************************************************************************************
  *****************************************************************************************/
  function validateCostSummaryTable(_formValues:TicketInfo_ui,_formErrors:TicketInfo_ui,_formTouched:TicketInfo_ui,recIndex?:number,markAsTouched:boolean=true):boolean{
    let allGood=true;
    const cs = _formValues.costSummary;
    // Allow saving without cost summary rows
    if(cs==null || cs.length===0){
      return true;
    }
    let start = recIndex!=null?recIndex:0;
    let end   = recIndex!=null?recIndex+1:cs.length;
    for (let row = start; row <end; row++) {
      const csRec:CostSummary_ui = cs[row];
        for (let ent of Object.entries(csRec)) {
          const whowho= ent[0];
          const val   = ent[1];
          
          // Skip the "selected" field - it's UI state, not data
          if(whowho === 'selected') {
            continue;
          }
          
          // call the validation and update form Conrolor
          let err = validateField(whowho,val,{recIndex:row,rec:csRec});
          ((_formErrors.costSummary  as any)![row][whowho] as string) = err;
          // Only mark as touched if explicitly requested (e.g., on blur or validation before save)
          if(markAsTouched){
            ((_formTouched.costSummary as any)![row][whowho] as string) = "T";
          }
          
          
          // all good ?  Note: dont use else here 
          if(err !== ''){
            allGood=false;
          }
      }
    }
    
    return allGood;
  }
  /****************************************************************************************
  *****************************************************************************************/
  // function onTicketEdit() {
  //   // take a copy
  //   orginalData.current = wdpUtil.deepCopy(formCtrl.values);
    

  //   setPageStatus({ ...pageStatus, editPage: true });
  //   if(props.onEditModeChange){
  //     props.onEditModeChange(true);
  //   }
  // }
  /****************************************************************************************
  *****************************************************************************************/
  function onCreateTicket () {  
    onSaveBasicInfo();
    onSaveCostSummary();
  }
  /****************************************************************************************
  *****************************************************************************************/
  function onCancelTicket() {
    if(!pageStatus.updateFlow){
      // in create new ticket flow, we just go back to the previous page, no need to reset the form
      navigate(-1);
      return;
    }
    // //put back the original Data
    // const _formValues: TicketInfo_ui = wdpUtil.deepCopy(orginalData.current);
    // const _formErrors: TicketInfo_ui = wdpUtil.deepCopy(ticketEmptyObj);
    // const _formTouched:TicketInfo_ui = wdpUtil.deepCopy(ticketEmptyObj);
    // _formErrors.costSummary = [];
    // _formTouched.costSummary = [];
    
    // // re create the autoComplete stuff
    // const _autoCompletInputCtrl: AutoCompleteCtrl_InputValue[] = [];
    // const _autoCompletListCtrl: AutoCompleteCtrl_Options[] = [];
    // const _autoCompletAttsCtrl: AutoCompleteCtrl_Attributes[] = [];
    // for (let i=0;i<_formValues.costSummary.length;i++) {
      
    //   // form _autoComplet controller
    //   const recInputCtrl  = {...autoCompleteInputCtrlEmptyObj};   _autoCompletInputCtrl.push(recInputCtrl);
    //   const recOptCtrl    = {...autoCompleteOptionsCtrlEmptyObj}; _autoCompletListCtrl.push(recOptCtrl);
    //   const rec = _formValues.costSummary[i];
    //   const recAttsCtrl: AutoCompleteCtrl_Attributes = {...autoCompleteAttrsCtrlEmptyObj,internalOrder: {matchFireNo: TicketService.isInternalOrderMatchingFireNo(rec?.fireNumber as GenListType | string | null,rec?.internalOrder as GenListType | string | null)}};
    //   _autoCompletAttsCtrl.push(recAttsCtrl);
      
    //   _formErrors.costSummary?.push(wdpUtil.deepCopy(costSummaryEmptyObj));
    //   _formTouched.costSummary?.push(wdpUtil.deepCopy(costSummaryEmptyObj));
    // }
    // // ready to update FormControl
    // updateFormCtrl(_formValues, _formErrors,_formTouched);
    // setAutoCompleteCtrl({input:_autoCompletInputCtrl,options:_autoCompletListCtrl,attrs:_autoCompletAttsCtrl});

    // // In create flow keep Basic Info editable; in update flow return all sections to read-only.
    // setPageStatus((prev) => ({
    //   ...prev,
    //   editModeBySection: prev.updateFlow
    //     ? { basic: false, meal: false, travel: false, costSummary: false, notes: false }
    //     : { basic: true, meal: false, travel: false, costSummary: false, notes: false }
    // }));
    // if(props.onEditModeChange){
    //   props.onEditModeChange(false);
    // }
  }
  /****************************************************************************************
  *****************************************************************************************/
  // function onClear() {
  //   setPageStatus({ ...pageStatus, editPage: true });
  //   const _formValues: TicketInfo_ui = wdpUtil.deepCopy(ticketEmptyObj);
  //   const _formErrors: TicketInfo_ui = wdpUtil.deepCopy(ticketEmptyObj);
  //   const _formTouched:TicketInfo_ui = wdpUtil.deepCopy(ticketEmptyObj);

  //   initCostSummaryRec(_formValues.costSummary![0]); // forsure there is one

  //   // ready to update FormControl
  //   updateFormCtrl(_formValues, _formErrors, _formTouched);
  // }

  /****************************************************************************************
   *  validate before you send
  *****************************************************************************************/
  function onSave() {
    // validate all
    if (!validateAll()) {
      // we can't submit ..there are some invalid values in the form
      appLog.debug("Validation Failed. some entered information does not meet the required rules or formatting for a specific field or process.");
      return;
    }
   doSave();

  }
  /****************************************************************************************
   * Reads the ACTUAL open/closed state of each accordion directly from the DOM.
   * The goa-accordion web component manages its own open/closed state internally (via a
   * shadow-DOM <details> element) once the user toggles it by clicking - it does not keep the
   * React `open` prop in sync. So to know "who is open and who is closed" at any point in time,
   * we have to read it directly from the DOM instead of relying on React state.
  *****************************************************************************************/
  function getCurrentAccordionOpenState(): { basic: boolean; costSummary: boolean; meal: boolean; travel: boolean; work: boolean; notes: boolean } {
    const readOpen = (testId: string, fallback: boolean): boolean => {
      const hostEl = formContainerRef.current?.querySelector(`goa-accordion[testid="${testId}"]`) as HTMLElement | null;
      const detailsEl = hostEl?.shadowRoot?.querySelector('details');
      return detailsEl ? detailsEl.open : fallback;
    };
    return {
      basic:       readOpen('accordion-basic',       allAccordionOpen.basic),
      meal:        readOpen('accordion-meal',         allAccordionOpen.meal),
      travel:      readOpen('accordion-travel',       allAccordionOpen.travel),
      work:        readOpen('accordion-work',         allAccordionOpen.work),
      costSummary: readOpen('accordion-costSummary',  allAccordionOpen.costSummary),
      notes:       readOpen('accordion-notes',        allAccordionOpen.notes),
    };
  }
  /****************************************************************************************
   *  send the Form the backend
  *****************************************************************************************/
  function doSave(postSaveWarning?: string, onSuccess?: () => void, onError?: (error: unknown) => void) {
    if (isBusyRef.current) return; // a save is already in flight - ignore the re-entrant call
    if (wdpUtil.isNullorUndefined(auth.user?.access_token)) {
      handleToast("Cannot save. Authentication token is required.", "emergency");
      onError?.(new Error("Authentication token is required."));
      return;
    }

    // Remember which accordions are currently open/closed (as seen by the user) so we can
    // restore this exact layout once the save-triggered reload completes.
    accordionOpenSnapshotRef.current = getCurrentAccordionOpenState();
    const today = new Date();

    // transformation is needed
    // convert TicketInfo_ui into TicketInfo and send it to the backend
    const data_ui: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.values);

    
    const myResourceAttributes = {addOns:wdpUtil.getFormFieldVal(data_ui.addOns,true)} 
    const draftStatusItem = getStatusLookupItemByKey(getNewTicketStatusKey());

    const goodPayload: TicketInfo = {
      resourceTypeId          : wdpUtil.safeParse(myAppCtx?.lookups.resourceTypeList.find((a: GenListType) => a.label === "Heavy Equipment")?.value ),
      id                      : isNewTicket()?undefined:data_ui.id,
      
      ticketNumber            : data_ui.ticketNumber,
      date                    : data_ui.date,
      statusId                : wdpUtil.safeParse(draftStatusItem?.value),
      status                  : draftStatusItem?.label || '',

      contractNo              : wdpUtil.getFormFieldVal(data_ui.contractNumber),
      contractorName          : wdpUtil.getFormFieldVal(data_ui.contractorName),
      forestAreaId            : wdpUtil.safeParse(wdpUtil.getFormFieldVal(data_ui.forestAreaId),{type:'int'}),
      forestArea              : wdpUtil.getFormFieldVal(data_ui.forestAreaId,true),   // for sorting
      standbyBase             : data_ui.standbyBase,
      fieldSupervisor         : data_ui.fieldSupervisor,

      resourceCode            : wdpUtil.getFormFieldVal(data_ui.unitNumber),
      resourceIdentifier      : wdpUtil.getFormFieldVal(data_ui.serialNumber),
      resourceId              : wdpUtil.safeParse(wdpUtil.getFormFieldVal(data_ui.equipment)),
      resourceDisplayName     : wdpUtil.getFormFieldVal(data_ui.equipment,true),  // for sorting
      resourceAttributes      : JSON.stringify(myResourceAttributes),
      resourceSnapshotRawJson : [],
      workSegments            : [],
      travelSegments          : [],
      meals                   : [],
      lodging                 : [],
      isDraft                 : false,
      resourceComments        : "",
      timeTrackingComments    : "",
      mealsAndLodgingComments : "",
      travelTimeComments      : "",

      digitalId               : undefined, 
      requestedBy             : undefined, 
      asOfUtc                 : undefined,
      isFlagged               : Boolean(data_ui.isFlagged),
      isReturnable            : Boolean(data_ui.isReturnable)
    }
    
    const strippedDown = resourceSnapshotRawJsonFromFires.filter((e: FireEquipmentInfo_raw) => 
          e.contractNumber  === goodPayload.contractNo    && 
          e.unitNumber      === goodPayload.resourceCode  && 
          e.serialNumber    === goodPayload.resourceIdentifier 
        );
    goodPayload.resourceSnapshotRawJson = [...strippedDown];

    // go through  costSummary array and do transformation for each segment
    //
    for (const cs of data_ui.costSummary!) {
      const rateTypeLabel = (cs.rateType as GenListType)?.label || "";
      // find the segment Type based on the Selected RateType
      
      //  Work Segment
      if (wdpUtil.includesIgnoreCase(workRateType,rateTypeLabel!)) {
          const fuelVal = cs.workFuelProvidedByGoa;
          const wrokSeg: Partial<WorkSegmentInfo> = {
            workPerformed     : wdpUtil.isNullOrEmpty(cs.workPerformedType ?? null) ? wdpUtil.getFormFieldVal(cs.costActivityCode,true) : wdpUtil.getFormFieldVal(cs.workPerformedType,true), // fallback to costActivityCode approximation until every row has workPerformedType
            costingActivityId : wdpUtil.getFormFieldVal(cs.costActivityCode), 
            startUtc          : wdpUtil.isNullOrEmpty(cs.workStartUtc ?? null) ? today.toISOString() : wdpUtil.toIsoStringOrEmpty(cs.workStartUtc),
            stopUtc           : wdpUtil.isNullOrEmpty(cs.workFinishUtc ?? null) ? today.toISOString() : wdpUtil.toIsoStringOrEmpty(cs.workFinishUtc),
            isFuelProvidedByGOA: fuelVal === "yes" ? true : fuelVal === "no" ? false : null,
        }
        addExpense(wrokSeg, cs);
        goodPayload.workSegments!.push(wrokSeg as WorkSegmentInfo);
      }
      // Travel Segment
      if (wdpUtil.includesIgnoreCase(TravelCostRateType,rateTypeLabel!)) {
        const travelSeg: Partial<TravelSegmentInfo> = {
          costingActivityId: wdpUtil.getFormFieldVal(cs.costActivityCode),
        }
        addExpense(travelSeg, cs);
        // add extra info for travel segment
        travelSeg.from      = cs.travelFrom;
        travelSeg.to        = cs.travelTo;  
        travelSeg.startUtc  = wdpUtil.toIsoStringOrEmpty(cs.travelStartUtc);
        travelSeg.finishUtc = wdpUtil.toIsoStringOrEmpty(cs.travelFinishUtc);
        
        goodPayload.travelSegments!.push(travelSeg as TravelSegmentInfo);
      }
      // Meal Segment
      if (wdpUtil.includesIgnoreCase(MealCostRateType,rateTypeLabel!)) {
        const mealSeg: Partial<MealProvisionInfo> = {
          costingActivityId: wdpUtil.getFormFieldVal(cs.costActivityCode),
        }
        addExpense(mealSeg, cs);
        goodPayload.meals!.push(mealSeg as MealProvisionInfo);
      }
      // Lodging Segment
      if (wdpUtil.includesIgnoreCase(LodgingCostRateType,rateTypeLabel!)) {
        const lodgingSeg: Partial<LodgingProvisionInfo> = {
          costingActivityId: wdpUtil.getFormFieldVal(cs.costActivityCode),
        }
        addExpense(lodgingSeg, cs);
        goodPayload.lodging!.push(lodgingSeg as LodgingProvisionInfo);
      }
    } // loop

    // Ready to submit (add or update)
    setIsBusy(true);
    setProgressMsg("Saving and refreshing...");
    if (isNewTicket()) {
      ApiService.createTicket(auth.user?.access_token as string, goodPayload).then(res => {
        // in case of null
        if (!wdpUtil.isNullorUndefined(res)) {
          // save is done ... reset Errors and touched 
          resetFormTrackers();
          redirectId.current = { id: res.id, ticketNumber: res.ticketNumber };
          handleToast(postSaveWarning ?? "Time ticket successfully created.", postSaveWarning ? "important" : "success", "refresh");
          if (typeof props.onChange === "function") {
            props.onChange(goodPayload);
          }
          onSuccess?.();
        }
        else {
          // backend failed
          handleToast("Time ticket failed to save.", 'emergency');
          onError?.(new Error("Time ticket failed to save."));
        }
      }).catch((error) => {
        handleServerError(error, 'Time ticket failed to save');
        onError?.(error);
      }).finally(() => { if (!reloadPendingRef.current) { setIsBusy(false); setProgressMsg(""); } });

    } else {
      // UPDATE Ticket Logic goes here
      ApiService.updateTicket(auth.user?.access_token as string, goodPayload).then(res => {
        // in case of null
        // if (!wdpUtil.isNullorUndefined(res)) {
        // save is done ... reset Errors and touched 
        resetFormTrackers();
        redirectId.current = { id: res.id, ticketNumber: res.ticketNumber };
        handleToast(postSaveWarning ?? "Time ticket successfully saved.", postSaveWarning ? "important" : "success", "refresh");
        if (typeof props.onChange === "function") {
          props.onChange(goodPayload);
        }
        onSuccess?.();
      }).catch((error) => {
        handleServerError(error, 'Time ticket failed to save');
        onError?.(error);
      }).finally(() => { if (!reloadPendingRef.current) { setIsBusy(false); setProgressMsg(""); } });
    }
  }
  /****************************************************************************************
   * Helper function to save pending notes after ticket creation
  *****************************************************************************************/
  async function applyNotesSectionSave(ticketId: string, notes: string[]): Promise<void> {
    const token = auth.user?.access_token as string;
    const failedNotes: string[] = [];

    // Save notes sequentially to maintain order
    for (const noteBody of notes) {
      try {
        await ApiService.addTicketNote(token, ticketId, noteBody);
      } catch (error) {
        appLog.error('Failed to save note:', noteBody, error);
        failedNotes.push(noteBody);
      }
    }

    // If any notes failed, throw an error with details
    if (failedNotes.length > 0) {
      throw new Error(`Failed to save ${failedNotes.length} of ${notes.length} notes`);
    }
  };

  /****************************************************************************************
  *****************************************************************************************/
  const handleServerError = (error: any, operationMessage?: string) => {
    setProgressMsg("");
    appLog.error('Server error:', error);
    let errorMessage = operationMessage || 'Operation has failed';
    
    if (error?.status >= 400 && error?.status < 500 && error?.message) {
      errorMessage = error?.response?.data?.detail || error.message || errorMessage;
    }
    handleToast(errorMessage, 'emergency');
  };
  /****************************************************************************************
   * Single entry point for every toast in this page, AND the former Toast component's
   * onClose handler logic (navigate/reload) - folded in here because the new notification
   * fires immediately (no close-delay needed)
   *
   * _trigger drives what happens after the notification is shown - at most ONE of these fires:
   *  - "ticketDel": the ticket no longer exists, go home and return immediately - do NOT fall
   *    through to the redirectId check below, it may still hold a stale id from an earlier save.
   *  - "returnToDashboard": a Return/Verify action just succeeded - go home and return immediately
   *    (same as "ticketDel"), instead of reloading the ticket in place like the other status actions.
   *  - "refresh": reload the current ticket in place (post save/approve/submit/etc.) via
   *    reloadPage(); redirectId (if any, i.e. a just-created ticket) is still honored after this.
   *  - undefined (e.g. flag toggle, notes save): no navigation, just fall through to the
   *    redirectId check.
   * redirectId.current is set once by doSave() right after a successful CREATE (so the "new"
   * route can be swapped for the real ticket id/number) and is NOT trigger-specific - it's
   * consumed/cleared here so it can only ever redirect once and can't leak into a later,
   * unrelated toast call.
  *****************************************************************************************/
  function handleToast(_msg: string, _type: GoabCalloutType, _trigger?: string) {
    // For a "refresh" trigger, leave progressMsg/isBusy up - reloadPendingRef + loadTicket() own
    // clearing them once the reload actually finishes, so the spinner never un-blocks early.
    if (_trigger === "refresh") {
      reloadPendingRef.current = true;
    } else {
      setProgressMsg("");
    }
    // GoabCalloutType -> GoabTemporaryNotificationType: success->success, emergency->failure, everything else->basic
    const notificationType: GoabTemporaryNotificationType = _type === 'success' ? 'success' : _type === 'emergency' ? 'failure' : 'basic';
    TemporaryNotification.show(_msg, { type: notificationType, duration: 'short' });
    if (_trigger === "ticketDel" || _trigger === "returnToDashboard") {
      navigate("/");
      return; // skip the redirectId check below, it may hold a stale id from an earlier save
    }
    if (_trigger === "refresh") {
      reloadPage();
    }
    // Swap the "new" route for the real ticket id/number right after its first successful save.
    if (redirectId.current && redirectId.current.id && redirectId.current.ticketNumber) {
      navigate(`/ticket-ctrl/${redirectId.current.id}/${redirectId.current.ticketNumber}`);
      redirectId.current = { id: '', ticketNumber: '' }; // consumed - don't let it fire again for a later unrelated toast
    }
  };
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function reloadPage() {
    setRefresh(prev => !prev);
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function onShowAllSections() {
    let cur: any = { ...allAccordionOpen };
    const values = Object.values(cur);
    const all = values.every(value => typeof value === 'boolean' && value === true);
    const any = values.some(value => typeof value === 'boolean' && value === true);

    const newSt = any ? false : !all;
    for (const e in cur) {
      cur[e] = newSt;
    }
    setAllAccordionOpen(cur);
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function onTicketApprove() {
    if (isBusyRef.current) return;
    if (wdpUtil.isNullorUndefined(getMyTicketId())) {
      handleToast("Cannot approve. ticketId is required.", "emergency");
      return;
    }
    if (wdpUtil.isNullorUndefined(auth.user?.access_token)) {
      handleToast("Cannot approve. Authentication token is required.", "emergency");
      return;
    }

    // call backend API to approve the ticket
    // on success show toast and redirect to read only page
    const approvedStatusItem = getStatusLookupItemByKey("APPROVED");
    const data = {
      status: approvedStatusItem?.label || 'Approved',
      statusId: wdpUtil.safeParse(approvedStatusItem?.value),
      requestedBy: auth.user?.profile?.email || "",
    };
    setIsBusy(true);
    setProgressMsg("Approving...");
    ApiService.approveTicket(auth.user?.access_token as string, getMyTicketId(), data).then(res => {
      handleToast("Time ticket successfully approved.", "success", 'refresh');
    }).catch((error) => {
      handleServerError(error, 'Failed to approve time ticket');
    }).finally(() => { if (!reloadPendingRef.current) { setIsBusy(false); setProgressMsg(""); } });
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function onTicketUnapprove() {
    if (isBusyRef.current) return;
    if (wdpUtil.isNullorUndefined(getMyTicketId())) {
      handleToast("Cannot unapprove. ticketId is required.", "emergency");
      return;
    }
    if (wdpUtil.isNullorUndefined(auth.user?.access_token)) {
      handleToast("Cannot unapprove. Authentication token is required.", "emergency");
      return;
    }
    // call backend API to unapprove the ticket
    // on success show toast and redirect to edit page
    const signedOffStatusItem = getStatusLookupItemByKey("SIGNED-OFF");
    const data = {
      ticketId: getMyTicketId(),
      status: signedOffStatusItem?.label || 'Signed Off',
      statusId: wdpUtil.safeParse(signedOffStatusItem?.value),
      requestedBy: auth.user?.profile?.email || "",
    };
    setIsBusy(true);
    setProgressMsg("Unapproving...");
    ApiService.UnapproveTicket(auth.user?.access_token as string, getMyTicketId(), data).then(res => {
      handleToast("Time ticket successfully unapproved.", "success", 'refresh');
    }).catch((error) => {
      handleServerError(error, 'Failed to unapprove time ticket');
    }).finally(() => { if (!reloadPendingRef.current) { setIsBusy(false); setProgressMsg(""); } });
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function onTicketDelete() {
    if (isBusyRef.current) return;
    if (wdpUtil.isNullorUndefined(getMyTicketId())) {
      handleToast("Cannot delete. ticketId is required.", "emergency");
      return;
    }
    if (wdpUtil.isNullorUndefined(auth.user?.access_token)) {
      handleToast("Cannot delete. Authentication token is required.", "emergency");
      return;
    }
    // call backend API to delete the ticket
    // on success show toast and redirect to home page
    const data = {};
    setIsBusy(true);
    setProgressMsg("Deleting...");
    ApiService.deleteTicket(auth.user?.access_token as string, getMyTicketId(), data).then(res => {
      handleToast("Time ticket successfully deleted.", "success", 'ticketDel');
    }).catch((error) => {
      handleServerError(error, 'Failed to delete time ticket');
    }).finally(() => { if (!reloadPendingRef.current) { setIsBusy(false); setProgressMsg(""); } });
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function hasConstSummaryInvoice(): boolean {
    const hasInvoice = !wdpUtil.isNullorUndefined(formCtrl.values.costSummary)
      && Array.isArray(formCtrl.values.costSummary)
      && formCtrl.values.costSummary.some(cs => !wdpUtil.isNullorUndefined(cs.invoiceId) && cs.invoiceId !== '');
    return hasInvoice;
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function onTicketDeleteStart() {
    if (["APPROVED", "SIGNED-OFF", "PROCESSED"].includes(getCurrentStatusLookupKey()) || hasConstSummaryInvoice()) {
      setShowDeleteTicketWarningModal(true);
    } else {
      setShowDeleteTicketModal(true);
    }
  }
  /****************************************************************************************
   * Toggle flag status of the ticket
  *****************************************************************************************/
  function onToggleFlag() {
    if (isNewTicket()) return; // Cannot flag unsaved tickets
    if (isBusyRef.current) return;
    
    const currentFlagState = formCtrl.values.isFlagged;
    setIsBusy(true);
    setProgressMsg("Updating flag...");
    const apiCall = currentFlagState 
      ? ApiService.unflagTicket(auth.user?.access_token as string, ticketId as string)
      : ApiService.flagTicket(auth.user?.access_token as string, ticketId as string);
    
    apiCall
      .then(_res => {
        // Update local state
        const _formValues = wdpUtil.deepCopy(formCtrl.values);
        const _formErrors = wdpUtil.deepCopy(formCtrl.errors);
        const _formTouched = wdpUtil.deepCopy(formCtrl.touched);
        _formValues.isFlagged = !currentFlagState;
        updateFormCtrl(_formValues, _formErrors, _formTouched);
        
        const message = currentFlagState ? "Flag removed from time ticket." : "Time ticket flagged for review.";
        handleToast(message, "success");
      })
      .catch((error) => {
        handleServerError(error, 'Failed to update flag status');
      })
      .finally(() => { if (!reloadPendingRef.current) { setIsBusy(false); setProgressMsg(""); } });
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function onTicketSubmit() {
    if (isBusyRef.current) return;
    if (wdpUtil.isNullorUndefined(getMyTicketId())) {
      handleToast("Cannot submit. ticketId is required.", "emergency");
      return;
    }
    if (wdpUtil.isNullorUndefined(auth.user?.access_token)) {
      handleToast("Cannot submit. Authentication token is required.", "emergency");
      return;
    }

    const submittedOffStatusItem = getStatusLookupItemByKey("SUBMITTED");
    const data = {
      ticketId: getMyTicketId(),
      status: submittedOffStatusItem?.label || 'Submitted',
      statusId: wdpUtil.safeParse(submittedOffStatusItem?.value),
      requestedBy: auth.user?.profile?.email || "",
    };
    setIsBusy(true);
    setProgressMsg("Submitting...");
    ApiService.submitTicket(auth.user?.access_token as string, getMyTicketId(), data).then(res => {
      handleToast("Time ticket successfully submitted.", "success", 'refresh');
    }).catch((error) => {
      handleServerError(error, 'Failed to submit time ticket');
    }).finally(() => { if (!reloadPendingRef.current) { setIsBusy(false); setProgressMsg(""); } });
  }

  function onTicketVerify() {
    if (isBusyRef.current) return;
    if (wdpUtil.isNullorUndefined(getMyTicketId())) {
      handleToast("Cannot verify. ticketId is required.", "emergency");
      return;
    }
    if (wdpUtil.isNullorUndefined(auth.user?.access_token)) {
      handleToast("Cannot verify. Authentication token is required.", "emergency");
      return;
    }

    const verifiedStatusItem = getStatusLookupItemByKey("IN-PROGRESS");
    const data = {
      ticketId: getMyTicketId(),
      status: verifiedStatusItem?.label || 'In-Progress',
      statusId: wdpUtil.safeParse(verifiedStatusItem?.value),
      requestedBy: auth.user?.profile?.email || "",
    };
    // Verify always moves the ticket to In-Progress. Roles that still have view access at
    // In-Progress (e.g. Area Sign Off/Finance) should stay and see the reloaded ticket; roles
    // that lose access there (Operational Reviewer) have nothing left to do, so send them home.
    const retainsViewAfterVerify = getViewableStatusLookupKeys(getTicketRole(auth)).includes("IN-PROGRESS");
    setIsBusy(true);
    setProgressMsg("Verifying...");
    ApiService.verifyTicket(auth.user?.access_token as string, getMyTicketId(), data).then(res => {
      handleToast("Time ticket successfully verified.", "success", retainsViewAfterVerify ? 'refresh' : 'returnToDashboard');
    }).catch((error) => {
      handleServerError(error, 'Failed to verify time ticket');
    }).finally(() => { if (!reloadPendingRef.current) { setIsBusy(false); setProgressMsg(""); } });
  }

  /****************************************************************************************
   * Opens the mandatory revision-note prompt before returning a ticket to Needs Attention.
   * "Share with operator & vendor" is selected by default per requirements.
  *****************************************************************************************/
  function onTicketReturnStart() {
    setReturnTicketNote('');
    setReturnShareWithOperatorVendor(true);
    setNotesDrawerMode('return');
    setNotesDrawerOpen(true);
  }

  function onTicketReturn() {
    if (isBusyRef.current) return;
    if (wdpUtil.isNullorUndefined(getMyTicketId())) {
      handleToast("Cannot return. ticketId is required.", "emergency");
      return;
    }
    if (wdpUtil.isNullorUndefined(auth.user?.access_token)) {
      handleToast("Cannot return. Authentication token is required.", "emergency");
      return;
    }
    const noteBody = returnTicketNote.trim();
    if (noteBody === '') {
      handleToast("Cannot return. A revision note is required.", "emergency");
      return;
    }

    const returnedStatusItem = getStatusLookupItemByKey("NEEDS-ATTENTION");
    const data = {
      ticketId: getMyTicketId(),
      status: returnedStatusItem?.label || 'Returned',
      statusId: wdpUtil.safeParse(returnedStatusItem?.value),
      requestedBy: auth.user?.profile?.email || "",
    };
    const token = auth.user?.access_token as string;
    const ticketId = getMyTicketId();
    setIsBusy(true);
    setProgressMsg("Returning...");
    ApiService.addTicketNote(token, ticketId, noteBody, returnShareWithOperatorVendor ? 'External' : undefined)
      .then(() => ApiService.returnTicket(token, ticketId, data))
      .then(() => {
        // Returning a ticket sends it back to the operator/vendor - nothing left for this
        // reviewer to do here, so go back to the dashboard instead of reloading in place.
        handleToast("Time ticket successfully returned.", "success", 'returnToDashboard');
      }).catch((error) => {
        handleServerError(error, 'Failed to return time ticket');
      }).finally(() => { if (!reloadPendingRef.current) { setIsBusy(false); setProgressMsg(""); } });
  }
  
  function onTicketSignOff() {
    if (isBusyRef.current) return;
    if (wdpUtil.isNullorUndefined(getMyTicketId())) {
      handleToast("Cannot sign off. ticketId is required.", "emergency");
      return;
    }
    if (wdpUtil.isNullorUndefined(auth.user?.access_token)) {
      handleToast("Cannot sign off. Authentication token is required.", "emergency");
      return;
    }

    const signedOffStatusItem = getStatusLookupItemByKey("SIGNED-OFF");
    const data = {
      ticketId: getMyTicketId(),
      status: signedOffStatusItem?.label || 'Signed Off',
      statusId: wdpUtil.safeParse(signedOffStatusItem?.value),
      requestedBy: auth.user?.profile?.email || "",
    };
    setIsBusy(true);
    setProgressMsg("Signing off...");
    ApiService.signOffTicket(auth.user?.access_token as string, getMyTicketId(), data).then(res => {
      handleToast("Time ticket successfully signed Off.", "success", 'refresh');
    }).catch((error) => {
      handleServerError(error, 'Failed to sign off time ticket');
    }).finally(() => { if (!reloadPendingRef.current) { setIsBusy(false); setProgressMsg(""); } });
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function formatPdfTime(utc?: string | null): string | null {
    return utc ? dayjs(utc).tz().format('HH:mm') : null;
  }

  function formatPdfDateTime(utc?: string | null): string | null {
    return utc ? dayjs(utc).tz().format('YYYY-MM-DD HH:mm') : null;
  }

  function computePdfTotalHours(startUtc?: string | null, stopUtc?: string | null): number | null {
    if (!startUtc || !stopUtc) return null;
    return Math.round((dayjs(stopUtc).diff(dayjs(startUtc), 'minute') / 60) * 100) / 100;
  }

  /****************************************************************************************
   * Builds the data payload handed to the ADSP PDF Service "time-ticket-summary" template.
   * freshNotes, when provided, is used instead of formCtrl.values.notes - the notes list is
   * loaded asynchronously and can be stale/empty in state at the moment the PDF is requested.
  *****************************************************************************************/
  function buildTicketPdfData(freshNotes?: NoteItem[]) {
    const vals = formCtrl.values;

    const basicInfo = {
      ticketNumber: vals.digitalId || null,
      fp167Number: vals.ticketNumber || null,
      date: vals.date || null,
      contractNo: wdpUtil.getFormFieldVal(vals.contractNumber, true) || null,
      contractorName: vals.contractorName || null,
      forestArea: wdpUtil.getFormFieldVal(vals.forestAreaId, true) || null,
      standbyBase: vals.standbyBase || null,
      fieldSupervisor: vals.fieldSupervisor || null,
      unitNumber: wdpUtil.getFormFieldVal(vals.unitNumber, true) || null,
      serialNumber: wdpUtil.getFormFieldVal(vals.serialNumber, true) || null,
      equipmentTypeAndSubType: wdpUtil.getFormFieldVal(vals.equipment, true) || null,
      addOns: wdpUtil.getFormFieldVal(vals.addOns, true) || null,
    };

    const workPerformedByRateType = new Map<string, number>();
    for (const e of vals.costSummary || []) {
      if (wdpUtil.isNullorUndefined(e.workPerformedType)) continue;
      const rateType = wdpUtil.getFormFieldVal(e.rateType, true) || '';
      const hours = wdpUtil.safeParse(e.noOfUnits, { type: "float" }) || 0;
      workPerformedByRateType.set(rateType, (workPerformedByRateType.get(rateType) ?? 0) + hours);
    }
    const workPerformed = Array.from(workPerformedByRateType.entries()).map(([rateType, totalHours]) => ({
      rateType: rateType || null,
      totalHours: wdpUtil.formatHoursToHM(totalHours),
    }));

    const hasMealsOrLodging = mealsCanClaim.breakfast || mealsCanClaim.lunch || mealsCanClaim.dinner || mealsCanClaim.lodging;
    const mealsAndLodging = hasMealsOrLodging ? {
      eligible: 'Yes',
      breakfast: mealsCanClaim.breakfast,
      lunch: mealsCanClaim.lunch,
      dinner: mealsCanClaim.dinner,
      lodging: mealsCanClaim.lodging,
    } : null;

    const travelTime = travelEntries.length > 0
      ? { totalHours: wdpUtil.formatHoursToHM(travelEntries.reduce((sum, t) => sum + (computePdfTotalHours(t.startUtc, t.finishUtc) ?? 0), 0)) }
      : null;

    const notesSource = freshNotes ?? vals.notes;
    const notes = (notesSource && notesSource.length > 0)
      ? notesSource.map((n: NoteItem) => ({
        author: n.createdByDisplayName || n.createdBy || null,
        body: n.body || null,
        // The PDF template renders one block per line, so line breaks survive even if the
        // template's CSS is ignored. Blank lines use a non-breaking space to keep their height.
        bodyLines: n.body ? n.body.split(/\r\n|\r|\n/).map((line) => (line.trim() === '' ? '\u00A0' : line)) : [],
        createdAtUtc: formatPdfDateTime(n.createdAtUtc),
      }))
      : null;

    return {
      basicInfo,
      workPerformed,
      mealsAndLodging,
      travelTime,
      notes,
      ticketVerification: { message: null, submitted: null, submittedBy: null, signedOffByGoa: null },
      generatedAt: dayjs().tz().format('YYYY-MM-DD HH:mm'),
    };
  }

  /****************************************************************************************
   * 
  *****************************************************************************************/
  function onDownloadTicketPdf() {
    if (isBusyRef.current) return;
    if (wdpUtil.isNullorUndefined(getMyTicketId())) {
      handleToast("Cannot download PDF. ticketId is required.", "emergency");
      return;
    }
    if (wdpUtil.isNullorUndefined(auth.user?.access_token)) {
      handleToast("Cannot download PDF. Authentication token is required.", "emergency");
      return;
    }

    const filename = `${formCtrl.values.digitalId || getMyTicketId()}-Summary.pdf`;

    setIsBusy(true);
    ApiService.getTicketNotes(auth.user?.access_token as string, getMyTicketId())
      .catch(() => undefined)
      .then((freshNotes: NoteItem[] | undefined) => {
        const data = buildTicketPdfData(Array.isArray(freshNotes) ? freshNotes : undefined);
        const pdfRequest = {
          operation: 'generate',
          templateId: appPdfTemplateId,
          filename,
          data,
        };
        return pdfService.pdfFile(auth.user?.access_token as string, pdfRequest);
      }).then(pdfUrl => {
      if (!pdfUrl) {
        handleToast("Failed to download PDF summary", "emergency");
        return;
      }
      wdpUtil.downloadFromUrl(pdfUrl, filename);
    }).catch((error) => {
      handleServerError(error, 'Failed to download PDF summary');
    }).finally(() => setIsBusy(false));
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function onTicketUnsignOff() {
    if (isBusyRef.current) return;
    if (wdpUtil.isNullorUndefined(getMyTicketId())) {
      handleToast("Cannot unsign off. ticketId is required.", "emergency");
      return;
    }
    if (wdpUtil.isNullorUndefined(auth.user?.access_token)) {
      handleToast("Cannot unsign off. Authentication token is required.", "emergency");
      return;
    }

    const inProgressStatusItem = getStatusLookupItemByKey("IN-PROGRESS");
    const data = {
      ticketId: getMyTicketId(),
      status: inProgressStatusItem?.label || 'In-Progress',
      statusId: wdpUtil.safeParse(inProgressStatusItem?.value),
      requestedBy: auth.user?.profile?.email || "",
    };
    setIsBusy(true);
    setProgressMsg("Unsigning off...");
    ApiService.UnsignOffTicket(auth.user?.access_token as string, getMyTicketId(), data).then(res => {
      handleToast("Time ticket successfully unsigned Off.", "success", 'refresh');
    }).catch((error) => {
      handleServerError(error, 'Failed to unsign off time ticket');
    }).finally(() => { if (!reloadPendingRef.current) { setIsBusy(false); setProgressMsg(""); } });
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function getNewTicketStatusKey(): TicketStatusLookupKey {
    const role = getTicketRole(auth);
    return role === "operator" ? "NOT-SUBMITTED" : "IN-PROGRESS";
  }

  function getStatusLookupItemByKey(lookupKey: TicketStatusLookupKey): GenListType | undefined {
    const statusItem = TicketStatuses.find((ts) => ts.lookupKey === lookupKey);
    if (!statusItem) {
      appLog.error(`Status with lookupKey ${lookupKey} not found in TicketStatuses.`);
      return undefined;
    }
    const statusLookup = myAppCtx?.lookups.ticketStatusList.find((ts: GenListType) => ts.value === statusItem.lookupId.toString());
    if (!statusLookup) {
      appLog.error(`Status with value ${statusItem.lookupId} not found in ticketStatusList.`);
      return undefined;
    }
    return statusLookup;
  }

  /******************************************************************************************
    
  *******************************************************************************************/
  function isCriticalValid(){
    const vals = formCtrl.values;
    const dateValid = !wdpUtil.isNullorUndefined(vals.date) && validateField("date", vals.date as string | GenListType | null) === "";
    const contractValid = vals.contractNumber != null && validateField("contractNumber", vals.contractNumber as string | GenListType | null) === "";
    return dateValid && contractValid;
  }
  /******************************************************************************************
    
  *******************************************************************************************/
  function isBasicInfoValid() {
    const vals = formCtrl.values;
    if (!isCriticalValid()) {
      return false;
    }

    const requiredBasicFields: Array<keyof TicketInfo_ui> = ["unitNumber", "serialNumber", "forestAreaId", "equipment"];
    return requiredBasicFields.every((fieldName) => {
      const value = vals[fieldName] as string | GenListType | null;
      return value != null && validateField(fieldName as string, value) === "";
    });
  }
    
  function extractTravelCostEntries(costSummary: CostSummary_ui[]): TravelClaimsExpenses[] {
    const ret = costSummary.filter(e =>e.rateType && wdpUtil.strEqual((e.rateType as GenListType).label, "travel"))
      .map(e => ({
        id: e.id || "",
        from: e.travelFrom || "",
        to: e.travelTo || "",
        startUtc: e.travelStartUtc || "",
        finishUtc: e.travelFinishUtc || "",
        noOfUnits: e.noOfUnits || ""
      }));
    return ret;
  }
  
  function extractWorkCostEntries(costSummary: CostSummary_ui[]): WorkClaimsExpenses[] {
    const ret = costSummary.filter(e => !wdpUtil.isNullorUndefined(e.workPerformedType))
      .map(e => ({
        id: e.id || "",
        startUtc: e.workStartUtc || "",
        finishUtc: e.workFinishUtc || "",
        noOfUnits: e.noOfUnits || "",
        workPerformed: e.workPerformedType ?? null,
        fireNumber: e.fireNumber ?? null,
        assignedToWildfire: e.workAssignedToWildfire || "",
        fuelProvidedByGoa: e.workFuelProvidedByGoa || "",
      }));
    return ret;
  }

  function extractMealCostEntries(costSummary: CostSummary_ui[]): MealsClaimsExpenses {
    // Default return structure
    const result: MealsClaimsExpenses = {breakfast: false,lunch: false,dinner: false,lodging: false};
    for (const rec of costSummary) {
    const rateLabel = wdpUtil.getFormFieldVal(rec.rateType, true);

    if (wdpUtil.strEqual(rateLabel, "Crew Exp - Breakfast")) {result.breakfast = true;}
    if (wdpUtil.strEqual(rateLabel, "Crew Exp - Lunch")) {result.lunch = true;}
    if (wdpUtil.strEqual(rateLabel, "Crew Exp - Dinner")) {result.dinner = true;}
    if (wdpUtil.strEqual(rateLabel, "Accommodation")) {result.lodging = true;}
    }

    return result;
  }

  /******************************************************************************************
   * True when the ticket hasn't been persisted to the backend yet (create-new-ticket flow).
   * Based on the resolved form data id rather than the raw route param, so it's the single
   * reliable source for "is this a new/unsaved ticket" UI checks - it stays correct regardless
   * of which route was used to arrive here.
  *******************************************************************************************/
  function isNewTicket(): boolean {
    return wdpUtil.isNullOrEmpty(formCtrl.values.id);
  }
  /******************************************************************************************
   * The real backend ticket id, used for API calls (approve/unapprove/sign-off/unsign-off).
   * Read from formCtrl.values.id rather than the route param, since the route may only carry
   * digitalId (ticketId param undefined) - formCtrl.values.id is populated from the loaded
   * ticket in populateForm() regardless of which route was used to arrive here. Replaces the
   * old effectiveTicketId state, which duplicated the same value in a second source of truth.
   *
   * Guards against calling this before the ticket has actually loaded/saved (formCtrl.values.id
   * still empty/null/undefined) - returns '' instead of blindly casting, so callers relying on
   * wdpUtil.isNullorUndefined(getMyTicketId()) get a real falsy string, and a console warning is
   * logged to help catch call sites that fire too early (e.g. during the new-ticket flow).
  *******************************************************************************************/
  function getMyTicketId(): string {
    const id = formCtrl.values.id;
    if (wdpUtil.isNullOrEmpty(id)) {
      appLog.warn('getMyTicketId() called while formCtrl.values.id is not populated yet (new/unloaded ticket).');
      return '';
    }
    return id;
  }
  /******************************************************************************************
    
  *******************************************************************************************/
  function canAddCostSummary() {
    // 1 - do we have basic ifo  
      return canManageCostSummaryRows(ticketPermissions) && isBasicInfoValid();
  }
  /******************************************************************************************
   * Check if cost summary rows can be deleted
  *******************************************************************************************/
  function canDeleteCostSummary() {
    if (!canManageCostSummaryRows(ticketPermissions)) return false;
    const selectedRows = formCtrl.values.costSummary!.filter(e => e.selected);
    const deletableSelectedRows = selectedRows.filter(e => !TicketService.isManagedCostSummaryRateType(e.rateType as GenListType | string | null, e.workPerformedType));
    const totalRows = formCtrl.values.costSummary!.length;
    const allRowsSelected = deletableSelectedRows.length === totalRows;
    const isInProgress = getCurrentStatusLookupKey() === "IN-PROGRESS"
     || isNewTicket(); // for new ticket we consider it as in progress to allow adding/deleting rows before the first save 
    
    // No selected rows
    if (deletableSelectedRows.length === 0) return false;
    
    // All rows selected and status is not IN-PROGRESS -> disable delete
    if (allRowsSelected && !isInProgress) return false;
    
    // More than 1 row total - can delete selected rows (existing behavior)
    if (totalRows > 1) return true;
    
    // Exactly 1 row - can only delete if:
    // 1. Status is IN-PROGRESS
    // 2. It has no invoice
    if (totalRows === 1 && deletableSelectedRows.length === 1) {
      const lastRow = formCtrl.values.costSummary![0];
      const hasNoInvoice = wdpUtil.isNullorUndefined(lastRow.invoiceId) || lastRow.invoiceId === '';
      return hasNoInvoice && isInProgress;
    }
    
    return false;
  }
  /******************************************************************************************
   * 
  *******************************************************************************************/
  function initTicket(ticketRec: TicketInfo_ui) {
    // init goes here 
      ticketRec.id = '';
      ticketRec.contractNumber=null;
      ticketRec.forestAreaId= null;
      ticketRec.unitNumber= null;
      ticketRec.serialNumber= null;
      ticketRec.equipment= null;
      ticketRec.addOns= null;
  }
  /******************************************************************************************
   * 
  *******************************************************************************************/
  function initCostSummaryRec(csRec: CostSummary_ui) {
    // ini cost Summary  
    let initCostCenter = null;
    if(formCtrl.values.forestAreaId!=null){
      const selectedForestArea = formCtrl.values.forestAreaId!=null? wdpUtil.getFormFieldVal(formCtrl.values.forestAreaId,true) : '';
      const goodOpts: GenListType[] = TicketService.getCostCenter4ForestArea(myAppCtx?.lookups,selectedForestArea); // exprecting just one item 
      if(goodOpts!=null && goodOpts.length===1){
        initCostCenter = (goodOpts!=null && goodOpts.length===1)? goodOpts[0]:null;
      }
    }


    if (!wdpUtil.isNullorUndefined(csRec)) {
      csRec.id        = "";
      csRec.noOfUnits = "0.00";
      csRec.rateUnit  = null;//myAppCtx?.lookups.costRateUnitList.find((e:GenListType) => e.value.toUpperCase() === "hour")||null;
      csRec.fund      = "41";
      csRec.account   = "6020700200";
      csRec.invoiceId = null;
      csRec.invoiceNo = null;
      csRec.costCenter = initCostCenter;
      csRec.internalOrder = null;
    }
  }
  /******************************************************************************************
   * 
  *******************************************************************************************/
  function onAddNewCostSummary(initExpense?:{type:string,expenseVals:TravelClaimsExpenses[]|null}) {
    if (!canManageCostSummaryRows(ticketPermissions)) {
      appLog.warn("Adding cost summary rows is not permitted for this ticket.");
      return;
    }
    const _formValues  = wdpUtil.deepCopy(formCtrl.values);
    const _formErrors  = wdpUtil.deepCopy(formCtrl.errors);
    const _formTouched = wdpUtil.deepCopy(formCtrl.touched);
    // This will store the deferred change
    //let queueChange: { who: string; value: any } | null = null;
    
    // Create autocomplete arrays ONCE
    const _autoCompInput  = [...autoCompleteCtrl.input];
    const _autoCompLists  = [...autoCompleteCtrl.options];
    const _autoCompAtts   = [...autoCompleteCtrl.attrs];

    // Helper to push one row everywhere
    const pushRow=(newRecVal: CostSummary_ui)=> {
      _formValues.costSummary!.push(newRecVal);
      _formErrors.costSummary!.push({ ...costSummaryEmptyObj });
      _formTouched.costSummary!.push({ ...costSummaryEmptyObj });

      _autoCompInput.push({ ...autoCompleteInputCtrlEmptyObj });
      _autoCompLists.push({ ...autoCompleteOptionsCtrlEmptyObj });
      _autoCompAtts.push({ ...autoCompleteAttrsCtrlEmptyObj });
      return _formValues.costSummary!.length - 1; // correct index
    }
  

    // -------------------------------------------------
    // CASE 1: No initExpense → add ONE empty row
    // -------------------------------------------------
    if (!initExpense) {
      const newRecVal = { ...costSummaryEmptyObj };
      initCostSummaryRec(newRecVal);
      pushRow(newRecVal);
      // ready to update FormCtrl
      updateFormCtrl(_formValues, _formErrors, _formTouched);
      setAutoCompleteCtrl({ input: _autoCompInput, options: _autoCompLists,attrs:_autoCompAtts });
      return;
    }
    
    // check is the priovdied string fits on one of the acceptable rate type names
    const allowedTypes = [...TravelCostRateType,...MealCostRateType,...LodgingCostRateType,...workRateType];
    if (!wdpUtil.inListCI(initExpense.type,allowedTypes)) {
      appLog.warn("Invalid rate type:", initExpense.type);
      return;
    }
    
    // we need RateTypes
    const goodOpts: GenListType[] =myAppCtx!.lookups.costRateTypeList?.map((x: any) => ({label: x.Description,value: x.LookupId?.toString()})) ?? [];
    
    // CASE 2: Travel
    if( wdpUtil.inListCI(initExpense.type,TravelCostRateType) ) {
      
      const travelList = initExpense.expenseVals as TravelClaimsExpenses[];
      for (const item of travelList) {
        const csRecVal = { ...costSummaryEmptyObj };
        initCostSummaryRec(csRecVal);
        csRecVal.rateType        = goodOpts.find((e) => wdpUtil.strEqual(e.label,"travel")) ?? null;
        csRecVal.id              = item.id;
        csRecVal.travelStartUtc  = item.startUtc;
        csRecVal.travelFinishUtc = item.finishUtc;
        csRecVal.travelFrom      = item.from;
        csRecVal.travelTo        = item.to;
        csRecVal.noOfUnits       = wdpUtil.formatValFloat(item.noOfUnits);
        
        const newIndex = pushRow(csRecVal);
        rateTypeSideEffect(newIndex,csRecVal.rateType,_formValues,_formTouched,_formTouched); 
      }
    }
    
    // CASE 3: Meals + Lodging
    else if (wdpUtil.inListCI(initExpense.type, MealCostRateType) || wdpUtil.inListCI(initExpense.type, LodgingCostRateType) ) {
      
      const rateTypeObj = goodOpts.find((e) => wdpUtil.strEqual(e.label, initExpense.type)) ?? null;
      const csRecVal    = { ...costSummaryEmptyObj };
      initCostSummaryRec(csRecVal);
      csRecVal.rateType = rateTypeObj;
      const newIndex    = pushRow(csRecVal);
      rateTypeSideEffect(newIndex, csRecVal.rateType, _formValues, _formErrors, _formTouched);
    }

    // -------------------------------------------------
    // ready to Update formCtrl + autocomplete
    // -------------------------------------------------
    updateFormCtrl(_formValues, _formErrors, _formTouched);
    setAutoCompleteCtrl({ input: _autoCompInput, options: _autoCompLists,attrs:_autoCompAtts });
  }
  /******************************************************************************************
   * 
  *******************************************************************************************/
  function onDelCostSummary() {
    if (!canDeleteCostSummary()) {
      appLog.warn("Deleting the selected cost summary rows is not permitted.");
      return;
    }
    let selectedIndexes =  formCtrl.values.costSummary!
      .reduce((acc: number[], item, index) => {
        if (item.selected && !TicketService.isManagedCostSummaryRateType(item.rateType as GenListType | string | null, item.workPerformedType)) {
          acc.push(index);
        }
        return acc;
      }, [])
      .sort((a, b) => b - a); // descending;
    doDelCostSummary(selectedIndexes);
  }

  function onCancelCostSummaryDeleteMode() {
    const _formValues: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.values);
    const _formErrors: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.errors);
    const _formTouched: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.touched);

    _formValues.costSummary = _formValues.costSummary.map((row: CostSummary_ui) => ({
      ...row,
      selected: false,
    }));

    updateFormCtrl(_formValues, _formErrors, _formTouched);
  }

  function doDelCostSummary(selectedIndexes:number[]) {
    // take a copy
    const _formValues: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.values);
    const _formErrors: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.errors);
    const _formTouched:TicketInfo_ui = wdpUtil.deepCopy(formCtrl.touched);

    const valNewArray   = wdpUtil.deepCopy(_formValues.costSummary);
    const errNewArray   = wdpUtil.deepCopy(_formErrors.costSummary);
    const touchNewArray = wdpUtil.deepCopy(_formTouched.costSummary);
    // Loop backward to avoid index shifting issues
    
      for (let i of selectedIndexes) {
      
      valNewArray.splice(i, 1);
      errNewArray.splice(i, 1);
      touchNewArray.splice(i, 1);

    }
    _formValues.costSummary = valNewArray;
    _formErrors.costSummary = errNewArray;
    _formTouched.costSummary = touchNewArray;

    // revalidate ..because deleting a row will effect EffectiveDate field
    //validateResourceTable(_formValues, _formErrors, _formTouched);
    updateFormCtrl(_formValues, _formErrors, _formTouched);

    // autoCompleteCtrl 
    const _autoCompInput: AutoCompleteCtrl_InputValue[] = wdpUtil.deepCopy(autoCompleteCtrl.input);
    const _autoCompLists: AutoCompleteCtrl_Options[]    = wdpUtil.deepCopy(autoCompleteCtrl.options);
    const _autoCompAtts: AutoCompleteCtrl_Attributes[]    = wdpUtil.deepCopy(autoCompleteCtrl.attrs);
    for (let i of selectedIndexes) {
      _autoCompInput.splice(i, 1);
      _autoCompLists.splice(i, 1);
      _autoCompAtts.splice(i, 1);
    }
    
    setAutoCompleteCtrl({input:_autoCompInput,options:_autoCompLists,attrs:_autoCompAtts});
  }

  /********************************************************************************************
  *********************************************************************************************/
  function findRecordinFiresLookups(fromList: FireEquipmentInfo_raw[], who: string, value: string): FireEquipmentInfo_raw | undefined {
    let rec: FireEquipmentInfo_raw | undefined = undefined;

    if (who === "unitNumber") {
      rec = fromList.find((e: FireEquipmentInfo_raw) => wdpUtil.strEqual(e.unitNumber,value));
    }
    if (who === "serialNumber") {
      rec = fromList.find((e: FireEquipmentInfo_raw) => wdpUtil.strEqual(e.serialNumber, value));
    }
    if (who === "equipment") {
      rec = fromList.find((e: FireEquipmentInfo_raw) => wdpUtil.strEqual(e.equipmentId,value));
    }
    if (who === "addOns") {
      //rec = fromList.find((e:FireEquipmentInfo_raw)=> e.addOns === value);
    }
    return rec;
  }
   ////////////////////////////////////////////////////////////////////////////////////////////////
  // Sub Component Interaction
  ////////////////////////////////////////////////////////////////////////////////////////////////
  function applyMealSectionSave(change: MealsClaimsExpenses) {
    const _formValues: TicketInfo_ui  = wdpUtil.deepCopy(formCtrl.values);
    const _formErrors: TicketInfo_ui  = wdpUtil.deepCopy(formCtrl.errors);
    const _formTouched: TicketInfo_ui = wdpUtil.deepCopy(formCtrl.touched);

    const _autoCompInput: AutoCompleteCtrl_InputValue[] = wdpUtil.deepCopy(autoCompleteCtrl.input);
    const _autoCompLists: AutoCompleteCtrl_Options[] = wdpUtil.deepCopy(autoCompleteCtrl.options);
    const _autoCompAtts: AutoCompleteCtrl_Attributes[] = wdpUtil.deepCopy(autoCompleteCtrl.attrs);

    const fieldToRate: Record<keyof MealsClaimsExpenses, string> = {
      breakfast: RateType_CrewExpBreakfast,
      lunch: RateType_CrewExpLunch,
      dinner: RateType_CrewExpDinner,
      lodging: RateType_Accommodation
    };

    const allMealRateTypes = Object.values(fieldToRate);
    const isMealOrLodgingRate = (rateLabel: string) =>
      wdpUtil.inListCI(rateLabel, MealCostRateType) || wdpUtil.inListCI(rateLabel, LodgingCostRateType);

    const removeIndexes = (indexes: number[]) => {
      for (const idx of indexes.sort((a, b) => b - a)) {
        _formValues.costSummary.splice(idx, 1);
        _formErrors.costSummary.splice(idx, 1);
        _formTouched.costSummary.splice(idx, 1);
        _autoCompInput.splice(idx, 1);
        _autoCompLists.splice(idx, 1);
        _autoCompAtts.splice(idx, 1);
      }
    };

    const selectedRateTypes = allMealRateTypes.filter((rateType, index) => {
      const field = Object.keys(fieldToRate)[index] as keyof MealsClaimsExpenses;
      return change[field] === true;
    });

    const selectedSet = new Set(selectedRateTypes.map(r => r.toLowerCase()));
    const existingByRate = new Map<string, number>();
    const indexesToRemoveByUnselect: number[] = [];
    const duplicateIndexes: number[] = [];

    _formValues.costSummary.forEach((item, idx) => {
      const rateLabel = wdpUtil.getFormFieldVal(item.rateType, true);
      if (!isMealOrLodgingRate(rateLabel)) return;

      const key = rateLabel.toLowerCase();
      if (!selectedSet.has(key)) {
        indexesToRemoveByUnselect.push(idx);
        return;
      }

      if (existingByRate.has(key)) {
        duplicateIndexes.push(idx);
      } else {
        existingByRate.set(key, idx);
      }
    });

    removeIndexes([...indexesToRemoveByUnselect, ...duplicateIndexes]);

    const rateTypeOpts: GenListType[] = myAppCtx!.lookups.costRateTypeList?.map((x: any) => ({label: x.Description,value: x.LookupId?.toString()})) ?? [];
    const existingAfterDelete = new Set(
      _formValues.costSummary
        .map(item => wdpUtil.getFormFieldVal(item.rateType, true).toLowerCase())
    );

    for (const rateTypeLabel of selectedRateTypes) {
      const key = rateTypeLabel.toLowerCase();
      if (existingAfterDelete.has(key)) continue;

      const csRecVal = { ...costSummaryEmptyObj };
      initCostSummaryRec(csRecVal);
      csRecVal.rateType = rateTypeOpts.find((e) => wdpUtil.strEqual(e.label, rateTypeLabel)) ?? null;

      _formValues.costSummary.push(csRecVal);
      _formErrors.costSummary.push({ ...costSummaryEmptyObj });
      _formTouched.costSummary.push({ ...costSummaryEmptyObj });
      _autoCompInput.push({ ...autoCompleteInputCtrlEmptyObj });
      _autoCompLists.push({ ...autoCompleteOptionsCtrlEmptyObj });
      _autoCompAtts.push({ ...autoCompleteAttrsCtrlEmptyObj });

      rateTypeSideEffect(_formValues.costSummary.length - 1, csRecVal.rateType, _formValues, _formErrors, _formTouched);
      existingAfterDelete.add(key);
    }

    for (let i = 0; i < _formValues.costSummary.length; i++) {
      const rateTypeLabel = wdpUtil.getFormFieldVal(_formValues.costSummary[i].rateType, true);
      if (
        wdpUtil.includesIgnoreCase(MealCostRateType, rateTypeLabel) ||
        wdpUtil.includesIgnoreCase(LodgingCostRateType, rateTypeLabel)
      ) {
        defaultNoOfUnitsField(i, _formValues, _formErrors, _formTouched);
        reCalcCost(i, _formValues, _formErrors, _formTouched);
      }
    }

    validateCostSummaryTable(_formValues, _formErrors, _formTouched);
    updateFormCtrl(_formValues, _formErrors, _formTouched);
    setAutoCompleteCtrl({ input: _autoCompInput, options: _autoCompLists, attrs: _autoCompAtts });
    setPendingBackendSave(true);
  }
  /***************************************************************************************************
  ****************************************************************************************************/
  function OnMealSecChanged(changeType: string, change: MealsClaimsExpenses | boolean | null) {
    // 1. Dirty notification from section
    // if (changeType === "dirty") {
    //   setSectionDirtyMap(prev => {
    //     const next = change as boolean;
    //     return prev.meal === next ? prev : { ...prev, meal: next };
    //   });
    //   return;
    // }
    // 2. Edit started: close any other active section
    if (changeType === "editStart") {
      if (pageStatus.editModeBySection.basic) onCancelBasicInfo();
      if (pageStatus.editModeBySection.costSummary) onCancelCostSummary();
      setActiveEditSection('meal');
      return;
    }
    // 3. Save: apply a single diff/update pass similar to travel handler
    if (changeType === "save" && change != null) {
      setActiveEditSection(prev => prev === 'meal' ? null : prev);
      applyMealSectionSave(change as MealsClaimsExpenses);
      return;
    }
  }
  /***************************************************************************************************
   
  ***************************************************************************************************/
  function onTravelChanged(changeType:string,change: TravelClaimsExpenses|TravelClaimsExpenses[]|boolean|null) {
    // 1. Dirty notification from section
    // if (changeType === 'dirty') {
    //   setSectionDirtyMap(prev => {
    //     const next = change as boolean;
    //     return prev.travel === next ? prev : { ...prev, travel: next };
    //   });
    //   return;
    // }
    
    // 2. Edit started: close any other active section
    if (changeType === 'editStart') {
      if (pageStatus.editModeBySection.basic) onCancelBasicInfo();
      if (pageStatus.editModeBySection.costSummary) onCancelCostSummary();
      setActiveEditSection('travel');
      return;
    }
    // 3. Save: apply rows to cost summary (may trigger deletion confirmation if needed)
    if(changeType==='save' && change!=null){
      setActiveEditSection(prev => prev === 'travel' ? null : prev);
      const incomingRows: TravelClaimsExpenses[] = Array.isArray(change) ? change : [change as TravelClaimsExpenses];
      applyTravelSectionSave(incomingRows);
    }
  }
  /***************************************************************************************************
  ***************************************************************************************************/  
  function applyWorkSectionSave(incomingRows: WorkClaimsExpenses[]) {

    const _formValues:TicketInfo_ui  = wdpUtil.deepCopy(formCtrl.values);
    const _formErrors:TicketInfo_ui  = wdpUtil.deepCopy(formCtrl.errors);
    const _formTouched:TicketInfo_ui = wdpUtil.deepCopy(formCtrl.touched);

    const _autoCompInput: AutoCompleteCtrl_InputValue[] = wdpUtil.deepCopy(autoCompleteCtrl.input);
    const _autoCompLists: AutoCompleteCtrl_Options[]    = wdpUtil.deepCopy(autoCompleteCtrl.options);
    const _autoCompAtts: AutoCompleteCtrl_Attributes[]  = wdpUtil.deepCopy(autoCompleteCtrl.attrs);


    const getIncomingIdentity = (row: WorkClaimsExpenses, workOrdinal: number): string => {
      const id = row?.id;
      return (!wdpUtil.isNullorUndefined(id) && String(id).trim() !== "") ? String(id) : `__work_idx_${workOrdinal}`;
    };

    const getCostSummaryIdentityMap = (rows: CostSummary_ui[]): Map<string, number> => {
      const map = new Map<string, number>();
      let workOrdinal = 0;
      rows.forEach((item, idx) => {
        const isWork = !wdpUtil.isNullorUndefined(item.workPerformedType);
        if (!isWork) return;

        const id = item.id;
        const identity = (!wdpUtil.isNullorUndefined(id) && String(id).trim() !== "")? String(id): `__work_idx_${workOrdinal}`;

        map.set(identity, idx);
        workOrdinal++;
      });
      return map;
    };

    const incomingIdentities  = new Set(incomingRows.map((r, i) => getIncomingIdentity(r, i)));
    const currentIdentityMap  = getCostSummaryIdentityMap(_formValues.costSummary);
    const staleIndexes        = Array.from(currentIdentityMap.entries()).filter(([identity]) => !incomingIdentities.has(identity)).map(([, idx]) => idx).sort((a, b) => b - a);

    for (const idx of staleIndexes) {
      _formValues.costSummary.splice(idx, 1);
      _formErrors.costSummary.splice(idx, 1);
      _formTouched.costSummary.splice(idx, 1);
      _autoCompInput.splice(idx, 1);
      _autoCompLists.splice(idx, 1);
      _autoCompAtts.splice(idx, 1);
    }

    let identityMapAfterDelete = getCostSummaryIdentityMap(_formValues.costSummary);
    for (let i = 0; i < incomingRows.length; i++) {
      const incoming = incomingRows[i];
      const incomingIdentity = getIncomingIdentity(incoming, i);
      const recIndex = identityMapAfterDelete.has(incomingIdentity) ? identityMapAfterDelete.get(incomingIdentity) as number: -1;

      if (recIndex !== -1) {
        const rec = _formValues.costSummary[recIndex];
        rec.workStartUtc          = incoming?.startUtc;
        rec.workFinishUtc         = incoming?.finishUtc;
        rec.noOfUnits             = wdpUtil.formatValFloat(incoming?.noOfUnits as number);
        rec.workPerformedType     = incoming?.workPerformed ?? null;
        rec.fireNumber            = incoming?.fireNumber ?? null;
        rec.workAssignedToWildfire= incoming?.assignedToWildfire || "";
        rec.workFuelProvidedByGoa = incoming?.fuelProvidedByGoa || "";

        // Costing activity depends on fireNumber (FP vs FS) and rate/unit defaults depend on
        // rate type - both can change here even when rateType itself doesn't (e.g. toggling
        // assignedToWildfire on a "Safety Briefing" combo), so always re-run full defaulting
        // rather than only reCalcCost.
        // WORK_PERFORMED combos always carry an explicit Yes/No for both questions - never blank -
        // so fall back to "no" (not ""), which can never match a real combo.
        const mapResult = mapWorkPerformedToActivityCode(myAppCtx?.lookups?.workPerformedRelationsList ?? [], {
          workPerformedId: (incoming as any)?.workPerformed?.value ?? "",
          assignedToWildfire: incoming?.assignedToWildfire || "no",
          fuelProvidedByGoA: incoming?.fuelProvidedByGoa || "no"
        });
        // lookupId comes back as a number; GenListType.value (and the costingActivityId sent to the API) must be a string.
        // If no combo matched, keep the previously resolved rateType/costActivityCode rather than wiping them to null.
        if (mapResult != null) {
          rec.rateType = {value: mapResult.rateTypeId != null ? mapResult.rateTypeId.toString() : "", label: mapResult.rateType ?? ""};
          rec.costActivityCode = {value: mapResult.activityCodeId ?? "", label: mapResult.activityCode ?? ""};
        }

        // Rate type just (re)computed above - default the unit/rate-per-unit and recalc the cost so
        // they don't stay blank/zero (defaultCostActivityField is skipped since costActivityCode was
        // already resolved from the WORK_PERFORMED combo above).
        defaultUnitField(recIndex, _formValues, _formErrors, _formTouched);
        defaultRatePerUnitField(recIndex, _formValues, _formErrors, _formTouched);
        reCalcCost(recIndex, _formValues, _formErrors, _formTouched);
      } else {
        const csRecVal = { ...costSummaryEmptyObj };
        initCostSummaryRec(csRecVal);
        csRecVal.id                     = incoming.id;
        csRecVal.workStartUtc           = incoming.startUtc;
        csRecVal.workFinishUtc          = incoming.finishUtc;
        csRecVal.noOfUnits              = wdpUtil.formatValFloat(incoming.noOfUnits);
        csRecVal.workPerformedType      = incoming.workPerformed ?? null;
        csRecVal.fireNumber             = incoming.fireNumber ?? null;
        csRecVal.workAssignedToWildfire = incoming.assignedToWildfire || "";
        csRecVal.workFuelProvidedByGoa  = incoming.fuelProvidedByGoa || "";

        _formValues.costSummary.push(csRecVal);
        _formErrors.costSummary.push({ ...costSummaryEmptyObj });
        _formTouched.costSummary.push({ ...costSummaryEmptyObj });
        _autoCompInput.push({ ...autoCompleteInputCtrlEmptyObj });
        _autoCompLists.push({ ...autoCompleteOptionsCtrlEmptyObj });
        _autoCompAtts.push({ ...autoCompleteAttrsCtrlEmptyObj });

        // rateTypeSideEffect(_formValues.costSummary.length - 1, csRecVal.rateType, _formValues, _formErrors, _formTouched);
        // WORK_PERFORMED combos always carry an explicit Yes/No for both questions - never blank -
        // so fall back to "no" (not ""), which can never match a real combo.
        const mapResult = mapWorkPerformedToActivityCode(myAppCtx?.lookups?.workPerformedRelationsList ?? [], {
          workPerformedId: (incoming as any)?.workPerformed?.value ?? "",
          assignedToWildfire: incoming?.assignedToWildfire || "no",
          fuelProvidedByGoA: incoming?.fuelProvidedByGoa || "no"
        });
        // lookupId comes back as a number; GenListType.value (and the costingActivityId sent to the API) must be a string.
        if (mapResult != null) {
          csRecVal.rateType = {value: mapResult.rateTypeId != null ? mapResult.rateTypeId.toString() : "", label: mapResult.rateType ?? ""};
          csRecVal.costActivityCode = {value: mapResult.activityCodeId ?? "", label: mapResult.activityCode ?? ""};
        }
        identityMapAfterDelete = getCostSummaryIdentityMap(_formValues.costSummary);

        // New row - default the unit/rate-per-unit and recalc the cost so they don't stay blank/zero.
        const newRecIndex = _formValues.costSummary.length - 1;
        defaultUnitField(newRecIndex, _formValues, _formErrors, _formTouched);
        defaultRatePerUnitField(newRecIndex, _formValues, _formErrors, _formTouched);
        reCalcCost(newRecIndex, _formValues, _formErrors, _formTouched);
      }
    }

    validateCostSummaryTable(_formValues,_formErrors,_formTouched);
    updateFormCtrl(_formValues,_formErrors,_formTouched);
    setAutoCompleteCtrl({input: _autoCompInput, options: _autoCompLists, attrs: _autoCompAtts});
    setPendingBackendSave(true);
  }
  /***************************************************************************************************
  ***************************************************************************************************/  
  function mapWorkPerformedToActivityCode(relationships: any[],
        { relationshipKey = domianTableRelationshipKeyWorkPerformed, 
          workPerformedId = "", 
          assignedToWildfire = "", 
          fuelProvidedByGoA = "" 
        } = {}) 
      {
        // NOTE: don't require rel.lookupRelationshipKey === relationshipKey - workPerformedRelationsList
        // is already fetched scoped to that one key (see ApiService). Requiring an exact key match here
        // was fragile and silently returned null (wiping costActivityCode) whenever it didn't match.
        const items = (relationships ?? []).flatMap((rel: any) => rel?.lookupRelationshipItems ?? []);
        if (items.length === 0) return null;

        // A combo bundles Work Performed + Assigned To Wildfire + Fuel Provided by GoA + Rate Type +
        // Costing Activity together - all three inputs must match one combo exactly (no partial/
        // fallback matching) to resolve the paired rateType/activityCode; Assigned/Fuel are simple
        // yes-no answers (not domain-table selections), so they're compared by normalized label;
        // everything else is keyed/matched by lookupTypeId/lookupId.
        const toYesNo = (label: string | undefined | null): string => {
          const normalized = String(label || "").trim().toLowerCase();
          return normalized === "yes" ? "yes" : normalized === "no" ? "no" : "";
        };

        const match = items.map((item: any) =>Object.fromEntries(item.itemElements.map((el: any) => [el.lookupTypeId, el])))
            .find(
                (byTypeId:any) =>
                    wdpUtil.strEqual(byTypeId[domianTableLookupIdWorkPerformed]?.lookupId, workPerformedId) &&
                    toYesNo(byTypeId[domianTableLookupIdAssignedToWildfire]?.lookupLabel) === toYesNo(assignedToWildfire) &&
                    toYesNo(byTypeId[domianTableLookupIdFuelProvidedByGoa]?.lookupLabel) === toYesNo(fuelProvidedByGoA)
            );
        if (!match) return null;

        const workPerformedEl = match[domianTableLookupIdWorkPerformed];
        const assignedEl      = match[domianTableLookupIdAssignedToWildfire];
        const fuelEl          = match[domianTableLookupIdFuelProvidedByGoa];
        const rateTypeEl      = match[domianTableLookupIdCostRateType];

        // WORK_PERFORMED combos carry the resolved activity code directly as a flat `activityCode`
        // string on the Work Performed element itself - there is no separate Costing Activity
        // (lookupTypeId 18) element in this relationship. Cross-reference that code against the
        // generic Costing Activity domain table (same rateTypeId pairing used by
        // TicketService.getCostActivity4RateTypeId for non-work rows) to resolve the real
        // costingActivityId/label the backend expects.
        const rawActivityCode = workPerformedEl?.activityCode ?? null;
        let activityCodeId: string | null = null;
        let activityCodeLabel: string | null = rawActivityCode;
        if (rawActivityCode) {
          const genericItemElements = (myAppCtx?.lookups?.genericRelationsList ?? []).map((e: any) => e.itemElements);
          const withRateType = genericItemElements?.filter((e: any[]) => e.find((n: any) => wdpUtil.strEqual(n.lookupTypeId, domianTableLookupIdCostRateType) && wdpUtil.strEqual(n.lookupId, rateTypeEl?.lookupId)));
          const matchedActivityEl = withRateType
            ?.flatMap((e: any[]) => e.filter((n: any) => wdpUtil.strEqual(n.lookupTypeId, domianTableLookupIdCostingActivity)))
            ?.find((n: any) => wdpUtil.strEqual(n.code, rawActivityCode));
          if (matchedActivityEl) {
            activityCodeId = matchedActivityEl.lookupId?.toString() ?? null;
            activityCodeLabel = `${matchedActivityEl.code} - ${matchedActivityEl.lookupLabel}`;
          }
        }

        return {
            relationshipKey,
            workPerformed: workPerformedEl?.lookupLabel ?? null,
            workPerformedId: workPerformedEl?.lookupId ?? null,
            assignedToWildfire: assignedEl?.lookupLabel ?? null,
            fuelProvidedByGoA: fuelEl?.lookupLabel ?? null,
            rateType: rateTypeEl?.lookupLabel ?? null,
            rateTypeId: rateTypeEl?.lookupId ?? null,
            activityCode: activityCodeLabel,
            activityCodeId: activityCodeId,
        };
    }
  /***************************************************************************************************
   
  ***************************************************************************************************/
  function onWorkChanged(changeType:string,change: WorkClaimsExpenses|WorkClaimsExpenses[]|boolean|null) {
    // 2. Edit started: close any other active section
    if (changeType === 'editStart') {
      if (pageStatus.editModeBySection.basic) onCancelBasicInfo();
      if (pageStatus.editModeBySection.costSummary) onCancelCostSummary();
      setActiveEditSection('work');
      return;
    }
    // 3. Save: apply rows to cost summary (may trigger deletion confirmation if needed)
    if(changeType==='save' && change!=null){
      setActiveEditSection(prev => prev === 'work' ? null : prev);
      const incomingRows: WorkClaimsExpenses[] = Array.isArray(change) ? change : [change as WorkClaimsExpenses];
      applyWorkSectionSave(incomingRows);
    }
  }
  /***************************************************************************************************
   
  ***************************************************************************************************/
  function onNotesChanged(changeType: string, change: string[] | boolean | null) {
    
    // if (changeType === 'dirty') {
    //   setSectionDirtyMap(prev => {
    //     const next = change as boolean;
    //     return prev.notes === next ? prev : { ...prev, notes: next };
    //   });
    //   return;
    // }

    if (changeType === 'editStart') {
      if (pageStatus.editModeBySection.basic) onCancelBasicInfo();
      if (pageStatus.editModeBySection.costSummary) onCancelCostSummary();
      setActiveEditSection('notes');
      return;
    }

    if (changeType === 'save' && Array.isArray(change) && change.length > 0) {
      if (isBusyRef.current) return;
      setActiveEditSection(prev => prev === 'notes' ? null : prev);
      if (!isNewTicket()) {
        // Use the real persisted ticket id (formCtrl.values.id) rather than the route's
        // ticketId param, which is undefined when the ticket was opened via the
        // /ticket/:digitalId route - using the route param here caused notes saves to
        // silently fail (or target the wrong ticket) on that route.
        const targetTicketId = getMyTicketId();
        setIsBusy(true);
        applyNotesSectionSave(targetTicketId, change)
          .then(() => {
            // Refresh notes from the backend so formCtrl.values.notes gets the real
            // NoteItem[] shape (id/createdAtUtc/createdByDisplayName/etc). Previously this
            // overwrote formCtrl.values.notes with the raw string[] that was just saved,
            // which broke the notes list rendering until the next full page reload.
            loadTicketNotes(targetTicketId);
            handleToast("Notes successfully saved.", "success");
          })
          .catch((error) => {
            handleServerError(error, 'Failed to save notes');
          })
          .finally(() => setIsBusy(false));
      }
    }
  }
  /***************************************************************************************************
   * 
   * @param incomingRows 
   * @param forceDelete 
   * @returns 
  ****************************************************************************************************/
  function applyTravelSectionSave(incomingRows: TravelClaimsExpenses[]) {

    const _formValues:TicketInfo_ui  = wdpUtil.deepCopy(formCtrl.values);
    const _formErrors:TicketInfo_ui  = wdpUtil.deepCopy(formCtrl.errors);
    const _formTouched:TicketInfo_ui = wdpUtil.deepCopy(formCtrl.touched);

    const _autoCompInput: AutoCompleteCtrl_InputValue[] = wdpUtil.deepCopy(autoCompleteCtrl.input);
    const _autoCompLists: AutoCompleteCtrl_Options[]    = wdpUtil.deepCopy(autoCompleteCtrl.options);
    const _autoCompAtts: AutoCompleteCtrl_Attributes[]  = wdpUtil.deepCopy(autoCompleteCtrl.attrs);


    const rateTypeOpts: GenListType[] = myAppCtx!.lookups.costRateTypeList?.map((x: any) => ({label: x.Description,value: x.LookupId?.toString()})) ?? [];
    const travelRateType = rateTypeOpts.find((e: GenListType) => wdpUtil.strEqual(e.label, "travel")) ?? null;

    const getIncomingIdentity = (row: TravelClaimsExpenses, travelOrdinal: number): string => {
      const id = row?.id;
      return (!wdpUtil.isNullorUndefined(id) && String(id).trim() !== "") ? String(id) : `__travel_idx_${travelOrdinal}`;
    };

    const getCostSummaryIdentityMap = (rows: CostSummary_ui[]): Map<string, number> => {
      const map = new Map<string, number>();
      let travelOrdinal = 0;
      rows.forEach((item, idx) => {
        const isTravel = wdpUtil.strEqual(wdpUtil.getFormFieldVal(item.rateType, true), "travel");
        if (!isTravel) return;

        const id = item.id;
        const identity = (!wdpUtil.isNullorUndefined(id) && String(id).trim() !== "")? String(id): `__travel_idx_${travelOrdinal}`;

        map.set(identity, idx);
        travelOrdinal++;
      });
      return map;
    };

    const incomingIdentities  = new Set(incomingRows.map((r, i) => getIncomingIdentity(r, i)));
    const currentIdentityMap  = getCostSummaryIdentityMap(_formValues.costSummary);
    const staleIndexes        = Array.from(currentIdentityMap.entries()).filter(([identity]) => !incomingIdentities.has(identity)).map(([, idx]) => idx).sort((a, b) => b - a);

    for (const idx of staleIndexes) {
      _formValues.costSummary.splice(idx, 1);
      _formErrors.costSummary.splice(idx, 1);
      _formTouched.costSummary.splice(idx, 1);
      _autoCompInput.splice(idx, 1);
      _autoCompLists.splice(idx, 1);
      _autoCompAtts.splice(idx, 1);
    }

    let identityMapAfterDelete = getCostSummaryIdentityMap(_formValues.costSummary);
    for (let i = 0; i < incomingRows.length; i++) {
      const incoming = incomingRows[i];
      const incomingIdentity = getIncomingIdentity(incoming, i);
      const recIndex = identityMapAfterDelete.has(incomingIdentity) ? identityMapAfterDelete.get(incomingIdentity) as number: -1;

      if (recIndex !== -1) {
        const rec = _formValues.costSummary[recIndex];
        rec.travelFrom      = incoming?.from;
        rec.travelTo        = incoming?.to;
        rec.travelStartUtc  = incoming?.startUtc;
        rec.travelFinishUtc = incoming?.finishUtc;
        rec.noOfUnits       = wdpUtil.formatValFloat(incoming?.noOfUnits as number);

        reCalcCost(recIndex,_formValues,_formErrors,_formTouched)
      } else {
        const csRecVal = { ...costSummaryEmptyObj };
        initCostSummaryRec(csRecVal);
        csRecVal.rateType        = travelRateType;
        csRecVal.id              = incoming.id;
        csRecVal.travelStartUtc  = incoming.startUtc;
        csRecVal.travelFinishUtc = incoming.finishUtc;
        csRecVal.travelFrom      = incoming.from;
        csRecVal.travelTo        = incoming.to;
        csRecVal.noOfUnits       = wdpUtil.formatValFloat(incoming.noOfUnits);

        _formValues.costSummary.push(csRecVal);
        _formErrors.costSummary.push({ ...costSummaryEmptyObj });
        _formTouched.costSummary.push({ ...costSummaryEmptyObj });
        _autoCompInput.push({ ...autoCompleteInputCtrlEmptyObj });
        _autoCompLists.push({ ...autoCompleteOptionsCtrlEmptyObj });
        _autoCompAtts.push({ ...autoCompleteAttrsCtrlEmptyObj });

        rateTypeSideEffect(_formValues.costSummary.length - 1, csRecVal.rateType, _formValues, _formErrors, _formTouched);
        identityMapAfterDelete = getCostSummaryIdentityMap(_formValues.costSummary);
      }
    }

    validateCostSummaryTable(_formValues,_formErrors,_formTouched);
    updateFormCtrl(_formValues,_formErrors,_formTouched);
    setAutoCompleteCtrl({input: _autoCompInput, options: _autoCompLists, attrs: _autoCompAtts});
    setPendingBackendSave(true);
  }
  
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Main 
  ////////////////////////////////////////////////////////////////////////////////////////////////
  /**
   * Name of the modal-like blocking flow currently active (e.g. "return"), or "" when none.
   * Add new flow names here as more blocking interactions are introduced - most call sites only
   * need `isModalMode !== ''` to block themselves while ANY flow is active; flow-specific
   * exceptions (like the drawer's own close button) can check the name directly.
   */
  function getActiveModalFlowName(): string {
    if (notesDrawerOpen && notesDrawerMode === 'return') return 'return';
    return '';
  }
  const isModalMode = getActiveModalFlowName();
  /**
   * Single place deciding whether an action/edit/save button should be enabled: never while an
   * API call is in flight or a modal flow (see isModalMode) is active, plus whatever extra
   * condition that particular button also requires (dirty/valid/etc, defaults to true).
   */
  function canEnableButton(extraCondition: boolean = true): boolean {
    return extraCondition && !isBusyRef.current && isModalMode === '';
  }
  return (
    <>
      {/* {JSON.stringify(myAppCtx)} */}
      {progressMsg !== "" &&
        <div className="spinner">
          <GoabCircularProgress variant="fullscreen" size="large" message={progressMsg} visible={true} />
        </div>
      }
      {/* Keep the form mounted (preserving accordion/edit state) underneath the blocking spinner
          when reloading the SAME ticket that's already displayed - only hide it for a genuinely
          fresh/different-ticket load, where there's no valid data to show under the overlay yet. */}
      {appError === "" && (progressMsg === "" || (lastLoadedIdentifierRef.current && lastLoadedIdentifierRef.current === (digitalId || ticketId))) &&
        <div className="ticket-page">
          <div className="ticket-page-main">
          <section className="row ticket-page-header">
            <div className="ticket-name">
              <h3 data-test-id="inc-details-page-newInc" style={{ margin: 0 }}>{isNewTicket() ? "New equipment time ticket" : `Time Ticket# ${formCtrl.values.ticketNumber}`}</h3>
              {pageStatus.updateFlow && <div className='flexStart' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {/* <GoabFormItem mb='0' label='Status'>
                  <GoabBadge type={(  wdpUtil.includesIgnoreCase( formCtrl.values?.status,"Progress")) ? "important":"information"} content={formCtrl.values?.status}></GoabBadge>
                </GoabFormItem> */}
                <div>
                  <div className='status-label'>Status</div>
                  <GoabBadge type={(  wdpUtil.includesIgnoreCase( formCtrl.values?.status,"Progress")) ? "important":"information"} content={formCtrl.values?.status}></GoabBadge>
                </div>
                {/* Flag Icon */}
                {!isNewTicket() && (
                  <div style={{ marginLeft: '16px', cursor: !canEnableButton() ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', color: '#0070C4', opacity: !canEnableButton() ? 0.5 : 1 }} onClick={() => { if (canEnableButton()) onToggleFlag(); }} title={formCtrl.values.isFlagged ? "Remove flag" : "Flag for review"}>
                    <GoabIcon type={formCtrl.values.isFlagged ? "flag-filled" : "flag"} opacity={1}></GoabIcon>
                  </div>
                )}
              </div>
              }
            </div>
            <div className='ticket-actions'>
              {canShowButton(ticketPermissions, 'delete')    && pageStatus.updateFlow && activeEditSection === null && !isBusyRef.current && <GoabButton type='text' size='compact' disabled={!canEnableButton()} onClick={onTicketDeleteStart}>Delete</GoabButton>}
              {canShowButton(ticketPermissions, 'submit')   && pageStatus.updateFlow && activeEditSection === null && !isBusyRef.current && <GoabButton type='primary' size='compact' disabled={!canEnableButton()} onClick={onTicketSubmit}>Submit</GoabButton>}
              {canShowButton(ticketPermissions, 'verify')   && pageStatus.updateFlow && activeEditSection === null && !isBusyRef.current && <GoabButton type='primary' size='compact' disabled={!canEnableButton()} onClick={onTicketVerify}>Verify</GoabButton>}
              {canShowButton(ticketPermissions, 'return')   && pageStatus.updateFlow && activeEditSection === null && !isBusyRef.current && formCtrl.values.isReturnable && <GoabButton type='primary' size='compact' disabled={!canEnableButton()} onClick={onTicketReturnStart}>Return</GoabButton>}
              {canShowButton(ticketPermissions, 'signOff')   && pageStatus.updateFlow && activeEditSection === null && !isBusyRef.current && <GoabButton type='primary' size='compact' disabled={!canEnableButton()} onClick={onTicketSignOff}>Sign off</GoabButton>}
              {canShowButton(ticketPermissions, 'unsignOff') && pageStatus.updateFlow && activeEditSection === null && !isBusyRef.current && <GoabButton type='primary' size='compact' disabled={!canEnableButton()} onClick={onTicketUnsignOff}>Unsign off</GoabButton>}
              {canShowButton(ticketPermissions, 'approve')   && pageStatus.updateFlow && activeEditSection === null && !isBusyRef.current && <GoabButton type='primary' size='compact' disabled={!canEnableButton()} onClick={onTicketApprove}>Approve</GoabButton>}
              {canShowButton(ticketPermissions, 'unapprove') && pageStatus.updateFlow && activeEditSection === null && !isBusyRef.current && <GoabButton type='primary' size='compact' disabled={!canEnableButton()} onClick={onTicketUnapprove}>UnApprove</GoabButton>}
              {canShowButton(ticketPermissions, 'downloadPdf') && activeEditSection === null && !isBusyRef.current && <GoabButton type='secondary' size='compact' trailingIcon='download' disabled={!canEnableButton()} onClick={onDownloadTicketPdf}>Download PDF</GoabButton>}
              {ticketPermissions?.viewNotes === true && <GoabButton testId="btn-open-notes" type='secondary' size='compact' disabled={!canEnableButton()} onClick={() => { setNotesDrawerMode('notes'); setNotesDrawerOpen(true); }}>{`Notes (${formCtrl.values.notes?.length ?? 0})`}</GoabButton>}
            </div>
          </section>
          <section className="row mbm">
            <GoabButton type='text' size='compact' disabled={!canEnableButton()} onClick={onShowAllSections}>{`${allAccordionOpen.basic && allAccordionOpen.costSummary?"Close all selections":"Show all selections"}`}</GoabButton>
          </section>
          <section className="ticket-page-content">
            <form ref={formContainerRef} noValidate autoComplete="off" onSubmit={onSave}>
              {/********** Basic Info Section ************/}
              {(ticketPermissions?.viewTicket === true) && (
              <GoabAccordion open={allAccordionOpen.basic} testId="accordion-basic" headingSize="small" heading='Basic information' secondaryText="" >
                <section className='acc-sec basic-info-sec'>
                  <div className="basic-header-actions">
                    {pageStatus.updateFlow ? ( <>
                        {canShowButton(ticketPermissions, 'edit', 'basic') && !pageStatus.editModeBySection.basic && (<GoabButton type='text' size='compact' disabled={!canEnableButton()} onClick={onEditBasicInfo}>Edit</GoabButton>)}
                        {pageStatus.editModeBySection.basic && (<>
                            <GoabButton type='text' size='compact'  onClick={onCancelBasicInfo}>Cancel</GoabButton>
                            <GoabButton type='secondary' size='compact' onClick={onSaveBasicInfo} disabled={!canEnableButton(isBasicSectionDirty() && isBasicInfoValid())}>Save</GoabButton>
                          </>
                        )}
                      </>
                    ):(
                      <>
                        <GoabButton type='text' size='compact'  onClick={onCancelTicket}  disabled={false}>Cancel</GoabButton>
                        <GoabButton type='secondary' size='compact' onClick={onCreateTicket}  disabled={!isBasicSectionDirty() || !isBasicInfoValid() || isBusyRef.current}>Create</GoabButton>
                      </>
                    )
                  }
                  </div>
                  <div className='rowG g4'>
                    {renderField("ticketNumber", "FP167 number", "Enter 8 characters in the format of E####### (E followed by 7 numeric digits)")}
                    {renderField("date", "Date", "", "")}
                    {renderField("contractNumber", "Contract number", "",/*"Enter 8 characters in the format of YYXFD###"*/)}
                    {renderField("contractorName", "Contractor name", "")}

                  </div>
                  <div className='rowG g4'>
                    {/* {renderField("fireNo", "Fire number", "Enter 10 characters in the format of XWF###-YYYY")} */}
                    {renderField("forestAreaId", "Forest area", "")}
                    {renderField("fieldSupervisor", "Field supervisor", "")}
                    {renderField("standbyBase", "Standby base", "")}
                  </div>
                  <div className='rowG g4'>
                    {renderField("unitNumber", "Unit number", "")}
                    {renderField("serialNumber", "Serial number", "")}
                    {renderField("equipment", "Equipment type and sub-type", "")}
                    {renderField("addOns", "Add-ons", "")}
                  </div>

                </section>
              </GoabAccordion>
              )}
               {/********** Meal  ************/}
              {(ticketPermissions?.viewTicket === true) && (
              <GoabAccordion open={allAccordionOpen.meal} testId="accordion-meal" headingSize="small" heading='Meals and lodging' secondaryText="" >
                <MealInfo 
                  updateFlow={pageStatus.updateFlow}
                  canShowEdit={canShowButton(ticketPermissions, 'edit', 'meal')}
                  mealsCanClaim={mealsCanClaim}
                  activeSection={activeEditSection}
                  isBusy={!canEnableButton()}
                  onChange={OnMealSecChanged}
                />
              </GoabAccordion>
              )}
              
              {/********** Travel time details  ************/}
              {(ticketPermissions?.viewTicket === true) && (
              <GoabAccordion open={allAccordionOpen.travel} testId="accordion-travel" headingSize="small" heading='Pre-approved operator travel' secondaryText="" >
                <TravelInfo 
                  updateFlow={pageStatus.updateFlow}
                  canShowEdit={canShowButton(ticketPermissions, 'edit', 'travel')}
                  referenceDate={formCtrl.values.date}
                  values={travelEntries}
                  activeSection={activeEditSection}
                  isBusy={!canEnableButton()}
                  onChange={onTravelChanged}
                />
              </GoabAccordion>
              )}
              {/********** Work performed  ************/}
              {(ticketPermissions?.viewTicket === true) && (
              <GoabAccordion open={allAccordionOpen.work} testId="accordion-work" headingSize="small" heading='Work performed' secondaryText="" >
                <WorkInfo 
                  updateFlow={pageStatus.updateFlow}
                  canShowEdit={canShowButton(ticketPermissions, 'edit', 'work')}
                  referenceDate={formCtrl.values.date}
                  values={workPerformedEntries}
                  // relationships={workPerformedRelationships}
                  activeSection={activeEditSection}
                  isBusy={!canEnableButton()}
                  onChange={onWorkChanged}
                />
              </GoabAccordion>
              )}
              {/********** Cost Summary Section ************/}
              {(ticketPermissions?.viewCostSummary === true) && (
              <section className="cost-summary-sec">
                <GoabAccordion open={allAccordionOpen.costSummary} testId="accordion-costSummary" headingSize="small" heading='Cost summary' secondaryText=""  >
                  <section className='acc-sec'>
                    
                    <div className="cost-summary-header-actions">
                      {pageStatus.updateFlow && (
                        <>
                          {canShowButton(ticketPermissions, 'edit', 'costSummary') && !pageStatus.editModeBySection.costSummary && (<GoabButton type='text' size='compact' disabled={!canEnableButton()} onClick={onEditCostSummary}>Edit</GoabButton>)}
                          {pageStatus.editModeBySection.costSummary && (<>
                              <GoabButton type='text' size='compact' onClick={onCancelCostSummary}>Cancel</GoabButton>
                              <GoabButton type='secondary' size='compact' onClick={onSaveCostSummary} disabled={!canEnableButton(canSaveCostSummary() && !(formCtrl.values.costSummary?.some((e: CostSummary_ui) => e.selected) ?? false))}>Save</GoabButton>
                            </>
                          )}
                        </>
                      )}
                    </div>
                    {pageStatus.editModeBySection.costSummary && formCtrl.values.costSummary != null && formCtrl.values.costSummary.filter((e: CostSummary_ui) => e.selected)?.length > 0 && (
                      <div className="cost-summary-delete-mode">
                        <span>{`${formCtrl.values.costSummary.filter((e: CostSummary_ui) => e.selected).length} selected`}</span>
                        <div className="delete-mode-actions">
                          <GoabButton                       type='secondary' size='compact' testId='cost-summary-cancel'  onClick={onCancelCostSummaryDeleteMode}>Cancel</GoabButton>
                          <GoabButton trailingIcon="trash"  type='secondary' size='compact' testId='cost-summary-del'     onClick={() => setShowDeleteCostSummaryModal(true)} disabled={!canDeleteCostSummary()}>Delete</GoabButton>
                        </div>
                      </div>
                    )}

                    <div className="rowG colSpan13 cost-summary-table">
                      
                        <GoabTable width="100%" mb="xl">
                          <thead>
                            <tr>
                              <th className="col-select"><span> </span></th>
                              <th className="col-fireNumber"><span>Fire number</span></th>
                              <th className="col-rateType"><span>Rate type</span></th>
                              <th className="col-activityCode"><span>Activity code</span></th>
                              <th className="col-units"><span>No. of units</span></th>
                              <th className="col-unit"><span>Unit</span></th>
                              <th className="col-ratePerUnit"><span>Rate Per unit</span></th>
                              <th className="col-cost"><span>Cost</span></th>
                              <th className="col-internalOrder"><span>Internal order</span></th>
                              <th className="col-costCenter"><span>Cost center</span></th>
                              <th className="col-fund"><span>Fund</span></th>
                              <th className="col-account"><span>Account</span></th>
                              <th className="col-invoiceNo"><span>Invoice no</span></th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              renderField("costSummary", "")
                            }
                          </tbody>
                        </GoabTable>
                      
                      
                    </div>
                    <div className="rowG add-new">
                        {pageStatus.updateFlow && pageStatus.editModeBySection.costSummary && <GoabButton type='secondary' size='compact' disabled={!canAddCostSummary()} onClick={() => onAddNewCostSummary()}>Add new+</GoabButton>}
                    </div>
                  </section>
                </GoabAccordion>
              </section>
              )}

            </form>
          </section>
          {notesDrawerOpen && (
          <section className="ticket-page-notes">
              <div className="notes-drawer" data-testid={notesDrawerMode === 'return' ? 'drawer-return' : 'drawer-notes'}>
                <div className="notes-drawer-header">
                  <h4 className="notes-drawer-title">{notesDrawerMode === 'return' ? 'Return' : 'Notes'}</h4>
                  {/* Disabled (not hidden) while returning a ticket - the user must explicitly click
                      Continue or Cancel below instead of dismissing the note via the X. */}
                  <GoabIconButton testId="drawer-close-button" icon="close" variant="dark" size="medium" disabled={isModalMode === 'return'} ariaLabel="Close the drawer" onClick={() => setNotesDrawerOpen(false)} />
                </div>
                {notesDrawerMode === 'return' ? (
                  <div className="notes-drawer-body">
                    <GoabFormItem label="Revision note" requirement={'required' as GoabFormItemRequirement}>
                      <textarea
                        data-testid="tic_returnNote"
                        style={{ width: '100%' }}
                        rows={4}
                        value={returnTicketNote}
                        onChange={(e) => setReturnTicketNote(e.target.value)}
                        placeholder="A reason for revision is required"
                      />
                    </GoabFormItem>
                    <GoabCheckbox name="returnShareWithOperatorVendor" text="Share with operator & vendor" checked={returnShareWithOperatorVendor}
                      onChange={(details: GoabCheckboxOnChangeDetail) => setReturnShareWithOperatorVendor(details.checked)} />
                  </div>
                ) : ticketPermissions?.viewNotes === true && (
                <div className="notes-drawer-body">
                  <Notes
                    updateFlow={pageStatus.updateFlow}
                    canShowEdit={pageStatus.updateFlow && canShowButton(ticketPermissions, 'addNote')}
                    maxLength={1200}
                    notes={formCtrl.values.notes ?? []}
                    isLoading={isTicketNotesLoading}
                    isError={isTicketNotesError}
                    activeSection={activeEditSection}
                    isBusy={isBusyRef.current}
                    onChange={onNotesChanged}
                  />
                </div>
                )}
                {notesDrawerMode === 'return' && (
                  <div className="notes-drawer-actions">
                    <GoabButtonGroup alignment="end">
                      <GoabButton testId='ud-return-ticket-modal-no' type='secondary' size='compact' onClick={() => setNotesDrawerOpen(false)}>Cancel</GoabButton>
                      <GoabButton testId='ud-return-ticket-modal-yes' type='primary' size='compact' disabled={returnTicketNote.trim() === '' || isBusyRef.current} onClick={() => { setNotesDrawerOpen(false); onTicketReturn(); }}>Continue</GoabButton>
                    </GoabButtonGroup>
                  </div>
                )}
              </div>
          </section>
          )}
          </div>
          

          
          {/* {!pageStatus.updateFlow && ( <section className="row ticket-page-footer">
              <GoabButton width='120px' type='text'  disabled={!canCancelCreateFlow()} onClick={() => { onTicketCancel() }}>Cancel</GoabButton>
              <div>
                <GoabSpacer hSpacing="m"></GoabSpacer>
                <GoabButton width='120px' type='primary' disabled={!canSave() || isBusyRef.current} onClick={() => { onSave() }}>Save</GoabButton>
              </div>
            </section>
          )} */}




          {/* // ################################################ */}
          {/* // ###################  Modals  ################### */}
          {/* // ################################################ */}
          {/* Delete a record popup confirmation */}
          <GoabModal heading={`Confirmation: Delete cost summary row`} calloutVariant='emergency' open={showDeleteCostSummaryModal === true} maxWidth="30vw"
            actions={
              <GoabButtonGroup alignment="end">
                <GoabButton testId='ud-delete-rec-modal-no' type='secondary' size='compact' onClick={() => { setShowDeleteCostSummaryModal(false); }}>No, cancel</GoabButton>
                <GoabButton testId='ud-delete-rec-modal-yes' type='primary' size='compact' disabled={!canDeleteCostSummary()} onClick={() => { setShowDeleteCostSummaryModal(false); onDelCostSummary() }}>Yes, delete</GoabButton>
              </GoabButtonGroup>
            }
          ><p>Do you want to continue with deleting the row?</p>
          </GoabModal>
          {/* Delete ticket confirmation */}
          <GoabModal heading={`Confirmation: Delete ticket`} calloutVariant='emergency' open={showDeleteTicketModal === true} maxWidth="30vw"
            actions={
              <GoabButtonGroup alignment="end">
                <GoabButton testId='ud-delete-ticket-modal-no' type='secondary' size='compact' onClick={() => { setShowDeleteTicketModal(false); }}>No, return</GoabButton>
                <GoabButton testId='ud-delete-ticket-modal-yes' type='primary' size='compact' disabled={isBusyRef.current} onClick={() => { setShowDeleteTicketModal(false); onTicketDelete() }}>Yes, delete</GoabButton>
              </GoabButtonGroup>
            }
          ><p>Are you sure you want to delete this ticket?<br/>This action cannot be undone.</p>
          </GoabModal>
          {/* Delete ticket warning */}
          <GoabModal heading={`Warning: Delete ticket`} calloutVariant='important' open={showDeleteTicketWarningModal === true} maxWidth="30vw"
            actions={
              <GoabButtonGroup alignment="end">
                <GoabButton testId='ud-ticket-warning-modal-okay' type='primary' size='compact' onClick={() => { setShowDeleteTicketWarningModal(false); }}>Okay</GoabButton>
              </GoabButtonGroup>
            }
          ><p>
              {getDeleteWarningMsg().map((msg, index) => (
                <Fragment key={index}>{index > 0 && <br/>}{msg}</Fragment>
              ))}
            </p>
          </GoabModal>
          {/* Changing Serial Number confirmation */}
          <GoabModal heading={`Confirmation: Change serial number`} calloutVariant='emergency' open={showChangeEquipWarningModal != null} maxWidth="30vw"
            actions={
              <GoabButtonGroup alignment="end">
                <GoabButton testId='ud-change_serial-modal-no' type='secondary' size='compact' onClick={() => { setShowChangeEquipWarningModal(null); }}>No, cancel</GoabButton>
                <GoabButton testId='ud-change_serial-modal-yes' type='primary' size='compact' onClick={() => { onConfirmChangeEqu(showChangeEquipWarningModal) }}>Yes, change</GoabButton>
              </GoabButtonGroup>
            }
          ><p>If serial number will be changed, all cost detail records will be deleted.  Are you sure you want to change it?</p>
          </GoabModal>
          
          {/* FP167 Number Duplicate confirmation */}
          <GoabModal  heading="Warning: FP167 number duplicate" open={showDuplicateTicketWarningModal} maxWidth="30vw" calloutVariant="important"
            actions={
              <GoabButtonGroup alignment="end">
                <GoabButton testId='ud-duplicate-ticket-modal-yes' type='primary' size='compact' onClick={() => { setShowDuplicateTicketWarningModal(false) }}>Okay</GoabButton>
              </GoabButtonGroup>}
          >
            <p>A ticket with this FP167 number already exists. Continue editing the ticket.</p>
          </GoabModal>
          
        </div> 
      }
    </>
  );
}
